var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudServerDataSecurityLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    enableBackground: "new 0 0 2196.21 2198.14",
    viewBox: "0 0 2196.21 2198.14",
    id: "Cloudserverdatasecuritylock",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.34,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1078.73,
    cy: 1812.27,
    fill: "#142223",
    rx: 175.72,
    ry: 457.53,
    transform: "rotate(-89.049 1078.679 1812.2)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.012,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1079.4,
    cy: 1811.96,
    fill: "#142223",
    rx: 173.98,
    ry: 452.99,
    transform: "rotate(-89.049 1079.35 1811.888)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.025,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1080.08,
    cy: 1811.65,
    fill: "#142223",
    rx: 172.23,
    ry: 448.45,
    transform: "rotate(-89.049 1080.022 1811.575)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.037,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1080.75,
    cy: 1811.33,
    fill: "#142223",
    rx: 170.49,
    ry: 443.91,
    transform: "rotate(-89.049 1080.694 1811.262)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.049,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1081.42,
    cy: 1811.02,
    fill: "#142223",
    rx: 168.74,
    ry: 439.37,
    transform: "rotate(-89.049 1081.365 1810.949)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.062,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1082.09,
    cy: 1810.71,
    fill: "#142223",
    rx: 167,
    ry: 434.83,
    transform: "rotate(-89.049 1082.037 1810.636)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.074,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1082.76,
    cy: 1810.39,
    fill: "#142223",
    rx: 165.26,
    ry: 430.28,
    transform: "rotate(-89.049 1082.709 1810.323)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.086,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1083.43,
    cy: 1810.08,
    fill: "#142223",
    rx: 163.51,
    ry: 425.74,
    transform: "rotate(-89.049 1083.38 1810.01)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.099,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1084.11,
    cy: 1809.77,
    fill: "#142223",
    rx: 161.77,
    ry: 421.2,
    transform: "rotate(-89.049 1084.052 1809.697)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.111,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1084.78,
    cy: 1809.46,
    fill: "#142223",
    rx: 160.02,
    ry: 416.66,
    transform: "rotate(-89.049 1084.724 1809.384)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.123,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1085.45,
    cy: 1809.14,
    fill: "#142223",
    rx: 158.28,
    ry: 412.12,
    transform: "rotate(-89.049 1085.396 1809.07)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.136,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1086.12,
    cy: 1808.83,
    fill: "#142223",
    rx: 156.54,
    ry: 407.58,
    transform: "rotate(-89.049 1086.067 1808.758)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.148,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1086.79,
    cy: 1808.52,
    fill: "#142223",
    rx: 154.79,
    ry: 403.04,
    transform: "rotate(-89.049 1086.739 1808.445)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.161,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1087.46,
    cy: 1808.2,
    fill: "#142223",
    rx: 153.05,
    ry: 398.5,
    transform: "rotate(-89.049 1087.41 1808.132)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.173,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1088.14,
    cy: 1807.89,
    fill: "#142223",
    rx: 151.3,
    ry: 393.95,
    transform: "rotate(-89.049 1088.082 1807.819)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.185,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1088.81,
    cy: 1807.58,
    fill: "#142223",
    rx: 149.56,
    ry: 389.41,
    transform: "rotate(-89.049 1088.754 1807.506)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.198,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1089.48,
    cy: 1807.26,
    fill: "#142223",
    rx: 147.82,
    ry: 384.87,
    transform: "rotate(-89.049 1089.426 1807.193)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.21,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1090.15,
    cy: 1806.95,
    fill: "#142223",
    rx: 146.07,
    ry: 380.33,
    transform: "rotate(-89.049 1090.097 1806.88)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.222,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1090.82,
    cy: 1806.64,
    fill: "#142223",
    rx: 144.33,
    ry: 375.79,
    transform: "rotate(-89.049 1090.77 1806.567)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.235,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1091.49,
    cy: 1806.33,
    fill: "#142223",
    rx: 142.58,
    ry: 371.25,
    transform: "rotate(-89.049 1091.44 1806.254)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.247,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1092.17,
    cy: 1806.01,
    fill: "#142223",
    rx: 140.84,
    ry: 366.71,
    transform: "rotate(-89.049 1092.112 1805.94)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.259,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1092.84,
    cy: 1805.7,
    fill: "#142223",
    rx: 139.09,
    ry: 362.17,
    transform: "rotate(-89.049 1092.784 1805.628)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.272,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1093.51,
    cy: 1805.39,
    fill: "#142223",
    rx: 137.35,
    ry: 357.62,
    transform: "rotate(-89.049 1093.456 1805.315)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.284,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1094.18,
    cy: 1805.07,
    fill: "#142223",
    rx: 135.61,
    ry: 353.08,
    transform: "rotate(-89.049 1094.127 1805.002)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.296,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1094.85,
    cy: 1804.76,
    fill: "#142223",
    rx: 133.86,
    ry: 348.54,
    transform: "rotate(-89.049 1094.8 1804.689)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.309,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1095.52,
    cy: 1804.45,
    fill: "#142223",
    rx: 132.12,
    ry: 344,
    transform: "rotate(-89.049 1095.47 1804.376)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.321,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1096.2,
    cy: 1804.13,
    fill: "#142223",
    rx: 130.37,
    ry: 339.46,
    transform: "rotate(-89.049 1096.143 1804.063)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.333,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1096.87,
    cy: 1803.82,
    fill: "#142223",
    rx: 128.63,
    ry: 334.92,
    transform: "rotate(-89.049 1096.814 1803.75)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.346,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1097.54,
    cy: 1803.51,
    fill: "#142223",
    rx: 126.89,
    ry: 330.38,
    transform: "rotate(-89.049 1097.486 1803.437)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.358,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1098.21,
    cy: 1803.2,
    fill: "#142223",
    rx: 125.14,
    ry: 325.84,
    transform: "rotate(-89.049 1098.158 1803.124)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.37,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1098.88,
    cy: 1802.88,
    fill: "#142223",
    rx: 123.4,
    ry: 321.29,
    transform: "rotate(-89.049 1098.83 1802.81)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.383,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1099.56,
    cy: 1802.57,
    fill: "#142223",
    rx: 121.65,
    ry: 316.75,
    transform: "rotate(-89.049 1099.501 1802.498)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.395,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1100.23,
    cy: 1802.26,
    fill: "#142223",
    rx: 119.91,
    ry: 312.21,
    transform: "rotate(-89.049 1100.173 1802.185)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.407,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1100.9,
    cy: 1801.94,
    fill: "#142223",
    rx: 118.16,
    ry: 307.67,
    transform: "rotate(-89.049 1100.844 1801.872)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.42,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1101.57,
    cy: 1801.63,
    fill: "#142223",
    rx: 116.42,
    ry: 303.13,
    transform: "rotate(-89.049 1101.516 1801.559)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.432,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1102.24,
    cy: 1801.32,
    fill: "#142223",
    rx: 114.68,
    ry: 298.59,
    transform: "rotate(-89.049 1102.188 1801.246)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.444,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1102.91,
    cy: 1801,
    fill: "#142223",
    rx: 112.93,
    ry: 294.05,
    transform: "rotate(-89.049 1102.86 1800.933)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.457,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1103.59,
    cy: 1800.69,
    fill: "#142223",
    rx: 111.19,
    ry: 289.51,
    transform: "rotate(-89.049 1103.531 1800.62)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.469,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1104.26,
    cy: 1800.38,
    fill: "#142223",
    rx: 109.44,
    ry: 284.96,
    transform: "rotate(-89.049 1104.203 1800.307)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.481,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1104.93,
    cy: 1800.06,
    fill: "#142223",
    rx: 107.7,
    ry: 280.42,
    transform: "rotate(-89.049 1104.875 1799.994)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.494,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1105.6,
    cy: 1799.75,
    fill: "#142223",
    rx: 105.96,
    ry: 275.88,
    transform: "rotate(-89.049 1105.546 1799.68)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.506,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1106.27,
    cy: 1799.44,
    fill: "#142223",
    rx: 104.21,
    ry: 271.34,
    transform: "rotate(-89.049 1106.218 1799.368)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.518,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1106.94,
    cy: 1799.13,
    fill: "#142223",
    rx: 102.47,
    ry: 266.8,
    transform: "rotate(-89.049 1106.89 1799.055)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.531,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1107.62,
    cy: 1798.81,
    fill: "#142223",
    rx: 100.72,
    ry: 262.26,
    transform: "rotate(-89.049 1107.561 1798.742)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.543,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1108.29,
    cy: 1798.5,
    fill: "#142223",
    rx: 98.98,
    ry: 257.72,
    transform: "rotate(-89.049 1108.233 1798.429)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.556,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1108.96,
    cy: 1798.19,
    fill: "#142223",
    rx: 97.24,
    ry: 253.18,
    transform: "rotate(-89.049 1108.905 1798.116)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.568,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1109.63,
    cy: 1797.87,
    fill: "#142223",
    rx: 95.49,
    ry: 248.63,
    transform: "rotate(-89.049 1109.576 1797.803)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.58,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1110.3,
    cy: 1797.56,
    fill: "#142223",
    rx: 93.75,
    ry: 244.09,
    transform: "rotate(-89.049 1110.248 1797.49)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.593,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1110.97,
    cy: 1797.25,
    fill: "#142223",
    rx: 92,
    ry: 239.55,
    transform: "rotate(-89.049 1110.92 1797.177)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.605,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1111.65,
    cy: 1796.93,
    fill: "#142223",
    rx: 90.26,
    ry: 235.01,
    transform: "rotate(-89.049 1111.591 1796.864)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.617,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1112.32,
    cy: 1796.62,
    fill: "#142223",
    rx: 88.51,
    ry: 230.47,
    transform: "rotate(-89.049 1112.263 1796.55)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.63,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1112.99,
    cy: 1796.31,
    fill: "#142223",
    rx: 86.77,
    ry: 225.93,
    transform: "rotate(-89.049 1112.935 1796.238)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.642,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1113.66,
    cy: 1796,
    fill: "#142223",
    rx: 85.03,
    ry: 221.39,
    transform: "rotate(-89.049 1113.607 1795.925)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.654,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1114.33,
    cy: 1795.68,
    fill: "#142223",
    rx: 83.28,
    ry: 216.85,
    transform: "rotate(-89.049 1114.278 1795.612)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.667,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1115,
    cy: 1795.37,
    fill: "#142223",
    rx: 81.54,
    ry: 212.3,
    transform: "rotate(-89.049 1114.95 1795.299)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.679,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1115.68,
    cy: 1795.06,
    fill: "#142223",
    rx: 79.79,
    ry: 207.76,
    transform: "rotate(-89.049 1115.622 1794.986)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.691,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1116.35,
    cy: 1794.74,
    fill: "#142223",
    rx: 78.05,
    ry: 203.22,
    transform: "rotate(-89.049 1116.293 1794.673)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.704,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1117.02,
    cy: 1794.43,
    fill: "#142223",
    rx: 76.31,
    ry: 198.68,
    transform: "rotate(-89.049 1116.965 1794.36)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.716,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1117.69,
    cy: 1794.12,
    fill: "#142223",
    rx: 74.56,
    ry: 194.14,
    transform: "rotate(-89.049 1117.637 1794.047)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.728,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1118.36,
    cy: 1793.8,
    fill: "#142223",
    rx: 72.82,
    ry: 189.6,
    transform: "rotate(-89.049 1118.308 1793.734)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.741,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1119.03,
    cy: 1793.49,
    fill: "#142223",
    rx: 71.07,
    ry: 185.06,
    transform: "rotate(-89.049 1118.98 1793.421)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.753,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1119.71,
    cy: 1793.18,
    fill: "#142223",
    rx: 69.33,
    ry: 180.51,
    transform: "rotate(-89.049 1119.652 1793.108)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.765,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1120.38,
    cy: 1792.87,
    fill: "#142223",
    rx: 67.58,
    ry: 175.97,
    transform: "rotate(-89.049 1120.323 1792.795)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.778,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1121.05,
    cy: 1792.55,
    fill: "#142223",
    rx: 65.84,
    ry: 171.43,
    transform: "rotate(-89.049 1120.995 1792.482)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.79,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1121.72,
    cy: 1792.24,
    fill: "#142223",
    rx: 64.1,
    ry: 166.89,
    transform: "rotate(-89.049 1121.667 1792.169)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.802,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1122.39,
    cy: 1791.93,
    fill: "#142223",
    rx: 62.35,
    ry: 162.35,
    transform: "rotate(-89.049 1122.339 1791.856)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.815,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1123.06,
    cy: 1791.61,
    fill: "#142223",
    rx: 60.61,
    ry: 157.81,
    transform: "rotate(-89.049 1123.01 1791.543)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.827,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1123.74,
    cy: 1791.3,
    fill: "#142223",
    rx: 58.86,
    ry: 153.27,
    transform: "rotate(-89.049 1123.682 1791.23)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.84,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1124.41,
    cy: 1790.99,
    fill: "#142223",
    rx: 57.12,
    ry: 148.73,
    transform: "rotate(-89.049 1124.354 1790.917)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.852,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1125.08,
    cy: 1790.67,
    fill: "#142223",
    rx: 55.38,
    ry: 144.18,
    transform: "rotate(-89.049 1125.026 1790.604)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.864,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1125.75,
    cy: 1790.36,
    fill: "#142223",
    rx: 53.63,
    ry: 139.64,
    transform: "rotate(-89.049 1125.697 1790.291)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.876,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1126.42,
    cy: 1790.05,
    fill: "#142223",
    rx: 51.89,
    ry: 135.1,
    transform: "rotate(-89.049 1126.369 1789.978)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.889,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1127.1,
    cy: 1789.74,
    fill: "#142223",
    rx: 50.14,
    ry: 130.56,
    transform: "rotate(-89.049 1127.04 1789.665)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.901,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1127.77,
    cy: 1789.42,
    fill: "#142223",
    rx: 48.4,
    ry: 126.02,
    transform: "rotate(-89.049 1127.712 1789.352)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.914,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1128.44,
    cy: 1789.11,
    fill: "#142223",
    rx: 46.66,
    ry: 121.48,
    transform: "rotate(-89.049 1128.384 1789.039)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.926,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1129.11,
    cy: 1788.8,
    fill: "#142223",
    rx: 44.91,
    ry: 116.94,
    transform: "rotate(-89.049 1129.056 1788.726)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.938,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1129.78,
    cy: 1788.48,
    fill: "#142223",
    rx: 43.17,
    ry: 112.4,
    transform: "rotate(-89.049 1129.728 1788.413)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.951,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1130.45,
    cy: 1788.17,
    fill: "#142223",
    rx: 41.42,
    ry: 107.85,
    transform: "rotate(-89.049 1130.4 1788.1)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.963,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1131.13,
    cy: 1787.86,
    fill: "#142223",
    rx: 39.68,
    ry: 103.31,
    transform: "rotate(-89.049 1131.07 1787.787)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.975,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1131.8,
    cy: 1787.54,
    fill: "#142223",
    rx: 37.93,
    ry: 98.77,
    transform: "rotate(-89.049 1131.743 1787.474)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.988,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1132.47,
    cy: 1787.23,
    fill: "#142223",
    rx: 36.19,
    ry: 94.23,
    transform: "rotate(-89.049 1132.414 1787.161)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1133.14,
    cy: 1786.92,
    fill: "#142223",
    rx: 34.45,
    ry: 89.69,
    transform: "rotate(-89.049 1133.086 1786.848)",
    className: "color141723 svgShape"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.34,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1738.73,
    cy: 2022.27,
    fill: "#142223",
    rx: 175.72,
    ry: 457.53,
    transform: "rotate(-89.049 1738.65 2022.195)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.012,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1739.4,
    cy: 2021.96,
    fill: "#142223",
    rx: 173.98,
    ry: 452.99,
    transform: "rotate(-89.049 1739.322 2021.882)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.025,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1740.08,
    cy: 2021.65,
    fill: "#142223",
    rx: 172.23,
    ry: 448.45,
    transform: "rotate(-89.049 1739.993 2021.569)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.037,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1740.75,
    cy: 2021.33,
    fill: "#142223",
    rx: 170.49,
    ry: 443.91,
    transform: "rotate(-89.049 1740.665 2021.256)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.049,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1741.42,
    cy: 2021.02,
    fill: "#142223",
    rx: 168.74,
    ry: 439.37,
    transform: "rotate(-89.049 1741.337 2020.943)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.062,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1742.09,
    cy: 2020.71,
    fill: "#142223",
    rx: 167,
    ry: 434.83,
    transform: "rotate(-89.049 1742.008 2020.63)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.074,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1742.76,
    cy: 2020.39,
    fill: "#142223",
    rx: 165.26,
    ry: 430.28,
    transform: "rotate(-89.049 1742.68 2020.317)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.086,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1743.43,
    cy: 2020.08,
    fill: "#142223",
    rx: 163.51,
    ry: 425.74,
    transform: "rotate(-89.049 1743.352 2020.004)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.099,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1744.11,
    cy: 2019.77,
    fill: "#142223",
    rx: 161.77,
    ry: 421.2,
    transform: "rotate(-89.049 1744.023 2019.69)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.111,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1744.78,
    cy: 2019.46,
    fill: "#142223",
    rx: 160.02,
    ry: 416.66,
    transform: "rotate(-89.049 1744.695 2019.378)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.123,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1745.45,
    cy: 2019.14,
    fill: "#142223",
    rx: 158.28,
    ry: 412.12,
    transform: "rotate(-89.049 1745.367 2019.065)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.136,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1746.12,
    cy: 2018.83,
    fill: "#142223",
    rx: 156.54,
    ry: 407.58,
    transform: "rotate(-89.049 1746.038 2018.752)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.148,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1746.79,
    cy: 2018.52,
    fill: "#142223",
    rx: 154.79,
    ry: 403.04,
    transform: "rotate(-89.049 1746.71 2018.439)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.161,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1747.46,
    cy: 2018.2,
    fill: "#142223",
    rx: 153.05,
    ry: 398.5,
    transform: "rotate(-89.049 1747.382 2018.126)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.173,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1748.14,
    cy: 2017.89,
    fill: "#142223",
    rx: 151.3,
    ry: 393.95,
    transform: "rotate(-89.049 1748.054 2017.813)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.185,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1748.81,
    cy: 2017.58,
    fill: "#142223",
    rx: 149.56,
    ry: 389.41,
    transform: "rotate(-89.049 1748.725 2017.5)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.198,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1749.48,
    cy: 2017.26,
    fill: "#142223",
    rx: 147.82,
    ry: 384.87,
    transform: "rotate(-89.049 1749.397 2017.187)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.21,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1750.15,
    cy: 2016.95,
    fill: "#142223",
    rx: 146.07,
    ry: 380.33,
    transform: "rotate(-89.049 1750.069 2016.874)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.222,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1750.82,
    cy: 2016.64,
    fill: "#142223",
    rx: 144.33,
    ry: 375.79,
    transform: "rotate(-89.049 1750.74 2016.56)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.235,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1751.49,
    cy: 2016.33,
    fill: "#142223",
    rx: 142.58,
    ry: 371.25,
    transform: "rotate(-89.049 1751.412 2016.248)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.247,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1752.17,
    cy: 2016.01,
    fill: "#142223",
    rx: 140.84,
    ry: 366.71,
    transform: "rotate(-89.049 1752.084 2015.935)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.259,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1752.84,
    cy: 2015.7,
    fill: "#142223",
    rx: 139.09,
    ry: 362.17,
    transform: "rotate(-89.049 1752.755 2015.622)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.272,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1753.51,
    cy: 2015.39,
    fill: "#142223",
    rx: 137.35,
    ry: 357.62,
    transform: "rotate(-89.049 1753.427 2015.309)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.284,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1754.18,
    cy: 2015.07,
    fill: "#142223",
    rx: 135.61,
    ry: 353.08,
    transform: "rotate(-89.049 1754.099 2014.996)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.296,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1754.85,
    cy: 2014.76,
    fill: "#142223",
    rx: 133.86,
    ry: 348.54,
    transform: "rotate(-89.049 1754.77 2014.683)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.309,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1755.52,
    cy: 2014.45,
    fill: "#142223",
    rx: 132.12,
    ry: 344,
    transform: "rotate(-89.049 1755.442 2014.37)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.321,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1756.2,
    cy: 2014.13,
    fill: "#142223",
    rx: 130.37,
    ry: 339.46,
    transform: "rotate(-89.049 1756.114 2014.057)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.333,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1756.87,
    cy: 2013.82,
    fill: "#142223",
    rx: 128.63,
    ry: 334.92,
    transform: "rotate(-89.049 1756.786 2013.744)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.346,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1757.54,
    cy: 2013.51,
    fill: "#142223",
    rx: 126.89,
    ry: 330.38,
    transform: "rotate(-89.049 1757.457 2013.43)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.358,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1758.21,
    cy: 2013.2,
    fill: "#142223",
    rx: 125.14,
    ry: 325.84,
    transform: "rotate(-89.049 1758.129 2013.118)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.37,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1758.88,
    cy: 2012.88,
    fill: "#142223",
    rx: 123.4,
    ry: 321.29,
    transform: "rotate(-89.049 1758.8 2012.805)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.383,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1759.56,
    cy: 2012.57,
    fill: "#142223",
    rx: 121.65,
    ry: 316.75,
    transform: "rotate(-89.049 1759.472 2012.492)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.395,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1760.23,
    cy: 2012.26,
    fill: "#142223",
    rx: 119.91,
    ry: 312.21,
    transform: "rotate(-89.049 1760.144 2012.179)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.407,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1760.9,
    cy: 2011.94,
    fill: "#142223",
    rx: 118.16,
    ry: 307.67,
    transform: "rotate(-89.049 1760.816 2011.866)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.42,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1761.57,
    cy: 2011.63,
    fill: "#142223",
    rx: 116.42,
    ry: 303.13,
    transform: "rotate(-89.049 1761.487 2011.553)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.432,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1762.24,
    cy: 2011.32,
    fill: "#142223",
    rx: 114.68,
    ry: 298.59,
    transform: "rotate(-89.049 1762.16 2011.24)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.444,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1762.91,
    cy: 2011,
    fill: "#142223",
    rx: 112.93,
    ry: 294.05,
    transform: "rotate(-89.049 1762.83 2010.927)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.457,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1763.59,
    cy: 2010.69,
    fill: "#142223",
    rx: 111.19,
    ry: 289.51,
    transform: "rotate(-89.049 1763.502 2010.614)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.469,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1764.26,
    cy: 2010.38,
    fill: "#142223",
    rx: 109.44,
    ry: 284.96,
    transform: "rotate(-89.049 1764.174 2010.3)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.481,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1764.93,
    cy: 2010.06,
    fill: "#142223",
    rx: 107.7,
    ry: 280.42,
    transform: "rotate(-89.049 1764.846 2009.988)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.494,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1765.6,
    cy: 2009.75,
    fill: "#142223",
    rx: 105.96,
    ry: 275.88,
    transform: "rotate(-89.049 1765.518 2009.675)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.506,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1766.27,
    cy: 2009.44,
    fill: "#142223",
    rx: 104.21,
    ry: 271.34,
    transform: "rotate(-89.049 1766.19 2009.362)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.518,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1766.94,
    cy: 2009.13,
    fill: "#142223",
    rx: 102.47,
    ry: 266.8,
    transform: "rotate(-89.049 1766.86 2009.049)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.531,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1767.62,
    cy: 2008.81,
    fill: "#142223",
    rx: 100.72,
    ry: 262.26,
    transform: "rotate(-89.049 1767.533 2008.736)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.543,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1768.29,
    cy: 2008.5,
    fill: "#142223",
    rx: 98.98,
    ry: 257.72,
    transform: "rotate(-89.049 1768.204 2008.423)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.556,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1768.96,
    cy: 2008.19,
    fill: "#142223",
    rx: 97.24,
    ry: 253.18,
    transform: "rotate(-89.049 1768.876 2008.11)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.568,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1769.63,
    cy: 2007.87,
    fill: "#142223",
    rx: 95.49,
    ry: 248.63,
    transform: "rotate(-89.049 1769.548 2007.797)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.58,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1770.3,
    cy: 2007.56,
    fill: "#142223",
    rx: 93.75,
    ry: 244.09,
    transform: "rotate(-89.049 1770.22 2007.484)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.593,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1770.97,
    cy: 2007.25,
    fill: "#142223",
    rx: 92,
    ry: 239.55,
    transform: "rotate(-89.049 1770.891 2007.17)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.605,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1771.65,
    cy: 2006.93,
    fill: "#142223",
    rx: 90.26,
    ry: 235.01,
    transform: "rotate(-89.049 1771.563 2006.858)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.617,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1772.32,
    cy: 2006.62,
    fill: "#142223",
    rx: 88.51,
    ry: 230.47,
    transform: "rotate(-89.049 1772.235 2006.545)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.63,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1772.99,
    cy: 2006.31,
    fill: "#142223",
    rx: 86.77,
    ry: 225.93,
    transform: "rotate(-89.049 1772.906 2006.232)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.642,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1773.66,
    cy: 2006,
    fill: "#142223",
    rx: 85.03,
    ry: 221.39,
    transform: "rotate(-89.049 1773.578 2005.919)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.654,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1774.33,
    cy: 2005.68,
    fill: "#142223",
    rx: 83.28,
    ry: 216.85,
    transform: "rotate(-89.049 1774.25 2005.606)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.667,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1775,
    cy: 2005.37,
    fill: "#142223",
    rx: 81.54,
    ry: 212.3,
    transform: "rotate(-89.049 1774.921 2005.293)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.679,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1775.68,
    cy: 2005.06,
    fill: "#142223",
    rx: 79.79,
    ry: 207.76,
    transform: "rotate(-89.049 1775.593 2004.98)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.691,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1776.35,
    cy: 2004.74,
    fill: "#142223",
    rx: 78.05,
    ry: 203.22,
    transform: "rotate(-89.049 1776.265 2004.667)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.704,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1777.02,
    cy: 2004.43,
    fill: "#142223",
    rx: 76.31,
    ry: 198.68,
    transform: "rotate(-89.049 1776.936 2004.354)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.716,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1777.69,
    cy: 2004.12,
    fill: "#142223",
    rx: 74.56,
    ry: 194.14,
    transform: "rotate(-89.049 1777.608 2004.04)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.728,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1778.36,
    cy: 2003.8,
    fill: "#142223",
    rx: 72.82,
    ry: 189.6,
    transform: "rotate(-89.049 1778.28 2003.728)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.741,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1779.03,
    cy: 2003.49,
    fill: "#142223",
    rx: 71.07,
    ry: 185.06,
    transform: "rotate(-89.049 1778.951 2003.415)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.753,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1779.71,
    cy: 2003.18,
    fill: "#142223",
    rx: 69.33,
    ry: 180.51,
    transform: "rotate(-89.049 1779.623 2003.102)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.765,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1780.38,
    cy: 2002.87,
    fill: "#142223",
    rx: 67.58,
    ry: 175.97,
    transform: "rotate(-89.049 1780.295 2002.789)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.778,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1781.05,
    cy: 2002.55,
    fill: "#142223",
    rx: 65.84,
    ry: 171.43,
    transform: "rotate(-89.049 1780.967 2002.476)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.79,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1781.72,
    cy: 2002.24,
    fill: "#142223",
    rx: 64.1,
    ry: 166.89,
    transform: "rotate(-89.049 1781.638 2002.163)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.802,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1782.39,
    cy: 2001.93,
    fill: "#142223",
    rx: 62.35,
    ry: 162.35,
    transform: "rotate(-89.049 1782.31 2001.85)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.815,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1783.06,
    cy: 2001.61,
    fill: "#142223",
    rx: 60.61,
    ry: 157.81,
    transform: "rotate(-89.049 1782.982 2001.537)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.827,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1783.74,
    cy: 2001.3,
    fill: "#142223",
    rx: 58.86,
    ry: 153.27,
    transform: "rotate(-89.049 1783.653 2001.224)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.84,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1784.41,
    cy: 2000.99,
    fill: "#142223",
    rx: 57.12,
    ry: 148.73,
    transform: "rotate(-89.049 1784.325 2000.91)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.852,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1785.08,
    cy: 2000.67,
    fill: "#142223",
    rx: 55.38,
    ry: 144.18,
    transform: "rotate(-89.049 1784.997 2000.598)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.864,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1785.75,
    cy: 2000.36,
    fill: "#142223",
    rx: 53.63,
    ry: 139.64,
    transform: "rotate(-89.049 1785.669 2000.285)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.876,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1786.42,
    cy: 2000.05,
    fill: "#142223",
    rx: 51.89,
    ry: 135.1,
    transform: "rotate(-89.049 1786.34 1999.972)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.889,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1787.1,
    cy: 1999.74,
    fill: "#142223",
    rx: 50.14,
    ry: 130.56,
    transform: "rotate(-89.049 1787.012 1999.659)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.901,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1787.77,
    cy: 1999.42,
    fill: "#142223",
    rx: 48.4,
    ry: 126.02,
    transform: "rotate(-89.049 1787.684 1999.346)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.914,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1788.44,
    cy: 1999.11,
    fill: "#142223",
    rx: 46.66,
    ry: 121.48,
    transform: "rotate(-89.049 1788.355 1999.033)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.926,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1789.11,
    cy: 1998.8,
    fill: "#142223",
    rx: 44.91,
    ry: 116.94,
    transform: "rotate(-89.049 1789.027 1998.72)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.938,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1789.78,
    cy: 1998.48,
    fill: "#142223",
    rx: 43.17,
    ry: 112.4,
    transform: "rotate(-89.049 1789.699 1998.407)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.951,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1790.45,
    cy: 1998.17,
    fill: "#142223",
    rx: 41.42,
    ry: 107.85,
    transform: "rotate(-89.049 1790.37 1998.094)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.963,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1791.13,
    cy: 1997.86,
    fill: "#142223",
    rx: 39.68,
    ry: 103.31,
    transform: "rotate(-89.049 1791.042 1997.78)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.975,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1791.8,
    cy: 1997.54,
    fill: "#142223",
    rx: 37.93,
    ry: 98.77,
    transform: "rotate(-89.049 1791.714 1997.468)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.988,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1792.47,
    cy: 1997.23,
    fill: "#142223",
    rx: 36.19,
    ry: 94.23,
    transform: "rotate(-89.049 1792.386 1997.155)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1793.14,
    cy: 1996.92,
    fill: "#142223",
    rx: 34.45,
    ry: 89.69,
    transform: "rotate(-89.049 1793.058 1996.842)",
    className: "color141723 svgShape"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.34,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 458.73,
    cy: 1244.27,
    fill: "#142223",
    rx: 175.72,
    ry: 457.53,
    transform: "rotate(-89.049 458.707 1244.222)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.012,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 459.4,
    cy: 1243.96,
    fill: "#142223",
    rx: 173.98,
    ry: 452.99,
    transform: "rotate(-89.049 459.379 1243.91)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.025,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 460.08,
    cy: 1243.65,
    fill: "#142223",
    rx: 172.23,
    ry: 448.45,
    transform: "rotate(-89.049 460.05 1243.596)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.037,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 460.75,
    cy: 1243.33,
    fill: "#142223",
    rx: 170.49,
    ry: 443.91,
    transform: "rotate(-89.049 460.722 1243.283)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.049,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 461.42,
    cy: 1243.02,
    fill: "#142223",
    rx: 168.74,
    ry: 439.37,
    transform: "rotate(-89.049 461.394 1242.97)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.062,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 462.09,
    cy: 1242.71,
    fill: "#142223",
    rx: 167,
    ry: 434.83,
    transform: "rotate(-89.049 462.066 1242.657)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.074,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 462.76,
    cy: 1242.39,
    fill: "#142223",
    rx: 165.26,
    ry: 430.28,
    transform: "rotate(-89.049 462.737 1242.344)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.086,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 463.43,
    cy: 1242.08,
    fill: "#142223",
    rx: 163.51,
    ry: 425.74,
    transform: "rotate(-89.049 463.41 1242.031)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.099,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 464.11,
    cy: 1241.77,
    fill: "#142223",
    rx: 161.77,
    ry: 421.2,
    transform: "rotate(-89.049 464.08 1241.718)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.111,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 464.78,
    cy: 1241.46,
    fill: "#142223",
    rx: 160.02,
    ry: 416.66,
    transform: "rotate(-89.049 464.752 1241.405)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.123,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 465.45,
    cy: 1241.14,
    fill: "#142223",
    rx: 158.28,
    ry: 412.12,
    transform: "rotate(-89.049 465.424 1241.092)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.136,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 466.12,
    cy: 1240.83,
    fill: "#142223",
    rx: 156.54,
    ry: 407.58,
    transform: "rotate(-89.049 466.096 1240.78)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.148,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 466.79,
    cy: 1240.52,
    fill: "#142223",
    rx: 154.79,
    ry: 403.04,
    transform: "rotate(-89.049 466.768 1240.466)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.161,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 467.46,
    cy: 1240.2,
    fill: "#142223",
    rx: 153.05,
    ry: 398.5,
    transform: "rotate(-89.049 467.44 1240.153)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.173,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 468.14,
    cy: 1239.89,
    fill: "#142223",
    rx: 151.3,
    ry: 393.95,
    transform: "rotate(-89.049 468.11 1239.84)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.185,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 468.81,
    cy: 1239.58,
    fill: "#142223",
    rx: 149.56,
    ry: 389.41,
    transform: "rotate(-89.049 468.783 1239.527)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.198,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 469.48,
    cy: 1239.26,
    fill: "#142223",
    rx: 147.82,
    ry: 384.87,
    transform: "rotate(-89.049 469.454 1239.214)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.21,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 470.15,
    cy: 1238.95,
    fill: "#142223",
    rx: 146.07,
    ry: 380.33,
    transform: "rotate(-89.049 470.126 1238.901)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.222,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 470.82,
    cy: 1238.64,
    fill: "#142223",
    rx: 144.33,
    ry: 375.79,
    transform: "rotate(-89.049 470.798 1238.588)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.235,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 471.49,
    cy: 1238.33,
    fill: "#142223",
    rx: 142.58,
    ry: 371.25,
    transform: "rotate(-89.049 471.47 1238.275)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.247,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 472.17,
    cy: 1238.01,
    fill: "#142223",
    rx: 140.84,
    ry: 366.71,
    transform: "rotate(-89.049 472.141 1237.962)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.259,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 472.84,
    cy: 1237.7,
    fill: "#142223",
    rx: 139.09,
    ry: 362.17,
    transform: "rotate(-89.049 472.813 1237.65)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.272,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 473.51,
    cy: 1237.39,
    fill: "#142223",
    rx: 137.35,
    ry: 357.62,
    transform: "rotate(-89.049 473.484 1237.336)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.284,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 474.18,
    cy: 1237.07,
    fill: "#142223",
    rx: 135.61,
    ry: 353.08,
    transform: "rotate(-89.049 474.156 1237.023)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.296,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 474.85,
    cy: 1236.76,
    fill: "#142223",
    rx: 133.86,
    ry: 348.54,
    transform: "rotate(-89.049 474.828 1236.71)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.309,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 475.52,
    cy: 1236.45,
    fill: "#142223",
    rx: 132.12,
    ry: 344,
    transform: "rotate(-89.049 475.5 1236.397)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.321,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 476.2,
    cy: 1236.13,
    fill: "#142223",
    rx: 130.37,
    ry: 339.46,
    transform: "rotate(-89.049 476.171 1236.084)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.333,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 476.87,
    cy: 1235.82,
    fill: "#142223",
    rx: 128.63,
    ry: 334.92,
    transform: "rotate(-89.049 476.843 1235.771)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.346,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 477.54,
    cy: 1235.51,
    fill: "#142223",
    rx: 126.89,
    ry: 330.38,
    transform: "rotate(-89.049 477.514 1235.458)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.358,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 478.21,
    cy: 1235.2,
    fill: "#142223",
    rx: 125.14,
    ry: 325.84,
    transform: "rotate(-89.049 478.186 1235.145)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.37,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 478.88,
    cy: 1234.88,
    fill: "#142223",
    rx: 123.4,
    ry: 321.29,
    transform: "rotate(-89.049 478.858 1234.832)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.383,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 479.56,
    cy: 1234.57,
    fill: "#142223",
    rx: 121.65,
    ry: 316.75,
    transform: "rotate(-89.049 479.53 1234.52)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.395,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 480.23,
    cy: 1234.26,
    fill: "#142223",
    rx: 119.91,
    ry: 312.21,
    transform: "rotate(-89.049 480.201 1234.206)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.407,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 480.9,
    cy: 1233.94,
    fill: "#142223",
    rx: 118.16,
    ry: 307.67,
    transform: "rotate(-89.049 480.873 1233.893)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.42,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 481.57,
    cy: 1233.63,
    fill: "#142223",
    rx: 116.42,
    ry: 303.13,
    transform: "rotate(-89.049 481.545 1233.58)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.432,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 482.24,
    cy: 1233.32,
    fill: "#142223",
    rx: 114.68,
    ry: 298.59,
    transform: "rotate(-89.049 482.216 1233.267)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.444,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 482.91,
    cy: 1233,
    fill: "#142223",
    rx: 112.93,
    ry: 294.05,
    transform: "rotate(-89.049 482.888 1232.954)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.457,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 483.59,
    cy: 1232.69,
    fill: "#142223",
    rx: 111.19,
    ry: 289.51,
    transform: "rotate(-89.049 483.56 1232.641)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.469,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 484.26,
    cy: 1232.38,
    fill: "#142223",
    rx: 109.44,
    ry: 284.96,
    transform: "rotate(-89.049 484.231 1232.328)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.481,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 484.93,
    cy: 1232.06,
    fill: "#142223",
    rx: 107.7,
    ry: 280.42,
    transform: "rotate(-89.049 484.903 1232.015)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.494,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 485.6,
    cy: 1231.75,
    fill: "#142223",
    rx: 105.96,
    ry: 275.88,
    transform: "rotate(-89.049 485.575 1231.702)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.506,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 486.27,
    cy: 1231.44,
    fill: "#142223",
    rx: 104.21,
    ry: 271.34,
    transform: "rotate(-89.049 486.246 1231.39)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.518,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 486.94,
    cy: 1231.13,
    fill: "#142223",
    rx: 102.47,
    ry: 266.8,
    transform: "rotate(-89.049 486.918 1231.076)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.531,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 487.62,
    cy: 1230.81,
    fill: "#142223",
    rx: 100.72,
    ry: 262.26,
    transform: "rotate(-89.049 487.59 1230.763)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.543,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 488.29,
    cy: 1230.5,
    fill: "#142223",
    rx: 98.98,
    ry: 257.72,
    transform: "rotate(-89.049 488.261 1230.45)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.556,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 488.96,
    cy: 1230.19,
    fill: "#142223",
    rx: 97.24,
    ry: 253.18,
    transform: "rotate(-89.049 488.933 1230.137)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.568,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 489.63,
    cy: 1229.87,
    fill: "#142223",
    rx: 95.49,
    ry: 248.63,
    transform: "rotate(-89.049 489.605 1229.824)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.58,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 490.3,
    cy: 1229.56,
    fill: "#142223",
    rx: 93.75,
    ry: 244.09,
    transform: "rotate(-89.049 490.277 1229.511)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.593,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 490.97,
    cy: 1229.25,
    fill: "#142223",
    rx: 92,
    ry: 239.55,
    transform: "rotate(-89.049 490.948 1229.198)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.605,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 491.65,
    cy: 1228.93,
    fill: "#142223",
    rx: 90.26,
    ry: 235.01,
    transform: "rotate(-89.049 491.62 1228.885)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.617,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 492.32,
    cy: 1228.62,
    fill: "#142223",
    rx: 88.51,
    ry: 230.47,
    transform: "rotate(-89.049 492.292 1228.572)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.63,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 492.99,
    cy: 1228.31,
    fill: "#142223",
    rx: 86.77,
    ry: 225.93,
    transform: "rotate(-89.049 492.963 1228.26)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.642,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 493.66,
    cy: 1228,
    fill: "#142223",
    rx: 85.03,
    ry: 221.39,
    transform: "rotate(-89.049 493.635 1227.946)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.654,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 494.33,
    cy: 1227.68,
    fill: "#142223",
    rx: 83.28,
    ry: 216.85,
    transform: "rotate(-89.049 494.307 1227.633)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.667,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 495,
    cy: 1227.37,
    fill: "#142223",
    rx: 81.54,
    ry: 212.3,
    transform: "rotate(-89.049 494.978 1227.32)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.679,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 495.68,
    cy: 1227.06,
    fill: "#142223",
    rx: 79.79,
    ry: 207.76,
    transform: "rotate(-89.049 495.65 1227.007)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.691,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 496.35,
    cy: 1226.74,
    fill: "#142223",
    rx: 78.05,
    ry: 203.22,
    transform: "rotate(-89.049 496.322 1226.694)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.704,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 497.02,
    cy: 1226.43,
    fill: "#142223",
    rx: 76.31,
    ry: 198.68,
    transform: "rotate(-89.049 496.993 1226.381)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.716,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 497.69,
    cy: 1226.12,
    fill: "#142223",
    rx: 74.56,
    ry: 194.14,
    transform: "rotate(-89.049 497.665 1226.068)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.728,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 498.36,
    cy: 1225.8,
    fill: "#142223",
    rx: 72.82,
    ry: 189.6,
    transform: "rotate(-89.049 498.337 1225.755)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.741,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 499.03,
    cy: 1225.49,
    fill: "#142223",
    rx: 71.07,
    ry: 185.06,
    transform: "rotate(-89.049 499.009 1225.442)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.753,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 499.71,
    cy: 1225.18,
    fill: "#142223",
    rx: 69.33,
    ry: 180.51,
    transform: "rotate(-89.049 499.68 1225.13)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.765,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 500.38,
    cy: 1224.87,
    fill: "#142223",
    rx: 67.58,
    ry: 175.97,
    transform: "rotate(-89.049 500.352 1224.816)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.778,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 501.05,
    cy: 1224.55,
    fill: "#142223",
    rx: 65.84,
    ry: 171.43,
    transform: "rotate(-89.049 501.024 1224.503)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.79,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 501.72,
    cy: 1224.24,
    fill: "#142223",
    rx: 64.1,
    ry: 166.89,
    transform: "rotate(-89.049 501.695 1224.19)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.802,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 502.39,
    cy: 1223.93,
    fill: "#142223",
    rx: 62.35,
    ry: 162.35,
    transform: "rotate(-89.049 502.367 1223.877)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.815,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 503.06,
    cy: 1223.61,
    fill: "#142223",
    rx: 60.61,
    ry: 157.81,
    transform: "rotate(-89.049 503.039 1223.564)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.827,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 503.74,
    cy: 1223.3,
    fill: "#142223",
    rx: 58.86,
    ry: 153.27,
    transform: "rotate(-89.049 503.71 1223.251)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.84,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 504.41,
    cy: 1222.99,
    fill: "#142223",
    rx: 57.12,
    ry: 148.73,
    transform: "rotate(-89.049 504.382 1222.938)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.852,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 505.08,
    cy: 1222.67,
    fill: "#142223",
    rx: 55.38,
    ry: 144.18,
    transform: "rotate(-89.049 505.054 1222.625)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.864,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 505.75,
    cy: 1222.36,
    fill: "#142223",
    rx: 53.63,
    ry: 139.64,
    transform: "rotate(-89.049 505.725 1222.312)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.876,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 506.42,
    cy: 1222.05,
    fill: "#142223",
    rx: 51.89,
    ry: 135.1,
    transform: "rotate(-89.049 506.397 1222)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.889,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 507.1,
    cy: 1221.74,
    fill: "#142223",
    rx: 50.14,
    ry: 130.56,
    transform: "rotate(-89.049 507.069 1221.686)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.901,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 507.77,
    cy: 1221.42,
    fill: "#142223",
    rx: 48.4,
    ry: 126.02,
    transform: "rotate(-89.049 507.74 1221.373)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.914,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 508.44,
    cy: 1221.11,
    fill: "#142223",
    rx: 46.66,
    ry: 121.48,
    transform: "rotate(-89.049 508.412 1221.06)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.926,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 509.11,
    cy: 1220.8,
    fill: "#142223",
    rx: 44.91,
    ry: 116.94,
    transform: "rotate(-89.049 509.084 1220.747)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.938,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 509.78,
    cy: 1220.48,
    fill: "#142223",
    rx: 43.17,
    ry: 112.4,
    transform: "rotate(-89.049 509.756 1220.434)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.951,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 510.45,
    cy: 1220.17,
    fill: "#142223",
    rx: 41.42,
    ry: 107.85,
    transform: "rotate(-89.049 510.427 1220.121)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.963,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 511.13,
    cy: 1219.86,
    fill: "#142223",
    rx: 39.68,
    ry: 103.31,
    transform: "rotate(-89.049 511.1 1219.808)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.975,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 511.8,
    cy: 1219.54,
    fill: "#142223",
    rx: 37.93,
    ry: 98.77,
    transform: "rotate(-89.049 511.77 1219.495)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.988,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 512.47,
    cy: 1219.23,
    fill: "#142223",
    rx: 36.19,
    ry: 94.23,
    transform: "rotate(-89.049 512.443 1219.182)",
    className: "color141723 svgShape"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 513.14,
    cy: 1218.92,
    fill: "#142223",
    rx: 34.45,
    ry: 89.69,
    transform: "rotate(-89.049 513.114 1218.87)",
    className: "color141723 svgShape"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 607.796,
    x2: 1079.435,
    y1: 225.959,
    y2: 225.959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c2cecf",
    className: "stopColorc2c3cf svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7b999b",
    className: "stopColor7b839b svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M1072.53,176.72c-4.26-3.13-8.52-6.18-12.8-9.11c-3.24-2.22-6.48-4.37-9.74-6.44 c-2.73-1.74-5.47-3.42-8.23-5.04c-0.59-0.35-1.18-0.69-1.77-1.03c-2.63-1.52-5.25-2.98-7.86-4.4c-3.39-1.84-6.77-3.58-10.13-5.25 c-2.2-1.09-4.38-2.08-6.56-3.09c-0.5-0.23-1.01-0.48-1.51-0.71c-0.65-0.29-1.3-0.63-1.94-0.92c-3.32-1.48-6.62-2.88-9.9-4.2 c-3.35-1.34-6.68-2.59-9.98-3.75c-0.58-0.21-1.15-0.36-1.72-0.56c-0.49-0.17-0.98-0.32-1.47-0.48c-2.25-0.75-4.49-1.53-6.72-2.2 c-3.44-1.04-6.84-1.98-10.22-2.82c-1.64-0.4-3.24-0.72-4.87-1.08c-0.71-0.17-1.43-0.33-2.14-0.48c-1.04-0.22-2.1-0.5-3.13-0.7 c-3.65-0.71-7.26-1.31-10.83-1.79c-2.21-0.3-4.38-0.46-6.56-0.67c-0.75-0.08-1.5-0.17-2.25-0.23c-0.73-0.06-1.48-0.18-2.2-0.22 c-3.93-0.28-7.81-0.4-11.62-0.39c-1.7,0.01-3.34,0.18-5.02,0.24c-1.28,0.04-2.55,0.09-3.82,0.18c-1.32,0.08-2.69,0.07-3.99,0.19 c-4.86,0.44-9.62,1.14-14.26,2.07c-0.09,0.02-0.18,0.06-0.27,0.07c-1.02,0.21-1.96,0.59-2.96,0.82 c-4.78,1.09-9.53,2.26-14.06,3.87c-0.37,0.13-0.69,0.35-1.06,0.49c-6.52,2.38-12.81,5.24-18.76,8.67 c-0.07,0.04-0.15,0.06-0.21,0.1L607.8,286.74c6.01-3.49,12.37-6.36,18.97-8.77c4.88-1.78,9.95-3.18,15.12-4.36 c1.01-0.23,1.95-0.61,2.96-0.82c5.97-1.21,12.17-1.92,18.5-2.33c1.29-0.08,2.59-0.13,3.89-0.18c6.13-0.23,12.38-0.16,18.8,0.37 c0.75,0.07,1.5,0.16,2.25,0.23c6.7,0.64,13.54,1.67,20.52,3.15c0.71,0.16,1.43,0.32,2.14,0.48c7.14,1.6,14.41,3.62,21.81,6.1 c0.49,0.16,0.98,0.31,1.47,0.48c7.72,2.65,15.58,5.79,23.54,9.43c0.5,0.23,1.01,0.48,1.51,0.72c8.08,3.75,16.27,7.95,24.55,12.74 c13.34,7.7,26.39,16.9,39.44,26.78l256.16-148.86C1077.13,180.14,1074.83,178.42,1072.53,176.72z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 910.629,
    x2: 1684.55,
    y1: 331.542,
    y2: 331.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c2cecf",
    className: "stopColorc2c3cf svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7b999b",
    className: "stopColor7b839b svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M1183.59,228.83c0.23,0.18,0.46,0.38,0.69,0.57c8.85,7.02,17.58,14.4,26.14,22.12 c0.12,0.11,0.23,0.22,0.34,0.32c8.6,7.78,17.05,15.87,25.32,24.28c0.09,0.09,0.17,0.17,0.26,0.26 c8.37,8.52,16.57,17.36,24.57,26.48c0.06,0.07,0.11,0.13,0.17,0.2c7.98,9.11,15.78,18.48,23.34,28.11 c0.02,0.03,0.04,0.06,0.06,0.08c6.2,7.89,12.14,16.03,18.04,24.22c2.71,3.76,5.38,7.56,8.02,11.38 c3.38,4.89,6.65,9.86,9.91,14.84c5.02,7.66,9.9,15.43,14.64,23.29c2.9,4.8,5.84,9.58,8.63,14.45c2.08,3.62,4.1,7.28,6.12,10.93 c4.86,8.8,9.66,17.64,14.14,26.61c0.05,0.11,0.11,0.21,0.16,0.31c5.43,10.89,10.57,21.89,15.42,32.96 c0.28,0.64,0.55,1.29,0.83,1.94c4.52,10.39,8.77,20.86,12.74,31.36c0.41,1.09,0.83,2.19,1.23,3.27 c3.85,10.32,7.41,20.66,10.7,31.02c0.33,1.03,0.67,2.06,0.99,3.09c3.34,10.71,6.38,21.43,9.1,32.13 c0.16,0.63,0.34,1.26,0.49,1.89c2.83,11.29,5.32,22.56,7.42,33.78c0.03,0.15,0.05,0.3,0.08,0.45c2.12,11.36,3.86,22.68,5.2,33.91 l256.16-148.87c-0.15-1.29-0.31-2.57-0.47-3.86c-0.64-5.08-1.37-10.18-2.17-15.28c-0.77-4.91-1.63-9.83-2.55-14.76 c-0.03-0.15-0.05-0.3-0.08-0.45c-0.02-0.12-0.04-0.23-0.06-0.34c-0.99-5.27-2.06-10.54-3.21-15.83 c-1.17-5.36-2.42-10.73-3.75-16.1c-0.12-0.5-0.27-1-0.4-1.5c-0.16-0.63-0.33-1.26-0.49-1.89c-1.08-4.28-2.18-8.55-3.37-12.82 c-1.49-5.37-3.06-10.74-4.71-16.11c-0.33-1.07-0.69-2.14-1.03-3.2c-0.32-1.03-0.66-2.06-0.99-3.09 c-1.02-3.21-2.01-6.42-3.09-9.63c-1.73-5.16-3.53-10.32-5.39-15.47c-0.72-1.99-1.5-3.97-2.24-5.96c-0.4-1.06-0.8-2.14-1.21-3.21 c-0.75-1.97-1.46-3.95-2.22-5.92c-1.91-4.91-3.88-9.82-5.92-14.71c-1.5-3.6-3.06-7.19-4.62-10.77c-0.28-0.64-0.55-1.29-0.83-1.93 c-0.29-0.66-0.56-1.33-0.85-1.99c-2.16-4.89-4.38-9.76-6.65-14.61c-2.54-5.43-5.16-10.83-7.84-16.21 c-0.03-0.05-0.05-0.1-0.08-0.16c-0.05-0.1-0.11-0.21-0.16-0.31c-2.91-5.82-5.89-11.6-8.96-17.36c-1.67-3.13-3.5-6.2-5.22-9.31 c-2-3.63-4.01-7.24-6.07-10.84c-1.26-2.19-2.42-4.44-3.7-6.61c-1.57-2.68-3.36-5.24-4.96-7.9c-4.74-7.85-9.61-15.61-14.63-23.26 c-1.55-2.37-2.94-4.84-4.52-7.19c-1.74-2.6-3.62-5.07-5.39-7.65c-2.64-3.83-5.31-7.61-8.02-11.37c-1.77-2.46-3.44-5-5.23-7.42 c-4.23-5.73-8.54-11.39-12.92-16.96c-3.95-5.02-7.96-9.98-12.03-14.87c-3.71-4.46-7.47-8.85-11.27-13.19 c-0.06-0.06-0.11-0.14-0.17-0.2c-0.04-0.05-0.08-0.1-0.12-0.15c-3.94-4.48-7.93-8.9-11.95-13.24c-4.05-4.37-8.16-8.67-12.3-12.89 c-0.05-0.06-0.11-0.11-0.16-0.16c-0.12-0.13-0.25-0.24-0.37-0.37c-4.11-4.18-8.25-8.29-12.44-12.3c-4.22-4.05-8.48-8-12.79-11.89 c-0.12-0.11-0.23-0.22-0.34-0.32c-0.05-0.05-0.11-0.1-0.16-0.15c-4.49-4.04-9.02-8-13.6-11.86c-4.07-3.43-8.17-6.76-12.3-10.04 c-0.27-0.22-0.54-0.44-0.81-0.67c-0.12-0.09-0.23-0.19-0.35-0.28c-4.45-3.52-8.93-6.93-13.44-10.26 c-4.35-3.19-8.72-6.31-13.12-9.32c-0.11-0.07-0.22-0.14-0.32-0.22c-0.15-0.1-0.31-0.2-0.46-0.3c-4.03-2.76-8.1-5.45-12.18-8.05 c-4.26-2.71-8.53-5.33-12.84-7.86c-0.99-0.58-1.99-1.16-2.98-1.74c-3.25-1.88-6.5-3.69-9.73-5.44c-4.2-2.27-8.38-4.44-12.53-6.49 c-2.68-1.33-5.33-2.53-7.99-3.77c-0.66-0.31-1.33-0.63-1.99-0.93c-0.79-0.37-1.59-0.78-2.38-1.13c-4.1-1.84-8.17-3.57-12.22-5.19 c-4.14-1.65-8.25-3.21-12.33-4.64c-0.69-0.24-1.37-0.44-2.05-0.68c-0.63-0.21-1.26-0.4-1.89-0.61c-2.78-0.94-5.57-1.9-8.32-2.73 c-4.22-1.28-8.4-2.43-12.55-3.46c-2-0.5-3.97-0.88-5.96-1.32c-0.91-0.21-1.82-0.42-2.73-0.61c-1.34-0.29-2.71-0.64-4.05-0.9 c-4.38-0.85-8.72-1.56-13.01-2.15c-2.75-0.37-5.43-0.57-8.14-0.83c-0.96-0.09-1.94-0.22-2.89-0.29 c-0.92-0.08-1.87-0.22-2.79-0.29c-4.86-0.33-9.66-0.49-14.38-0.47c-2.09,0.01-4.1,0.21-6.15,0.28c-1.49,0.06-2.97,0.12-4.44,0.21 c-1.58,0.1-3.2,0.09-4.75,0.22c-5.92,0.53-11.72,1.36-17.38,2.47c-0.21,0.04-0.39,0.12-0.6,0.17c-1.92,0.39-3.7,1.06-5.59,1.52 c-5.2,1.25-10.43,2.44-15.38,4.19c-0.5,0.17-0.93,0.47-1.42,0.65c-8.2,2.98-16.11,6.53-23.57,10.86L910.63,169.44 c7.45-4.33,15.36-7.87,23.55-10.86c5.4-1.97,11.03-3.46,16.73-4.82c1.92-0.46,3.73-1.16,5.69-1.55 c7.34-1.48,14.94-2.37,22.72-2.86c1.48-0.09,2.96-0.15,4.45-0.21c7.59-0.29,15.34-0.19,23.29,0.47c0.99,0.08,1.99,0.21,2.98,0.3 c8.21,0.8,16.58,2.06,25.13,3.87c0.92,0.19,1.85,0.41,2.77,0.62c8.79,1.97,17.74,4.45,26.84,7.51c0.6,0.2,1.21,0.38,1.81,0.59 c9.52,3.27,19.2,7.15,29.02,11.63c0.66,0.3,1.33,0.63,1.99,0.94c9.96,4.62,20.04,9.8,30.25,15.7 c9.41,5.43,18.72,11.32,27.91,17.59c0.2,0.13,0.39,0.25,0.59,0.39C1165.57,215.06,1174.65,221.76,1183.59,228.83z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 1428.392,
    x2: 1933.202,
    y1: 757.069,
    y2: 757.069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c2cecf",
    className: "stopColorc2c3cf svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7b999b",
    className: "stopColor7b839b svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M1933.1,831.22c-0.08-2.79-0.22-5.59-0.39-8.41c-0.18-2.81-0.4-5.62-0.67-8.45 c-0.27-2.83-0.59-5.67-0.95-8.52c-0.37-2.91-0.78-5.82-1.25-8.74c-0.02-0.13-0.05-0.26-0.07-0.39c-0.01-0.07-0.02-0.13-0.03-0.19 c-0.44-2.73-0.9-5.47-1.42-8.2c-0.57-3.02-1.18-6.04-1.84-9.07c-0.66-3.03-1.37-6.07-2.12-9.11c-0.76-3.08-1.57-6.16-2.43-9.24 c-0.69-2.5-1.43-4.99-2.19-7.48c-0.05-0.16-0.09-0.31-0.14-0.46c-0.13-0.42-0.24-0.84-0.37-1.25c-0.92-3.01-1.88-6-2.89-9 c-0.99-2.97-2.02-5.93-3.09-8.88c-1.03-2.86-2.1-5.7-3.21-8.54c-1.1-2.83-2.24-5.66-3.41-8.48c-0.93-2.25-1.91-4.49-2.89-6.73 c-0.06-0.14-0.12-0.28-0.18-0.42c-0.17-0.39-0.33-0.79-0.5-1.18c-1.25-2.82-2.52-5.62-3.83-8.42c-1.45-3.08-2.93-6.16-4.46-9.22 c-1.74-3.48-3.53-6.94-5.37-10.38c-2.09-3.92-4.3-7.79-6.52-11.65c-0.28-0.49-0.54-0.99-0.83-1.48 c-0.32-0.55-0.62-1.13-0.94-1.69c-4.26-7.28-8.75-14.42-13.42-21.42c-3.55-5.31-7.22-10.53-11-15.65 c-0.02-0.03-0.04-0.06-0.06-0.08c-0.01-0.02-0.02-0.03-0.03-0.04c-2.5-3.39-5.05-6.73-7.64-10.03c-2.21-2.82-4.46-5.59-6.74-8.33 c-2.22-2.67-4.48-5.31-6.76-7.91c-2.24-2.55-4.51-5.06-6.8-7.53c-0.47-0.5-0.94-0.98-1.41-1.48c-0.19-0.21-0.39-0.4-0.58-0.6 c-1.71-1.82-3.42-3.64-5.16-5.41c-2.43-2.47-4.88-4.9-7.36-7.28c-2.54-2.44-5.1-4.82-7.69-7.15c-2.57-2.32-5.16-4.58-7.78-6.78 c-1.31-1.1-2.63-2.15-3.95-3.22c-0.3-0.24-0.59-0.49-0.89-0.73c-0.98-0.79-1.95-1.62-2.93-2.4c-2.54-2-5.09-3.95-7.67-5.85 c-2.52-1.85-5.04-3.65-7.59-5.4c-2.46-1.69-4.93-3.32-7.41-4.9c-2.45-1.56-4.91-3.07-7.39-4.52c-0.57-0.34-1.14-0.67-1.71-1 c-1.84-1.06-3.67-2.09-5.49-3.07c-2.35-1.28-4.7-2.48-7.03-3.64c-2.33-1.15-4.65-2.25-6.95-3.28c-0.06-0.03-0.13-0.06-0.19-0.08 c-0.07-0.03-0.13-0.06-0.2-0.08c-2.19-0.98-4.37-1.9-6.53-2.77c-2.33-0.93-4.64-1.8-6.94-2.61c-1.66-0.59-3.29-1.1-4.93-1.61 c-0.3-0.09-0.6-0.21-0.9-0.29c-0.39-0.12-0.79-0.27-1.18-0.39c-2.39-0.72-4.77-1.38-7.12-1.96c-2.45-0.62-4.89-1.15-7.3-1.62 c-0.6-0.12-1.18-0.18-1.77-0.29c-0.48-0.09-0.96-0.16-1.44-0.24c-1.45-0.24-2.91-0.52-4.34-0.72c-2.66-0.36-5.29-0.63-7.89-0.82 c-1.48-0.11-2.95-0.18-4.41-0.23l-256.16,148.86c5.4,0.18,10.97,0.8,16.65,1.76c0.47,0.08,0.94,0.15,1.42,0.23 c5.66,1.03,11.44,2.43,17.34,4.26c0.32,0.11,0.65,0.22,0.98,0.32c6.01,1.91,12.12,4.21,18.35,6.98c0.07,0.03,0.13,0.06,0.2,0.09 c6.45,2.88,13.01,6.23,19.66,10.07c11.89,6.87,23.49,14.97,34.71,24.07c0.29,0.23,0.58,0.47,0.87,0.71 c11.07,9.03,21.76,19.04,31.95,29.86c0.19,0.2,0.39,0.4,0.58,0.6c10.33,11.01,20.15,22.83,29.34,35.27 c0.01,0.01,0.02,0.03,0.03,0.04c9.14,12.39,17.64,25.42,25.43,38.85c0.28,0.48,0.53,0.96,0.8,1.44 c7.64,13.28,14.6,26.95,20.7,40.86c0.06,0.14,0.12,0.28,0.18,0.42c6.18,14.14,11.5,28.51,15.86,42.89 c0.05,0.16,0.09,0.31,0.14,0.47c4.34,14.41,7.71,28.84,9.99,43.1c0.01,0.07,0.02,0.13,0.03,0.2c2.28,14.36,3.47,28.54,3.43,42.35 c-0.01,2.33-0.17,4.35-0.33,6.44c-0.09,1.21-0.19,2.47-0.24,3.69c-0.02,0.59-0.04,1.18-0.04,1.77c0,0.03,0,0.06,0,0.09l0,0l0,0 l256.16-148.86c0.01-1.86,0.14-3.75,0.29-5.56c0.11-1.42,0.22-2.8,0.28-4.31c0.03-0.65,0.05-1.33,0.05-2.02c0-0.04,0-0.07,0-0.11 C1933.21,836.46,1933.17,833.84,1933.1,831.22z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 1676.428,
    x2: 2166.424,
    y1: 1143.145,
    y2: 1143.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c2cecf",
    className: "stopColorc2c3cf svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7b999b",
    className: "stopColor7b839b svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M2166.32,1166.48c-0.08-2.8-0.22-5.61-0.39-8.43s-0.4-5.65-0.67-8.48c-0.27-2.84-0.59-5.68-0.95-8.54 c-0.37-2.91-0.78-5.83-1.25-8.75c-0.01-0.09-0.03-0.18-0.05-0.28c-0.01-0.06-0.02-0.12-0.03-0.18c-0.44-2.78-0.92-5.57-1.44-8.36 c-0.57-3.02-1.18-6.06-1.84-9.09c-0.66-3.04-1.37-6.08-2.13-9.13c-0.77-3.08-1.57-6.16-2.43-9.24c-0.67-2.4-1.38-4.8-2.1-7.2 c-0.06-0.21-0.12-0.41-0.18-0.62c-0.14-0.47-0.26-0.93-0.41-1.39c-0.92-3.01-1.88-6.01-2.89-9.01c-0.99-2.96-2.02-5.92-3.09-8.88 c-1.03-2.84-2.1-5.68-3.2-8.51c-1.1-2.82-2.23-5.63-3.4-8.45c-0.9-2.17-1.85-4.35-2.8-6.51c-0.07-0.18-0.15-0.34-0.22-0.51 c-0.19-0.44-0.37-0.88-0.56-1.31c-1.24-2.81-2.52-5.62-3.83-8.42c-1.44-3.06-2.91-6.11-4.43-9.14c-1.74-3.49-3.53-6.96-5.37-10.4 c-2.03-3.8-4.18-7.55-6.33-11.29c-0.35-0.62-0.68-1.23-1.03-1.84c-0.43-0.74-0.82-1.51-1.26-2.25c-4.14-7.03-8.48-13.94-13-20.7 c-3.55-5.31-7.22-10.54-10.99-15.66c-0.02-0.02-0.03-0.04-0.05-0.06c-0.02-0.03-0.04-0.04-0.06-0.08 c-2.49-3.37-5.03-6.71-7.62-9.99c-2.2-2.8-4.44-5.57-6.7-8.29c-2.22-2.67-4.47-5.31-6.75-7.9c-2.24-2.56-4.51-5.06-6.8-7.54 c-0.47-0.51-0.96-1-1.44-1.51c-0.21-0.22-0.41-0.43-0.61-0.64c-1.69-1.79-3.38-3.59-5.1-5.34c-2.43-2.48-4.89-4.91-7.38-7.3 c-2.54-2.43-5.1-4.81-7.69-7.14c-2.57-2.32-5.16-4.58-7.78-6.79c-1.33-1.12-2.68-2.19-4.02-3.28c-0.3-0.24-0.59-0.48-0.88-0.72 c-0.96-0.78-1.91-1.59-2.88-2.35c-2.55-2.01-5.11-3.97-7.69-5.87c-2.52-1.86-5.06-3.67-7.62-5.42c-2.47-1.69-4.95-3.33-7.45-4.92 c-2.46-1.57-4.94-3.08-7.42-4.54c-0.57-0.34-1.15-0.68-1.72-1.01c-1.7-0.98-3.41-1.93-5.1-2.85c-2.24-1.21-4.46-2.36-6.69-3.46 c-2.27-1.12-4.53-2.19-6.79-3.19c-2.32-1.04-4.64-2.02-6.93-2.94c-1.64-0.66-3.27-1.25-4.9-1.85c-0.22-0.08-0.44-0.17-0.65-0.24 c-0.52-0.19-1.05-0.4-1.56-0.59c-2.46-0.87-4.91-1.66-7.33-2.4c-2.56-0.78-5.09-1.48-7.6-2.1c-2.67-0.67-5.31-1.25-7.91-1.76 c-1.45-0.28-2.89-0.54-4.32-0.77l-256.16,148.86c9.2,1.51,18.83,4.03,28.73,7.62c0.22,0.08,0.44,0.17,0.65,0.25 c9.9,3.63,20.08,8.34,30.4,14.29c11.93,6.89,23.56,15.02,34.81,24.12c0.29,0.23,0.57,0.47,0.86,0.7 c11.09,9.04,21.78,19.06,31.97,29.87c0.2,0.21,0.41,0.42,0.61,0.64c10.32,11,20.14,22.8,29.32,35.23 c0.02,0.03,0.04,0.05,0.06,0.07c9.1,12.33,17.54,25.31,25.3,38.67c0.35,0.61,0.68,1.23,1.03,1.84 c7.57,13.19,14.47,26.76,20.52,40.56c0.07,0.17,0.14,0.34,0.22,0.51c6.15,14.1,11.44,28.41,15.78,42.75 c0.06,0.21,0.12,0.42,0.18,0.62c4.32,14.39,7.68,28.78,9.95,43.02c0.01,0.06,0.02,0.12,0.03,0.18 c2.28,14.36,3.46,28.54,3.42,42.35c-0.04,13.55-1.29,26.07-3.56,37.59c-0.07,0.35-0.14,0.7-0.21,1.05 c-2.3,11.31-5.62,21.61-9.88,30.8c-0.08,0.17-0.14,0.35-0.22,0.51c-3.62,7.73-8.27,14.19-13.14,20.32 c-1.6,2.02-3.12,4.15-4.84,5.99c-5.78,6.16-12.03,11.64-19.1,15.75l256.16-148.86c7.08-4.11,13.32-9.59,19.1-15.75 c1.74-1.85,3.24-3.97,4.84-5.99c2.09-2.63,4.44-4.89,6.31-7.81c2.39-3.75,4.59-7.73,6.59-11.95c0.08-0.18,0.15-0.37,0.23-0.55 c0.08-0.18,0.14-0.35,0.22-0.53c1.32-2.86,2.59-5.79,3.74-8.86c1.11-2.97,2.12-6.04,3.05-9.2c0.85-2.89,1.63-5.87,2.32-8.92 c0.29-1.24,0.51-2.55,0.77-3.82c0.07-0.35,0.14-0.7,0.21-1.05c0.24-1.23,0.52-2.42,0.74-3.67c0.47-2.73,0.89-5.51,1.25-8.35 c0.35-2.75,0.64-5.55,0.87-8.4c0.22-2.7,0.39-5.45,0.51-8.24c0.12-2.77,0.18-5.58,0.2-8.44c0-0.17,0-0.33,0-0.5 C2166.43,1171.74,2166.39,1169.12,2166.32,1166.48z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 1078.468,
    x2: 1475.049,
    y1: 1050.183,
    y2: 561.712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cbd5d6",
    className: "stopColorcbcbd6 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9fafa",
    className: "stopColorf9faf9 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M1127.86,190.78c152.86,88.26,278.96,290.93,300.53,472.31c22.66,0.73,47.91,8.3,74.6,23.71 c96.3,55.6,174.36,190.47,174.05,301.13c-0.01,4.34-0.6,8-0.62,12c18.59,3.05,38.9,10.11,59.79,22.17 c96.59,55.77,174.36,190.47,174.05,301.13c-0.31,110.65-78.59,155.6-175.19,99.83c-3.48-2.01-6.67-4.52-10.15-6.53L792.67,878.28 c-3.48-2.01-6.96-3.35-10.44-5.36c-3.48-2.01-6.67-4.52-10.15-6.53l-4.35-2.51C637.8,779.85,535.18,596.75,535.61,445.43 c0.45-156.99,111.61-220.34,248.23-141.46c13.34,7.7,26.39,16.91,39.44,26.78C839.15,162.63,969.49,99.34,1127.86,190.78z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1d2f30",
    d: "M1813.44,1406.4c-17,0-37.07-6.39-58.05-18.51l-2.59-1.7c-2.47-1.68-4.97-3.33-7.55-4.83L812.98,843.13 c-2.56-1.52-5.29-2.87-8.04-4.17l-2.4-1.19l-2.54-1.68c-2.49-1.7-5.01-3.36-7.6-4.85l-4.36-2.52 c-116.38-75.33-212.21-247.71-211.81-383.19c0.23-84.47,36.35-134.87,96.61-134.87c27.07,0,58.43,9.84,90.69,28.47 c10.16,5.88,21.36,13.5,35.25,24.01l58.08,43.97l6.85-72.53c8.7-92.23,55.02-145.11,127.09-145.11 c35.06,0,75.42,12.61,116.76,36.46c139.56,80.55,260.16,270.54,280.54,441.94l4.1,34.62l34.88,1.17 c16.62,0.54,35.83,6.85,55.6,18.28c83.6,48.28,154.04,170.03,153.76,265.85c0,1.07-0.12,2.17-0.19,3.24 c-0.23,2.87-0.42,5.69-0.44,8.65l-0.19,34.69l34.23,5.62c14.97,2.45,30.47,8.25,46.09,17.25 c83.6,48.28,154.01,170.03,153.71,265.85C1869.58,1348.14,1863.98,1406.4,1813.44,1406.4z",
    className: "color1d2330 svgShape"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "f",
    d: "M1813.44,1406.4c-17,0-37.07-6.39-58.05-18.51l-2.59-1.7c-2.47-1.68-4.97-3.33-7.55-4.83L812.98,843.13 c-2.56-1.52-5.29-2.87-8.04-4.17l-2.4-1.19l-2.54-1.68c-2.49-1.7-5.01-3.36-7.6-4.85l-4.36-2.52 c-116.38-75.33-212.21-247.71-211.81-383.19c0.23-84.47,36.35-134.87,96.61-134.87c27.07,0,58.43,9.84,90.69,28.47 c10.16,5.88,21.36,13.5,35.25,24.01l58.08,43.97l6.85-72.53c8.7-92.23,55.02-145.11,127.09-145.11 c35.06,0,75.42,12.61,116.76,36.46c139.56,80.55,260.16,270.54,280.54,441.94l4.1,34.62l34.88,1.17 c16.62,0.54,35.83,6.85,55.6,18.28c83.6,48.28,154.04,170.03,153.76,265.85c0,1.07-0.12,2.17-0.19,3.24 c-0.23,2.87-0.42,5.69-0.44,8.65l-0.19,34.69l34.23,5.62c14.97,2.45,30.47,8.25,46.09,17.25 c83.6,48.28,154.01,170.03,153.71,265.85C1869.58,1348.14,1863.98,1406.4,1813.44,1406.4z",
    fill: "#000000",
    className: "color000000 svgShape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#f"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)",
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 3413.151,
    x2: 3985.985,
    y1: 695.992,
    y2: 695.992,
    gradientTransform: "matrix(-1 0 0 1 4662.933 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#819ea0",
    className: "stopColor8188a0 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#628082",
    className: "stopColor626282 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#h)",
    points: "939.81 861.61 1249.78 683.74 986.92 530.37 676.95 708.24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 3723.12,
    x2: 3985.985,
    y1: 812.861,
    y2: 812.861,
    gradientTransform: "matrix(-1 0 0 1 4662.933 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b5b5e",
    className: "stopColor3b3e5e svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#628082",
    className: "stopColor626282 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#i)",
    points: "676.95 708.24 676.95 764.11 939.81 917.48 939.81 861.61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 3413.151,
    x2: 3723.12,
    y1: 800.609,
    y2: 800.609,
    gradientTransform: "matrix(-1 0 0 1 4662.933 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b5b5e",
    className: "stopColor3b3e5e svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#628082",
    className: "stopColor626282 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#j)",
    points: "1249.78 683.74 1249.78 739.6 939.81 917.48 939.81 861.61"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 3444.598,
    x2: 3954.665,
    y1: 259.141,
    y2: 259.141,
    gradientTransform: "matrix(-1 0 0 1 4662.933 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#819ea0",
    className: "stopColor8188a0 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#628082",
    className: "stopColor626282 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#k)",
    points: "942.33 406.62 1218.34 248.23 984.27 111.67 708.27 270.05"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 3541.292,
    x2: 4294.255,
    y1: 219.81,
    y2: 201.395,
    gradientTransform: "matrix(-1 0 0 1 4662.933 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b5b5e",
    className: "stopColor3b3e5e svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#527174",
    className: "stopColor525474 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#l)",
    points: "770.19 270.27 787.87 280.59 984.14 167.99 1138.81 258.07 1156.33 248.06 984.14 147.5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 3698.843,
    x2: 3700.356,
    y1: 359.381,
    y2: 177.763,
    gradientTransform: "matrix(-1 0 0 1 4662.933 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#819ea0",
    className: "stopColor8188a0 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#628082",
    className: "stopColor626282 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#m)",
    points: "787.87 280.59 942.38 370.83 1138.81 258.07 984.14 167.99"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 3720.603,
    x2: 3954.665,
    y1: 555.095,
    y2: 555.095,
    gradientTransform: "matrix(-1 0 0 1 4662.933 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b5b5e",
    className: "stopColor3b3e5e svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#628082",
    className: "stopColor626282 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#n)",
    points: "708.27 270.05 708.27 703.57 942.33 840.14 942.33 406.62"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 3444.598,
    x2: 3720.603,
    y1: 544.185,
    y2: 544.185,
    gradientTransform: "matrix(-1 0 0 1 4662.933 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b5b5e",
    className: "stopColor3b3e5e svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#152728",
    className: "stopColor151828 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#o)",
    points: "1218.34 248.23 1218.34 681.75 942.33 840.14 942.33 406.62"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 3837.591,
    x2: 3837.591,
    y1: 373.383,
    y2: 709.811,
    gradientTransform: "matrix(-1 0 0 1 4662.933 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b5b5e",
    className: "stopColor3b3e5e svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#152728",
    className: "stopColor151828 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#p)",
    points: "743.42 331.14 743.42 683.47 907.26 779.07 907.26 760.99 759.15 674.55 759.15 340.3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 3861.743,
    x2: 3799.423,
    y1: 684.46,
    y2: 423.991,
    gradientTransform: "matrix(-1 0 0 1 4662.933 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b5b5e",
    className: "stopColor3b3e5e svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#628082",
    className: "stopColor626282 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#q)",
    points: "759.15 340.3 759.15 674.55 907.26 760.99 907.26 426.74"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 3841.897,
    x2: 3830.722,
    y1: 749.27,
    y2: 702.563,
    gradientTransform: "matrix(-1 0 0 1 4662.933 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#819ea0",
    className: "stopColor8188a0 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#628082",
    className: "stopColor626282 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#r)",
    points: "759.15 674.55 743.42 683.47 907.26 779.07 907.26 760.99"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 3829.06,
    x2: 3829.06,
    y1: 1941.544,
    y2: 1982.773,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b5b5e",
    className: "stopColor3b3e5e svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#152728",
    className: "stopColor151828 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#s)",
    points: "766.06 403.86 901.69 483.46 901.69 428.56 766.06 348.96"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 3790.209,
    x2: 3765.072,
    y1: 1918.024,
    y2: 1966.767,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#t)",
    points: "884.1 435.94 893.62 441.53 893.62 432.01 884.1 426.42",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 3801.86,
    x2: 3776.723,
    y1: 1924.032,
    y2: 1972.776,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#u)",
    points: "869.35 427.29 878.87 432.87 878.87 423.35 869.35 417.76"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 3813.51,
    x2: 3788.374,
    y1: 1930.04,
    y2: 1978.784,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#v)",
    points: "854.6 418.63 864.12 424.22 864.12 414.7 854.6 409.11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 3825.161,
    x2: 3800.024,
    y1: 1936.049,
    y2: 1984.792,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#w)",
    points: "839.85 409.97 849.37 415.56 849.37 406.04 839.85 400.45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 3836.812,
    x2: 3811.675,
    y1: 1942.057,
    y2: 1990.8,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#x)",
    points: "825.1 401.32 834.62 406.91 834.62 397.38 825.1 391.8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 3795.671,
    x2: 3770.534,
    y1: 1920.841,
    y2: 1969.584,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#y)",
    points: "884.1 449.35 893.62 454.94 893.62 445.42 884.1 439.83",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 3807.322,
    x2: 3782.185,
    y1: 1926.849,
    y2: 1975.592,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#z)",
    points: "869.35 440.69 878.87 446.28 878.87 436.76 869.35 431.17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 3818.972,
    x2: 3793.835,
    y1: 1932.857,
    y2: 1981.601,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#A)",
    points: "854.6 432.04 864.12 437.63 864.12 428.1 854.6 422.52",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: 3830.623,
    x2: 3805.486,
    y1: 1938.865,
    y2: 1987.609,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#B)",
    points: "839.85 423.38 849.37 428.97 849.37 419.45 839.85 413.86",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: 3842.274,
    x2: 3817.137,
    y1: 1944.874,
    y2: 1993.617,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#C)",
    points: "825.1 414.73 834.62 420.31 834.62 410.79 825.1 405.21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    x1: 3801.133,
    x2: 3775.996,
    y1: 1923.657,
    y2: 1972.401,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#D)",
    points: "884.1 462.76 893.62 468.35 893.62 458.83 884.1 453.24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    x1: 3812.784,
    x2: 3787.647,
    y1: 1929.666,
    y2: 1978.409,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#E)",
    points: "869.35 454.1 878.87 459.69 878.87 450.17 869.35 444.58"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    x1: 3824.434,
    x2: 3799.298,
    y1: 1935.674,
    y2: 1984.417,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#F)",
    points: "854.6 445.45 864.12 451.03 864.12 441.51 854.6 435.93"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    x1: 3836.085,
    x2: 3810.948,
    y1: 1941.682,
    y2: 1990.426,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#G)",
    points: "839.85 436.79 849.37 442.38 849.37 432.86 839.85 427.27"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "H",
    x1: 3847.736,
    x2: 3822.599,
    y1: 1947.69,
    y2: 1996.434,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#H)",
    points: "825.1 428.13 834.62 433.72 834.62 424.2 825.1 418.61",
    opacity: 0.41
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#17cedd",
    points: "773.89 361.73 773.89 398.01 817.35 423.65 817.35 418.94 778.1 395.91 778.1 364.2",
    className: "colordd6b17 svgShape"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "I",
    x1: 3865.207,
    x2: 3865.207,
    y1: 369.364,
    y2: 410.476,
    gradientTransform: "matrix(-1 0 0 1 4662.933 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0ce8fa",
    className: "stopColorfabb0c svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19e8f8",
    className: "stopColorf88019 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#I)",
    points: "778.1 364.2 778.1 395.91 817.35 418.94 817.35 387.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#079eaa",
    points: "778.1 395.91 773.89 398.01 773.89 361.73 778.1 364.2",
    className: "coloraa4907 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "J",
    x1: 3829.06,
    x2: 3829.06,
    y1: 2008.791,
    y2: 2050.019,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b5b5e",
    className: "stopColor3b3e5e svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#152728",
    className: "stopColor151828 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#J)",
    points: "766.06 471.1 901.69 550.7 901.69 495.81 766.06 416.21"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "K",
    x1: 3790.209,
    x2: 3765.072,
    y1: 1985.27,
    y2: 2034.014,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#K)",
    points: "884.1 503.19 893.62 508.78 893.62 499.25 884.1 493.67",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "L",
    x1: 3801.86,
    x2: 3776.723,
    y1: 1991.278,
    y2: 2040.022,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#L)",
    points: "869.35 494.53 878.87 500.12 878.87 490.6 869.35 485.01"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "M",
    x1: 3813.51,
    x2: 3788.374,
    y1: 1997.287,
    y2: 2046.03,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#M)",
    points: "854.6 485.88 864.12 491.46 864.12 481.94 854.6 476.36"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "N",
    x1: 3825.161,
    x2: 3800.024,
    y1: 2003.295,
    y2: 2052.039,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#N)",
    points: "839.85 477.22 849.37 482.81 849.37 473.29 839.85 467.7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "O",
    x1: 3836.812,
    x2: 3811.675,
    y1: 2009.303,
    y2: 2058.047,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#O)",
    points: "825.1 468.56 834.62 474.15 834.62 464.63 825.1 459.04"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    x1: 3795.671,
    x2: 3770.534,
    y1: 1988.087,
    y2: 2036.83,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#P)",
    points: "884.1 516.6 893.62 522.18 893.62 512.66 884.1 507.08",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Q",
    x1: 3807.322,
    x2: 3782.185,
    y1: 1994.095,
    y2: 2042.839,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#Q)",
    points: "869.35 507.94 878.87 513.53 878.87 504.01 869.35 498.42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "R",
    x1: 3818.972,
    x2: 3793.835,
    y1: 2000.103,
    y2: 2048.847,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#R)",
    points: "854.6 499.28 864.12 504.87 864.12 495.35 854.6 489.76",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "S",
    x1: 3830.623,
    x2: 3805.486,
    y1: 2006.112,
    y2: 2054.855,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#S)",
    points: "839.85 490.63 849.37 496.22 849.37 486.7 839.85 481.11",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "T",
    x1: 3842.274,
    x2: 3817.137,
    y1: 2012.12,
    y2: 2060.863,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#T)",
    points: "825.1 481.97 834.62 487.56 834.62 478.04 825.1 472.45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "U",
    x1: 3801.133,
    x2: 3775.996,
    y1: 1990.904,
    y2: 2039.647,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#U)",
    points: "884.1 530 893.62 535.59 893.62 526.07 884.1 520.48"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "V",
    x1: 3812.784,
    x2: 3787.647,
    y1: 1996.912,
    y2: 2045.656,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#V)",
    points: "869.35 521.35 878.87 526.94 878.87 517.42 869.35 511.83"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "W",
    x1: 3824.434,
    x2: 3799.298,
    y1: 2002.92,
    y2: 2051.664,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#W)",
    points: "854.6 512.69 864.12 518.28 864.12 508.76 854.6 503.17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "X",
    x1: 3836.085,
    x2: 3810.948,
    y1: 2008.928,
    y2: 2057.672,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#X)",
    points: "839.85 504.04 849.37 509.62 849.37 500.1 839.85 494.52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Y",
    x1: 3847.736,
    x2: 3822.599,
    y1: 2014.937,
    y2: 2063.68,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#Y)",
    points: "825.1 495.38 834.62 500.97 834.62 491.45 825.1 485.86",
    opacity: 0.41
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#17cedd",
    points: "773.89 428.97 773.89 465.26 817.35 490.89 817.35 486.19 778.1 463.15 778.1 431.45",
    className: "colordd6b17 svgShape"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Z",
    x1: 3865.207,
    x2: 3865.207,
    y1: 436.61,
    y2: 477.723,
    gradientTransform: "matrix(-1 0 0 1 4662.933 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0ce8fa",
    className: "stopColorfabb0c svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19e8f8",
    className: "stopColorf88019 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#Z)",
    points: "778.1 431.45 778.1 463.15 817.35 486.19 817.35 454.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#079eaa",
    points: "778.1 463.15 773.89 465.26 773.89 428.97 778.1 431.45",
    className: "coloraa4907 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "aa",
    x1: 3829.06,
    x2: 3829.06,
    y1: 2076.037,
    y2: 2117.266,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b5b5e",
    className: "stopColor3b3e5e svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#152728",
    className: "stopColor151828 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#aa)",
    points: "766.06 538.35 901.69 617.95 901.69 563.06 766.06 483.46"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab",
    x1: 3790.209,
    x2: 3765.072,
    y1: 2052.517,
    y2: 2101.26,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#ab)",
    points: "884.1 570.43 893.62 576.02 893.62 566.5 884.1 560.91",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ac",
    x1: 3801.86,
    x2: 3776.723,
    y1: 2058.525,
    y2: 2107.268,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#ac)",
    points: "869.35 561.78 878.87 567.37 878.87 557.85 869.35 552.26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ad",
    x1: 3813.51,
    x2: 3788.374,
    y1: 2064.533,
    y2: 2113.277,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#ad)",
    points: "854.6 553.12 864.12 558.71 864.12 549.19 854.6 543.6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ae",
    x1: 3825.161,
    x2: 3800.024,
    y1: 2070.541,
    y2: 2119.285,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#ae)",
    points: "839.85 544.47 849.37 550.05 849.37 540.53 839.85 534.95"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "af",
    x1: 3836.812,
    x2: 3811.675,
    y1: 2076.55,
    y2: 2125.293,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#af)",
    points: "825.1 535.81 834.62 541.4 834.62 531.88 825.1 526.29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ag",
    x1: 3795.671,
    x2: 3770.534,
    y1: 2055.333,
    y2: 2104.077,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#ag)",
    points: "884.1 583.84 893.62 589.43 893.62 579.91 884.1 574.32",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ah",
    x1: 3807.322,
    x2: 3782.185,
    y1: 2061.342,
    y2: 2110.085,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#ah)",
    points: "869.35 575.19 878.87 580.77 878.87 571.25 869.35 565.67"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai",
    x1: 3818.972,
    x2: 3793.835,
    y1: 2067.35,
    y2: 2116.093,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#ai)",
    points: "854.6 566.53 864.12 572.12 864.12 562.6 854.6 557.01",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aj",
    x1: 3830.623,
    x2: 3805.486,
    y1: 2073.358,
    y2: 2122.102,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#aj)",
    points: "839.85 557.88 849.37 563.46 849.37 553.94 839.85 548.35",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ak",
    x1: 3842.274,
    x2: 3817.137,
    y1: 2079.366,
    y2: 2128.11,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#ak)",
    points: "825.1 549.22 834.62 554.81 834.62 545.29 825.1 539.7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "al",
    x1: 3801.133,
    x2: 3775.996,
    y1: 2058.15,
    y2: 2106.894,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#al)",
    points: "884.1 597.25 893.62 602.84 893.62 593.32 884.1 587.73"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "am",
    x1: 3812.784,
    x2: 3787.647,
    y1: 2064.158,
    y2: 2112.902,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#am)",
    points: "869.35 588.6 878.87 594.18 878.87 584.66 869.35 579.07"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "an",
    x1: 3824.434,
    x2: 3799.298,
    y1: 2070.166,
    y2: 2118.91,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#an)",
    points: "854.6 579.94 864.12 585.53 864.12 576.01 854.6 570.42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ao",
    x1: 3836.085,
    x2: 3810.948,
    y1: 2076.175,
    y2: 2124.918,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#ao)",
    points: "839.85 571.28 849.37 576.87 849.37 567.35 839.85 561.76"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ap",
    x1: 3847.736,
    x2: 3822.599,
    y1: 2082.183,
    y2: 2130.927,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#ap)",
    points: "825.1 562.63 834.62 568.22 834.62 558.69 825.1 553.11",
    opacity: 0.41
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#17cedd",
    points: "773.89 496.22 773.89 532.5 817.35 558.14 817.35 553.43 778.1 530.4 778.1 498.69",
    className: "colordd6b17 svgShape"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aq",
    x1: 3865.207,
    x2: 3865.207,
    y1: 503.857,
    y2: 544.969,
    gradientTransform: "matrix(-1 0 0 1 4662.933 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0ce8fa",
    className: "stopColorfabb0c svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19e8f8",
    className: "stopColorf88019 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#aq)",
    points: "778.1 498.69 778.1 530.4 817.35 553.43 817.35 521.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#079eaa",
    points: "778.1 530.4 773.89 532.5 773.89 496.22 778.1 498.69",
    className: "coloraa4907 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ar",
    x1: 3829.06,
    x2: 3829.06,
    y1: 2143.283,
    y2: 2184.512,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b5b5e",
    className: "stopColor3b3e5e svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#152728",
    className: "stopColor151828 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#ar)",
    points: "766.06 605.6 901.69 685.2 901.69 630.3 766.06 550.7"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "as",
    x1: 3790.209,
    x2: 3765.072,
    y1: 2119.763,
    y2: 2168.506,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#as)",
    points: "884.1 637.68 893.62 643.27 893.62 633.75 884.1 628.16",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "at",
    x1: 3801.86,
    x2: 3776.723,
    y1: 2125.771,
    y2: 2174.515,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#at)",
    points: "869.35 629.02 878.87 634.61 878.87 625.09 869.35 619.5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "au",
    x1: 3813.51,
    x2: 3788.374,
    y1: 2131.779,
    y2: 2180.523,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#au)",
    points: "854.6 620.37 864.12 625.96 864.12 616.44 854.6 610.85"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "av",
    x1: 3825.161,
    x2: 3800.024,
    y1: 2137.788,
    y2: 2186.531,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#av)",
    points: "839.85 611.71 849.37 617.3 849.37 607.78 839.85 602.19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aw",
    x1: 3836.812,
    x2: 3811.675,
    y1: 2143.796,
    y2: 2192.539,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#aw)",
    points: "825.1 603.06 834.62 608.65 834.62 599.12 825.1 593.54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ax",
    x1: 3795.671,
    x2: 3770.534,
    y1: 2122.58,
    y2: 2171.323,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#ax)",
    points: "884.1 651.09 893.62 656.68 893.62 647.16 884.1 641.57",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ay",
    x1: 3807.322,
    x2: 3782.185,
    y1: 2128.588,
    y2: 2177.331,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#ay)",
    points: "869.35 642.43 878.87 648.02 878.87 638.5 869.35 632.91"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "az",
    x1: 3818.972,
    x2: 3793.835,
    y1: 2134.596,
    y2: 2183.34,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#az)",
    points: "854.6 633.78 864.12 639.37 864.12 629.84 854.6 624.26",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aA",
    x1: 3830.623,
    x2: 3805.486,
    y1: 2140.604,
    y2: 2189.348,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#aA)",
    points: "839.85 625.12 849.37 630.71 849.37 621.19 839.85 615.6",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aB",
    x1: 3842.274,
    x2: 3817.137,
    y1: 2146.613,
    y2: 2195.356,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#aB)",
    points: "825.1 616.47 834.62 622.05 834.62 612.53 825.1 606.94"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aC",
    x1: 3801.133,
    x2: 3775.996,
    y1: 2125.396,
    y2: 2174.14,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#aC)",
    points: "884.1 664.5 893.62 670.09 893.62 660.56 884.1 654.98"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aD",
    x1: 3812.784,
    x2: 3787.647,
    y1: 2131.405,
    y2: 2180.148,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#aD)",
    points: "869.35 655.84 878.87 661.43 878.87 651.91 869.35 646.32"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aE",
    x1: 3824.434,
    x2: 3799.298,
    y1: 2137.413,
    y2: 2186.156,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#aE)",
    points: "854.6 647.19 864.12 652.77 864.12 643.25 854.6 637.66"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aF",
    x1: 3836.085,
    x2: 3810.948,
    y1: 2143.421,
    y2: 2192.165,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#aF)",
    points: "839.85 638.53 849.37 644.12 849.37 634.6 839.85 629.01"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aG",
    x1: 3847.736,
    x2: 3822.599,
    y1: 2149.429,
    y2: 2198.173,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#aG)",
    points: "825.1 629.87 834.62 635.46 834.62 625.94 825.1 620.35",
    opacity: 0.41
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#17cedd",
    points: "773.89 563.46 773.89 599.75 817.35 625.39 817.35 620.68 778.1 597.64 778.1 565.94",
    className: "colordd6b17 svgShape"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aH",
    x1: 3865.207,
    x2: 3865.207,
    y1: 571.103,
    y2: 612.215,
    gradientTransform: "matrix(-1 0 0 1 4662.933 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0ce8fa",
    className: "stopColorfabb0c svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19e8f8",
    className: "stopColorf88019 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#aH)",
    points: "778.1 565.94 778.1 597.64 817.35 620.68 817.35 588.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#079eaa",
    points: "778.1 597.64 773.89 599.75 773.89 563.46 778.1 565.94",
    className: "coloraa4907 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "aI",
    x1: 3829.06,
    x2: 3829.06,
    y1: 2210.53,
    y2: 2251.758,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b5b5e",
    className: "stopColor3b3e5e svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#152728",
    className: "stopColor151828 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#aI)",
    points: "766.06 672.84 901.69 752.44 901.69 697.55 766.06 617.95"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "aJ",
    x1: 3790.209,
    x2: 3765.072,
    y1: 2187.009,
    y2: 2235.753,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#aJ)",
    points: "884.1 704.93 893.62 710.52 893.62 700.99 884.1 695.41",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aK",
    x1: 3801.86,
    x2: 3776.723,
    y1: 2193.017,
    y2: 2241.761,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#aK)",
    points: "869.35 696.27 878.87 701.86 878.87 692.34 869.35 686.75"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aL",
    x1: 3813.51,
    x2: 3788.374,
    y1: 2199.026,
    y2: 2247.769,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#aL)",
    points: "854.6 687.62 864.12 693.2 864.12 683.68 854.6 678.09"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aM",
    x1: 3825.161,
    x2: 3800.024,
    y1: 2205.034,
    y2: 2253.777,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#aM)",
    points: "839.85 678.96 849.37 684.55 849.37 675.03 839.85 669.44"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aN",
    x1: 3836.812,
    x2: 3811.675,
    y1: 2211.042,
    y2: 2259.786,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#aN)",
    points: "825.1 670.3 834.62 675.89 834.62 666.37 825.1 660.78"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aO",
    x1: 3795.671,
    x2: 3770.534,
    y1: 2189.826,
    y2: 2238.569,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#aO)",
    points: "884.1 718.34 893.62 723.92 893.62 714.4 884.1 708.81",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aP",
    x1: 3807.322,
    x2: 3782.185,
    y1: 2195.834,
    y2: 2244.578,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#aP)",
    points: "869.35 709.68 878.87 715.27 878.87 705.75 869.35 700.16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aQ",
    x1: 3818.972,
    x2: 3793.835,
    y1: 2201.842,
    y2: 2250.586,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#aQ)",
    points: "854.6 701.02 864.12 706.61 864.12 697.09 854.6 691.5",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aR",
    x1: 3830.623,
    x2: 3805.486,
    y1: 2207.851,
    y2: 2256.594,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#aR)",
    points: "839.85 692.37 849.37 697.96 849.37 688.43 839.85 682.85",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aS",
    x1: 3842.274,
    x2: 3817.137,
    y1: 2213.859,
    y2: 2262.602,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#aS)",
    points: "825.1 683.71 834.62 689.3 834.62 679.78 825.1 674.19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aT",
    x1: 3801.133,
    x2: 3775.996,
    y1: 2192.643,
    y2: 2241.386,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#aT)",
    points: "884.1 731.74 893.62 737.33 893.62 727.81 884.1 722.22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aU",
    x1: 3812.784,
    x2: 3787.647,
    y1: 2198.651,
    y2: 2247.394,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#aU)",
    points: "869.35 723.09 878.87 728.68 878.87 719.15 869.35 713.57"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aV",
    x1: 3824.434,
    x2: 3799.298,
    y1: 2204.659,
    y2: 2253.403,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#aV)",
    points: "854.6 714.43 864.12 720.02 864.12 710.5 854.6 704.91"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aW",
    x1: 3836.085,
    x2: 3810.948,
    y1: 2210.667,
    y2: 2259.411,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#aW)",
    points: "839.85 705.78 849.37 711.36 849.37 701.84 839.85 696.25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aX",
    x1: 3847.736,
    x2: 3822.599,
    y1: 2216.675,
    y2: 2265.419,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#aX)",
    points: "825.1 697.12 834.62 702.71 834.62 693.19 825.1 687.6",
    opacity: 0.41
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#17cedd",
    points: "773.89 630.71 773.89 667 817.35 692.63 817.35 687.93 778.1 664.89 778.1 633.19",
    className: "colordd6b17 svgShape"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aY",
    x1: 3865.207,
    x2: 3865.207,
    y1: 638.349,
    y2: 679.462,
    gradientTransform: "matrix(-1 0 0 1 4662.933 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0ce8fa",
    className: "stopColorfabb0c svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19e8f8",
    className: "stopColorf88019 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#aY)",
    points: "778.1 633.19 778.1 664.89 817.35 687.93 817.35 656.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#079eaa",
    points: "778.1 664.89 773.89 667 773.89 630.71 778.1 633.19",
    className: "coloraa4907 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "aZ",
    x1: 3465.332,
    x2: 3691.45,
    y1: 371.306,
    y2: 371.306,
    gradientTransform: "matrix(-1 0 0 1 4662.93 .065)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#819ea0",
    className: "stopColor8188a0 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#628082",
    className: "stopColor626282 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#aZ)",
    points: "984.96 436.22 1197.6 314.21 1184.11 306.52 971.48 428.54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ba",
    x1: 3684.71,
    x2: 3684.71,
    y1: 412.863,
    y2: 725.346,
    gradientTransform: "matrix(-1 0 0 1 4662.933 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b5b5e",
    className: "stopColor3b3e5e svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#152728",
    className: "stopColor151828 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#ba)",
    points: "971.48 428.54 971.48 762.52 984.96 770.21 984.96 436.22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bb",
    x1: 3544.326,
    x2: 3592.03,
    y1: 715.269,
    y2: 413.146,
    gradientTransform: "matrix(-1 0 0 1 4662.933 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b5b5e",
    className: "stopColor3b3e5e svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#628082",
    className: "stopColor626282 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bb)",
    points: "1197.6 314.21 1197.6 648.19 984.96 770.21 984.96 436.22"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1178.01 534.45 1182.69 531.85 1182.69 529.79 1178.01 532.38",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1178.01 541.93 1182.69 539.34 1182.69 537.27 1178.01 539.86",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1178.01 549.41 1182.69 546.82 1182.69 544.75 1178.01 547.35",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1178.01 556.89 1182.69 554.3 1182.69 552.23 1178.01 554.83",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1178.01 564.38 1182.69 561.78 1182.69 559.72 1178.01 562.31",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1178.01 571.86 1182.69 569.26 1182.69 567.2 1178.01 569.79",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1178.01 579.34 1182.69 576.75 1182.69 574.68 1178.01 577.27",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1178.01 586.82 1182.69 584.23 1182.69 582.16 1178.01 584.76",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1178.01 594.3 1182.69 591.71 1182.69 589.64 1178.01 592.24",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1178.01 601.79 1182.69 599.19 1182.69 597.13 1178.01 599.72",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1178.01 609.27 1182.69 606.67 1182.69 604.61 1178.01 607.2",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1178.01 616.75 1182.69 614.16 1182.69 612.09 1178.01 614.68",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1178.01 624.23 1182.69 621.64 1182.69 619.57 1178.01 622.17",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1178.01 631.71 1182.69 629.12 1182.69 627.05 1178.01 629.65",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1178.01 639.2 1182.69 636.6 1182.69 634.53 1178.01 637.13",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1178.01 646.68 1182.69 644.08 1182.69 642.02 1178.01 644.61",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1163.18 542.67 1167.86 540.08 1167.86 538.01 1163.18 540.61",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1163.18 550.16 1167.86 547.56 1167.86 545.5 1163.18 548.09",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1140.79 562.57 1158.02 553.01 1158.02 550.95 1140.79 560.5",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1119.31 574.48 1136.54 564.93 1136.54 562.86 1119.31 572.41",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1097.83 586.39 1115.06 576.84 1115.06 574.77 1097.83 584.33",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1076.35 598.3 1093.58 588.75 1093.58 586.68 1076.35 596.24",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1054.86 610.21 1072.09 600.66 1072.09 598.59 1054.86 608.15",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1033.38 622.13 1050.61 612.57 1050.61 610.51 1033.38 620.06",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1011.9 634.04 1029.13 624.48 1029.13 622.42 1011.9 631.97",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1137.17 572.06 1158.02 560.5 1158.02 558.43 1137.17 569.99",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1111.17 586.47 1132.02 574.91 1132.02 572.85 1111.17 584.41",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1085.17 600.89 1106.03 589.33 1106.03 587.26 1085.17 598.82",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1059.17 615.31 1080.03 603.74 1080.03 601.68 1059.17 613.24",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1033.18 629.72 1054.03 618.16 1054.03 616.09 1033.18 627.66",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1007.18 644.14 1028.03 632.58 1028.03 630.51 1007.18 642.07",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1140.79 614.94 1158.02 605.39 1158.02 603.32 1140.79 612.88",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1119.31 626.85 1136.54 617.3 1136.54 615.23 1119.31 624.79",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1097.83 638.77 1115.06 629.21 1115.06 627.15 1097.83 636.7",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1076.35 650.68 1093.58 641.12 1093.58 639.06 1076.35 648.61",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1054.86 662.59 1072.09 653.03 1072.09 650.97 1054.86 660.52",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1033.38 674.5 1050.61 664.95 1050.61 662.88 1033.38 672.43",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1011.9 686.41 1029.13 676.86 1029.13 674.79 1011.9 684.35",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1137.17 624.43 1158.02 612.87 1158.02 610.8 1137.17 622.37",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1111.17 638.85 1132.02 627.29 1132.02 625.22 1111.17 636.78",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1085.17 653.26 1106.03 641.7 1106.03 639.64 1085.17 651.2",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1059.17 667.68 1080.03 656.12 1080.03 654.05 1059.17 665.61",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1033.18 682.1 1054.03 670.53 1054.03 668.47 1033.18 680.03",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1007.18 696.51 1028.03 684.95 1028.03 682.88 1007.18 694.45",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1140.79 577.53 1158.02 567.98 1158.02 565.91 1140.79 575.47",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1119.31 589.44 1136.54 579.89 1136.54 577.82 1119.31 587.38",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1097.83 601.36 1115.06 591.8 1115.06 589.74 1097.83 599.29",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1140.79 644.87 1158.02 635.32 1158.02 633.25 1140.79 642.8",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1119.31 656.78 1136.54 647.23 1136.54 645.16 1119.31 654.72",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1097.83 668.69 1115.06 659.14 1115.06 657.07 1097.83 666.63",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1076.35 680.6 1093.58 671.05 1093.58 668.98 1076.35 678.54",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1054.86 692.52 1072.09 682.96 1072.09 680.9 1054.86 690.45",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1033.38 704.43 1050.61 694.87 1050.61 692.81 1033.38 702.36",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1011.9 716.34 1029.13 706.79 1029.13 704.72 1011.9 714.27",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1137.17 654.36 1158.02 642.8 1158.02 640.73 1137.17 652.29",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1111.17 668.78 1132.02 657.21 1132.02 655.15 1111.17 666.71",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1085.17 683.19 1106.03 671.63 1106.03 669.56 1085.17 681.13",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1059.17 697.61 1080.03 686.05 1080.03 683.98 1059.17 695.54",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1033.18 712.02 1054.03 700.46 1054.03 698.39 1033.18 709.96",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1007.18 726.44 1028.03 714.88 1028.03 712.81 1007.18 724.37",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1140.79 659.83 1158.02 650.28 1158.02 648.21 1140.79 657.77",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1119.31 671.75 1136.54 662.19 1136.54 660.13 1119.31 669.68",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1097.83 683.66 1115.06 674.1 1115.06 672.04 1097.83 681.59",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1163.18 557.64 1167.86 555.04 1167.86 552.98 1163.18 555.57",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1163.18 565.12 1167.86 562.53 1167.86 560.46 1163.18 563.05",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1163.18 572.6 1167.86 570.01 1167.86 567.94 1163.18 570.54",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#599499",
    points: "1141.93 591.86 1167.86 577.49 1167.86 575.42 1141.93 589.8",
    className: "color998359 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1113.22 607.78 1139.14 593.41 1139.14 591.34 1113.22 605.72",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1084.51 623.71 1110.43 609.33 1110.43 607.27 1084.51 621.64",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#599499",
    points: "1141.93 636.76 1167.86 622.38 1167.86 620.32 1141.93 634.69",
    className: "color998359 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1113.22 652.68 1139.14 638.3 1139.14 636.24 1113.22 650.61",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1084.51 668.6 1110.43 654.22 1110.43 652.16 1084.51 666.53",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1163.18 587.57 1167.86 584.97 1167.86 582.91 1163.18 585.5",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1163.18 595.05 1167.86 592.45 1167.86 590.39 1163.18 592.98",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1163.18 602.53 1167.86 599.94 1167.86 597.87 1163.18 600.46",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1163.18 610.01 1167.86 607.42 1167.86 605.35 1163.18 607.95",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1163.18 617.49 1167.86 614.9 1167.86 612.83 1163.18 615.43",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1163.18 632.46 1167.86 629.86 1167.86 627.8 1163.18 630.39",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1163.18 639.94 1167.86 637.35 1167.86 635.28 1163.18 637.87",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1163.18 647.42 1167.86 644.83 1167.86 642.76 1163.18 645.36",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1163.18 654.9 1167.86 652.31 1167.86 650.24 1163.18 652.84",
    className: "color99a7c6 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1103.31 397.24 1106.79 395.27 1106.79 392.57 1103.31 394.54",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1103.31 403.83 1106.79 401.86 1106.79 399.15 1103.31 401.12",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1103.31 410.42 1106.79 408.44 1106.79 405.74 1103.31 407.71",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1103.31 417 1106.79 415.03 1106.79 412.32 1103.31 414.3",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1103.31 423.59 1106.79 421.62 1106.79 418.91 1103.31 420.88",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1103.31 430.17 1106.79 428.2 1106.79 425.5 1103.31 427.47",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1103.31 436.76 1106.79 434.79 1106.79 432.08 1103.31 434.06",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1103.31 443.35 1106.79 441.37 1106.79 438.67 1103.31 440.64",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1103.31 449.93 1106.79 447.96 1106.79 445.26 1103.31 447.23",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1103.31 456.52 1106.79 454.55 1106.79 451.84 1103.31 453.81",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1103.31 463.11 1106.79 461.13 1106.79 458.43 1103.31 460.4",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1103.31 469.69 1106.79 467.72 1106.79 465.01 1103.31 466.99",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1103.31 476.28 1106.79 474.3 1106.79 471.6 1103.31 473.57",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1103.31 482.86 1106.79 480.89 1106.79 478.19 1103.31 480.16",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1103.31 489.45 1106.79 487.48 1106.79 484.77 1103.31 486.75",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1103.31 496.04 1106.79 494.06 1106.79 491.36 1103.31 493.33",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1103.31 502.62 1106.79 500.65 1106.79 497.94 1103.31 499.92",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1103.31 509.21 1106.79 507.24 1106.79 504.53 1103.31 506.5",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1103.31 515.8 1106.79 513.82 1106.79 511.12 1103.31 513.09",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1103.31 522.38 1106.79 520.41 1106.79 517.7 1103.31 519.68",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1103.31 528.97 1106.79 526.99 1106.79 524.29 1103.31 526.26",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1103.31 535.55 1106.79 533.58 1106.79 530.88 1103.31 532.85",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1103.31 542.14 1106.79 540.17 1106.79 537.46 1103.31 539.44",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1103.31 548.73 1106.79 546.75 1106.79 544.05 1103.31 546.02",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1103.31 555.31 1106.79 553.34 1106.79 550.63 1103.31 552.61",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1173.89 357.27 1177.37 355.3 1177.37 352.59 1173.89 354.57",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#599499",
    points: "1158.64 365.91 1170.85 358.99 1170.85 356.29 1158.64 363.2",
    className: "color998359 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#599499",
    points: "1143.66 374.39 1155.87 367.48 1155.87 364.77 1143.66 371.69",
    className: "color998359 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#599499",
    points: "1128.67 382.88 1140.88 375.96 1140.88 373.26 1128.67 380.17",
    className: "color998359 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1173.89 363.86 1177.37 361.88 1177.37 359.18 1173.89 361.15",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1173.89 370.44 1177.37 368.47 1177.37 365.77 1173.89 367.74",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1160.94 377.78 1170.18 372.54 1170.18 369.84 1160.94 375.07",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1150.29 383.81 1159.52 378.58 1159.52 375.88 1150.29 381.11",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1139.63 389.85 1148.86 384.62 1148.86 381.91 1139.63 387.14",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1173.89 377.03 1177.37 375.06 1177.37 372.35 1173.89 374.33",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1156.09 387.11 1171.46 378.4 1171.46 375.7 1156.09 384.41",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1138.78 396.91 1154.16 388.21 1154.16 385.5 1138.78 394.21",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1121.47 406.71 1136.85 398.01 1136.85 395.3 1121.47 404.01",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1173.89 383.62 1177.37 381.64 1177.37 378.94 1173.89 380.91",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1160.15 391.4 1171.46 384.99 1171.46 382.29 1160.15 388.69",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1173.89 390.2 1177.37 388.23 1177.37 385.52 1173.89 387.5",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1165.34 395.04 1168.83 393.07 1168.83 390.37 1165.34 392.34",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1173.89 396.79 1177.37 394.82 1177.37 392.11 1173.89 394.08",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1165.34 401.63 1168.83 399.66 1168.83 396.95 1165.34 398.93",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1173.89 403.38 1177.37 401.4 1177.37 398.7 1173.89 400.67",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1165.34 408.22 1168.83 406.24 1168.83 403.54 1165.34 405.51",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1150.29 403.57 1164.18 395.7 1164.18 393 1150.29 400.87",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1145.8 412.7 1164.18 402.29 1164.18 399.58 1145.8 409.99",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1143.64 420.51 1164.18 408.87 1164.18 406.17 1143.64 417.8",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1173.89 409.96 1177.37 407.99 1177.37 405.28 1173.89 407.26",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1160.7 417.43 1164.18 415.46 1164.18 412.75 1160.7 414.73",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1138.36 430.08 1158.93 418.43 1158.93 415.73 1138.36 427.38",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1173.89 416.55 1177.37 414.57 1177.37 411.87 1173.89 413.84",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1173.89 423.13 1177.37 421.16 1177.37 418.46 1173.89 420.43",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1173.89 429.72 1177.37 427.75 1177.37 425.04 1173.89 427.02",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1173.89 436.31 1177.37 434.33 1177.37 431.63 1173.89 433.6",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1173.89 442.89 1177.37 440.92 1177.37 438.21 1173.89 440.19",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1173.89 449.48 1177.37 447.51 1177.37 444.8 1173.89 446.77",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1173.89 456.06 1177.37 454.09 1177.37 451.39 1173.89 453.36",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1173.89 462.65 1177.37 460.68 1177.37 457.97 1173.89 459.95",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1144.85 433 1158.58 425.22 1158.58 422.51 1144.85 430.29",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1129.31 441.79 1143.04 434.02 1143.04 431.31 1129.31 439.09",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1113.77 450.59 1127.51 442.81 1127.51 440.11 1113.77 447.89",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1146.92 438.41 1158.58 431.8 1158.58 429.1 1146.92 435.7",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1133.71 445.89 1145.37 439.28 1145.37 436.58 1133.71 443.18",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1120.5 453.37 1132.16 446.77 1132.16 444.06 1120.5 450.66",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#438c92",
    points: "1144.59 446.31 1158.58 438.39 1158.58 435.68 1144.59 443.61",
    className: "color924443 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1128.73 455.3 1142.72 447.37 1142.72 444.67 1128.73 452.59",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1146.92 451.58 1158.58 444.98 1158.58 442.27 1146.92 448.87",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1132.93 459.5 1144.59 452.9 1144.59 450.2 1132.93 456.8",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1146.92 458.16 1158.58 451.56 1158.58 448.86 1146.92 455.46",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1134.03 465.47 1145.69 458.86 1145.69 456.16 1134.03 462.76",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1121.13 472.77 1132.79 466.17 1132.79 463.46 1121.13 470.06",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1149.23 463.45 1158.58 458.15 1158.58 455.44 1149.23 460.74",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1138.63 469.45 1147.98 464.15 1147.98 461.45 1138.63 466.74",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1128.02 475.45 1137.38 470.15 1137.38 467.45 1128.02 472.75",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1117.42 481.46 1126.78 476.16 1126.78 473.45 1117.42 478.75",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1146.92 471.34 1158.58 464.73 1158.58 462.03 1146.92 468.63",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1134.03 478.64 1145.69 472.04 1145.69 469.33 1134.03 475.93",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1121.13 485.94 1132.79 479.34 1132.79 476.64 1121.13 483.24",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1146.92 477.92 1158.58 471.32 1158.58 468.62 1146.92 475.22",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1133.71 485.4 1145.37 478.8 1145.37 476.1 1133.71 482.7",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1173.89 469.24 1177.37 467.26 1177.37 464.56 1173.89 466.53",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1173.89 475.82 1177.37 473.85 1177.37 471.15 1173.89 473.12",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1173.89 482.41 1177.37 480.44 1177.37 477.73 1173.89 479.7",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1173.89 489 1177.37 487.02 1177.37 484.32 1173.89 486.29",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1173.89 495.58 1177.37 493.61 1177.37 490.9 1173.89 492.88",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1165.34 474.08 1168.83 472.11 1168.83 469.4 1165.34 471.37",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1165.34 480.66 1168.83 478.69 1168.83 475.99 1165.34 477.96",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1165.34 487.25 1168.83 485.28 1168.83 482.57 1165.34 484.55",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1165.34 493.84 1168.83 491.86 1168.83 489.16 1165.34 491.13",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1165.34 500.42 1168.83 498.45 1168.83 495.75 1165.34 497.72",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1146.55 484.72 1163.47 475.14 1163.47 472.43 1146.55 482.01",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1152.75 487.79 1163.47 481.73 1163.47 479.02 1152.75 485.09",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1149.02 496.49 1163.47 488.31 1163.47 485.61 1149.02 493.79",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1151.73 501.55 1163.47 494.9 1163.47 492.19 1151.73 498.84",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1155.76 505.85 1163.47 501.48 1163.47 498.78 1155.76 503.14",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1173.89 502.17 1177.37 500.2 1177.37 497.49 1173.89 499.46",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1173.89 508.75 1177.37 506.78 1177.37 504.08 1173.89 506.05",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1173.89 515.34 1177.37 513.37 1177.37 510.66 1173.89 512.64",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1168.83 505.04 1172.31 503.06 1172.31 500.36 1168.83 502.33",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1168.83 511.62 1172.31 509.65 1172.31 506.94 1168.83 508.92",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1168.83 518.21 1172.31 516.24 1172.31 513.53 1168.83 515.5",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1153.11 513.93 1166.29 506.47 1166.29 503.77 1153.11 511.23",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1157.27 518.17 1166.29 513.06 1166.29 510.35 1157.27 515.46",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1159.7 523.38 1166.29 519.64 1166.29 516.94 1159.7 520.67",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#7b999b",
    points: "1087.68 406.09 1097 400.81 1097 398.11 1087.68 403.39",
    className: "color9a7b9b svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1071.36 415.34 1086.57 406.72 1086.57 404.02 1071.36 412.63",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#438c92",
    points: "1077.63 418.37 1097 407.4 1097 404.69 1077.63 415.67",
    className: "color924443 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#599499",
    points: "1054.49 431.48 1073.87 420.5 1073.87 417.8 1054.49 428.77",
    className: "color998359 svgShape"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bc",
    x1: 3612.208,
    x2: 3631.586,
    y1: -951.484,
    y2: -951.484,
    gradientTransform: "matrix(-1 .5663 0 1 4662.934 -661.86)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1dc1ce",
    className: "stopColor1d7ece svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17838c",
    className: "stopColor17538c svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bc)",
    points: "1031.35 444.58 1050.73 433.61 1050.73 430.9 1031.35 441.87"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bd",
    x1: 3635.348,
    x2: 3654.726,
    y1: -951.484,
    y2: -951.484,
    gradientTransform: "matrix(-1 .5663 0 1 4662.934 -661.86)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1dc1ce",
    className: "stopColor1d7ece svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17838c",
    className: "stopColor17538c svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bd)",
    points: "1008.21 457.68 1027.59 446.71 1027.59 444 1008.21 454.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#7b999b",
    points: "1088.18 418.98 1097 413.98 1097 411.28 1088.18 416.28",
    className: "color9a7b9b svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#438c92",
    points: "1064.18 432.57 1085.82 420.32 1085.82 417.61 1064.18 429.87",
    className: "color924443 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1039.91 446.32 1061.55 434.06 1061.55 431.36 1039.91 443.61",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1068.21 436.88 1089.06 425.07 1089.06 422.37 1068.21 434.17",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#599499",
    points: "1045.18 449.92 1066.03 438.11 1066.03 435.4 1045.18 447.21",
    className: "color998359 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1022.16 462.95 1043.01 451.15 1043.01 448.44 1022.16 460.25",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "999.14 475.99 1019.99 464.18 1019.99 461.48 999.14 473.29",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#7b999b",
    points: "1081.44 435.97 1093.19 429.32 1093.19 426.61 1081.44 433.26",
    className: "color9a7b9b svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1076.92 445.12 1090.28 437.55 1090.28 434.84 1076.92 442.41",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1061.09 454.08 1074.45 446.52 1074.45 443.81 1061.09 451.38",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#7b999b",
    points: "1084.54 447.39 1092.96 442.62 1092.96 439.91 1084.54 444.68",
    className: "color9a7b9b svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#7b999b",
    points: "1089.77 451.01 1097 446.92 1097 444.21 1089.77 448.31",
    className: "color9a7b9b svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#7b999b",
    points: "1086.38 466.1 1097 460.09 1097 457.38 1086.38 463.4",
    className: "color9a7b9b svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1073.9 473.17 1084.52 467.16 1084.52 464.45 1073.9 470.47",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#438c92",
    points: "1077.06 477.97 1093.44 468.69 1093.44 465.99 1077.06 475.26",
    className: "color924443 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#599499",
    points: "1058.98 488.21 1075.35 478.93 1075.35 476.23 1058.98 485.5",
    className: "color998359 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1040.89 498.45 1057.27 489.17 1057.27 486.47 1040.89 495.74",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1022.81 508.69 1039.19 499.41 1039.19 496.71 1022.81 505.98",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1004.73 518.93 1021.11 509.65 1021.11 506.95 1004.73 516.22",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#7b999b",
    points: "1087.45 478.67 1097 473.26 1097 470.56 1087.45 475.97",
    className: "color9a7b9b svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#7b999b",
    points: "1088.87 491.04 1097 486.43 1097 483.73 1088.87 488.34",
    className: "color9a7b9b svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1073.31 499.85 1087.45 491.84 1087.45 489.14 1073.31 497.15",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#438c92",
    points: "1075.35 505.28 1093.44 495.04 1093.44 492.33 1075.35 502.57",
    className: "color924443 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#599499",
    points: "1055.23 516.68 1073.31 506.44 1073.31 503.73 1055.23 513.97",
    className: "color998359 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1035.1 528.08 1053.18 517.84 1053.18 515.13 1035.1 525.37",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1014.97 539.48 1033.05 529.24 1033.05 526.53 1014.97 536.77",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "994.84 550.87 1012.92 540.63 1012.92 537.93 994.84 548.17",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#7b999b",
    points: "1089.18 504.04 1092.66 502.06 1092.66 499.36 1089.18 501.33",
    className: "color9a7b9b svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#438c92",
    points: "1072.15 513.68 1086.72 505.43 1086.72 502.73 1072.15 510.98",
    className: "color924443 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1054.63 523.6 1069.2 515.35 1069.2 512.65 1054.63 520.9",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1037.11 533.52 1051.68 525.27 1051.68 522.57 1037.11 530.82",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1019.59 543.44 1034.16 535.19 1034.16 532.49 1019.59 540.74",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1067.88 522.68 1088.46 511.03 1088.46 508.33 1067.88 519.98",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#599499",
    points: "1044.94 535.68 1065.52 524.02 1065.52 521.32 1044.94 532.97",
    className: "color998359 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1021.99 548.67 1042.57 537.02 1042.57 534.31 1021.99 545.97",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#438c92",
    points: "999.05 561.66 1019.63 550.01 1019.63 547.3 999.05 558.96",
    className: "color924443 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#7b999b",
    points: "1085.03 519.56 1092.66 515.24 1092.66 512.53 1085.03 516.85",
    className: "color9a7b9b svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1076.6 530.92 1089.19 523.79 1089.19 521.08 1076.6 528.21",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#599499",
    points: "1062.13 539.11 1074.72 531.98 1074.72 529.28 1062.13 536.41",
    className: "color998359 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#7b999b",
    points: "1086.17 532.09 1092.66 528.41 1092.66 525.7 1086.17 529.38",
    className: "color9a7b9b svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#7b999b",
    points: "1090.04 536.48 1097 532.54 1097 529.83 1090.04 533.77",
    className: "color9a7b9b svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#599499",
    points: "1082.5 553.92 1097 545.71 1097 543 1082.5 551.22",
    className: "color998359 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1066.05 563.24 1080.56 555.02 1080.56 552.32 1066.05 560.53",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#7b999b",
    points: "1093.52 554.27 1097 552.29 1097 549.59 1093.52 551.56",
    className: "color9a7b9b svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#7b999b",
    points: "1083.64 566.45 1097 558.88 1097 556.18 1083.64 563.75",
    className: "color9a7b9b svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1066.63 576.08 1079.99 568.52 1079.99 565.81 1066.63 573.38",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#599499",
    points: "1049.61 585.72 1062.98 578.15 1062.98 575.45 1049.61 583.01",
    className: "color998359 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#438c92",
    points: "1032.6 595.35 1045.96 587.79 1045.96 585.08 1032.6 592.65",
    className: "color924443 svgShape"
  })))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)",
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "be",
    x1: 3126.734,
    x2: 3699.568,
    y1: 862.021,
    y2: 862.021,
    gradientTransform: "matrix(-1 0 0 1 4662.933 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#819ea0",
    className: "stopColor8188a0 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#628082",
    className: "stopColor626282 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#be)",
    points: "1226.23 1027.64 1536.2 849.77 1273.33 696.4 963.36 874.27"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bf",
    x1: 3436.704,
    x2: 3699.568,
    y1: 978.89,
    y2: 978.89,
    gradientTransform: "matrix(-1 0 0 1 4662.933 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b5b5e",
    className: "stopColor3b3e5e svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#628082",
    className: "stopColor626282 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bf)",
    points: "963.36 874.27 963.36 930.14 1226.23 1083.51 1226.23 1027.64"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 3126.734,
    x2: 3436.704,
    y1: 966.639,
    y2: 966.639,
    gradientTransform: "matrix(-1 0 0 1 4662.933 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b5b5e",
    className: "stopColor3b3e5e svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#628082",
    className: "stopColor626282 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bg)",
    points: "1536.2 849.77 1536.2 905.63 1226.23 1083.51 1226.23 1027.64"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bh",
    x1: 3158.181,
    x2: 3668.248,
    y1: 425.171,
    y2: 425.171,
    gradientTransform: "matrix(-1 0 0 1 4662.933 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#819ea0",
    className: "stopColor8188a0 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#628082",
    className: "stopColor626282 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bh)",
    points: "1228.75 572.65 1504.75 414.26 1270.69 277.7 994.68 436.08"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bi",
    x1: 3254.875,
    x2: 4007.838,
    y1: 385.84,
    y2: 367.425,
    gradientTransform: "matrix(-1 0 0 1 4662.933 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b5b5e",
    className: "stopColor3b3e5e svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#527174",
    className: "stopColor525474 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bi)",
    points: "1056.61 436.3 1074.28 446.62 1270.56 334.02 1425.23 424.1 1442.75 414.09 1270.56 313.53"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bj",
    x1: 3412.426,
    x2: 3413.939,
    y1: 525.411,
    y2: 343.793,
    gradientTransform: "matrix(-1 0 0 1 4662.933 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#819ea0",
    className: "stopColor8188a0 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#628082",
    className: "stopColor626282 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bj)",
    points: "1074.28 446.62 1228.8 536.86 1425.23 424.1 1270.56 334.02"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bk",
    x1: 3434.186,
    x2: 3668.248,
    y1: 721.124,
    y2: 721.124,
    gradientTransform: "matrix(-1 0 0 1 4662.933 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b5b5e",
    className: "stopColor3b3e5e svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#628082",
    className: "stopColor626282 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bk)",
    points: "994.68 436.08 994.68 869.6 1228.75 1006.17 1228.75 572.65"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bl",
    x1: 3158.181,
    x2: 3434.186,
    y1: 710.215,
    y2: 710.215,
    gradientTransform: "matrix(-1 0 0 1 4662.933 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b5b5e",
    className: "stopColor3b3e5e svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#152728",
    className: "stopColor151828 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bl)",
    points: "1504.75 414.26 1504.75 847.78 1228.75 1006.17 1228.75 572.65"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bm",
    x1: 3551.174,
    x2: 3551.174,
    y1: 539.413,
    y2: 875.841,
    gradientTransform: "matrix(-1 0 0 1 4662.933 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b5b5e",
    className: "stopColor3b3e5e svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#152728",
    className: "stopColor151828 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bm)",
    points: "1029.84 497.17 1029.84 849.5 1193.68 945.1 1193.68 927.02 1045.57 840.58 1045.57 506.33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bn",
    x1: 3575.327,
    x2: 3513.006,
    y1: 850.49,
    y2: 590.021,
    gradientTransform: "matrix(-1 0 0 1 4662.933 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b5b5e",
    className: "stopColor3b3e5e svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#628082",
    className: "stopColor626282 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bn)",
    points: "1045.57 506.33 1045.57 840.58 1193.68 927.02 1193.68 592.77"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bo",
    x1: 3555.48,
    x2: 3544.305,
    y1: 915.3,
    y2: 868.592,
    gradientTransform: "matrix(-1 0 0 1 4662.933 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#819ea0",
    className: "stopColor8188a0 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#628082",
    className: "stopColor626282 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bo)",
    points: "1045.57 840.58 1029.84 849.5 1193.68 945.1 1193.68 927.02"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bp",
    x1: 3542.643,
    x2: 3542.643,
    y1: 1939.483,
    y2: 1980.711,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b5b5e",
    className: "stopColor3b3e5e svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#152728",
    className: "stopColor151828 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bp)",
    points: "1052.47 569.89 1188.11 649.49 1188.11 594.59 1052.47 514.99"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bq",
    x1: 3503.792,
    x2: 3478.655,
    y1: 1915.962,
    y2: 1964.706,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bq)",
    points: "1170.51 601.97 1180.04 607.56 1180.04 598.04 1170.51 592.45",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "br",
    x1: 3515.443,
    x2: 3490.306,
    y1: 1921.97,
    y2: 1970.714,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#br)",
    points: "1155.77 593.32 1165.29 598.9 1165.29 589.38 1155.77 583.79"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bs",
    x1: 3527.093,
    x2: 3501.956,
    y1: 1927.979,
    y2: 1976.722,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bs)",
    points: "1141.02 584.66 1150.54 590.25 1150.54 580.73 1141.02 575.14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bt",
    x1: 3538.744,
    x2: 3513.607,
    y1: 1933.987,
    y2: 1982.73,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bt)",
    points: "1126.27 576 1135.79 581.59 1135.79 572.07 1126.27 566.48"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bu",
    x1: 3550.395,
    x2: 3525.258,
    y1: 1939.995,
    y2: 1988.739,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bu)",
    points: "1111.52 567.35 1121.04 572.94 1121.04 563.41 1111.52 557.83"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bv",
    x1: 3509.254,
    x2: 3484.117,
    y1: 1918.779,
    y2: 1967.523,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bv)",
    points: "1170.51 615.38 1180.04 620.97 1180.04 611.45 1170.51 605.86",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bw",
    x1: 3520.905,
    x2: 3495.768,
    y1: 1924.787,
    y2: 1973.531,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bw)",
    points: "1155.77 606.72 1165.29 612.31 1165.29 602.79 1155.77 597.2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bx",
    x1: 3532.555,
    x2: 3507.419,
    y1: 1930.795,
    y2: 1979.539,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bx)",
    points: "1141.02 598.07 1150.54 603.66 1150.54 594.13 1141.02 588.55",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "by",
    x1: 3544.206,
    x2: 3519.069,
    y1: 1936.804,
    y2: 1985.547,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#by)",
    points: "1126.27 589.41 1135.79 595 1135.79 585.48 1126.27 579.89",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bz",
    x1: 3555.857,
    x2: 3530.72,
    y1: 1942.812,
    y2: 1991.555,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bz)",
    points: "1111.52 580.76 1121.04 586.34 1121.04 576.82 1111.52 571.23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bA",
    x1: 3514.716,
    x2: 3489.579,
    y1: 1921.596,
    y2: 1970.339,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bA)",
    points: "1170.51 628.79 1180.04 634.38 1180.04 624.85 1170.51 619.27"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bB",
    x1: 3526.367,
    x2: 3501.23,
    y1: 1927.604,
    y2: 1976.347,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bB)",
    points: "1155.77 620.13 1165.29 625.72 1165.29 616.2 1155.77 610.61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bC",
    x1: 3538.018,
    x2: 3512.881,
    y1: 1933.612,
    y2: 1982.356,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bC)",
    points: "1141.02 611.48 1150.54 617.06 1150.54 607.54 1141.02 601.96"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bD",
    x1: 3549.668,
    x2: 3524.532,
    y1: 1939.62,
    y2: 1988.364,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bD)",
    points: "1126.27 602.82 1135.79 608.41 1135.79 598.89 1126.27 593.3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bE",
    x1: 3561.319,
    x2: 3536.182,
    y1: 1945.629,
    y2: 1994.372,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bE)",
    points: "1111.52 594.16 1121.04 599.75 1121.04 590.23 1111.52 584.64",
    opacity: 0.41
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#17cedd",
    points: "1060.3 527.75 1060.3 564.04 1103.77 589.68 1103.77 584.97 1064.51 561.94 1064.51 530.23",
    className: "colordd6b17 svgShape"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bF",
    x1: 3578.791,
    x2: 3578.791,
    y1: 535.394,
    y2: 576.506,
    gradientTransform: "matrix(-1 0 0 1 4662.933 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0ce8fa",
    className: "stopColorfabb0c svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19e8f8",
    className: "stopColorf88019 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bF)",
    points: "1064.51 530.23 1064.51 561.94 1103.77 584.97 1103.77 553.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#079eaa",
    points: "1064.51 561.94 1060.3 564.04 1060.3 527.75 1064.51 530.23",
    className: "coloraa4907 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bG",
    x1: 3542.643,
    x2: 3542.643,
    y1: 2006.729,
    y2: 2047.958,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b5b5e",
    className: "stopColor3b3e5e svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#152728",
    className: "stopColor151828 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bG)",
    points: "1052.47 637.13 1188.11 716.73 1188.11 661.84 1052.47 582.24"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bH",
    x1: 3503.792,
    x2: 3478.655,
    y1: 1983.208,
    y2: 2031.952,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bH)",
    points: "1170.51 669.22 1180.04 674.81 1180.04 665.28 1170.51 659.7",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bI",
    x1: 3515.443,
    x2: 3490.306,
    y1: 1989.217,
    y2: 2037.96,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bI)",
    points: "1155.77 660.56 1165.29 666.15 1165.29 656.63 1155.77 651.04"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bJ",
    x1: 3527.093,
    x2: 3501.956,
    y1: 1995.225,
    y2: 2043.968,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bJ)",
    points: "1141.02 651.91 1150.54 657.49 1150.54 647.97 1141.02 642.38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bK",
    x1: 3538.744,
    x2: 3513.607,
    y1: 2001.233,
    y2: 2049.977,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bK)",
    points: "1126.27 643.25 1135.79 648.84 1135.79 639.32 1126.27 633.73"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bL",
    x1: 3550.395,
    x2: 3525.258,
    y1: 2007.242,
    y2: 2055.985,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bL)",
    points: "1111.52 634.59 1121.04 640.18 1121.04 630.66 1111.52 625.07"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bM",
    x1: 3509.254,
    x2: 3484.117,
    y1: 1986.025,
    y2: 2034.769,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bM)",
    points: "1170.51 682.63 1180.04 688.21 1180.04 678.69 1170.51 673.1",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bN",
    x1: 3520.905,
    x2: 3495.768,
    y1: 1992.033,
    y2: 2040.777,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bN)",
    points: "1155.77 673.97 1165.29 679.56 1165.29 670.04 1155.77 664.45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bO",
    x1: 3532.555,
    x2: 3507.419,
    y1: 1998.042,
    y2: 2046.785,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bO)",
    points: "1141.02 665.31 1150.54 670.9 1150.54 661.38 1141.02 655.79",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bP",
    x1: 3544.206,
    x2: 3519.069,
    y1: 2004.05,
    y2: 2052.794,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bP)",
    points: "1126.27 656.66 1135.79 662.25 1135.79 652.72 1126.27 647.14",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bQ",
    x1: 3555.857,
    x2: 3530.72,
    y1: 2010.058,
    y2: 2058.802,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bQ)",
    points: "1111.52 648 1121.04 653.59 1121.04 644.07 1111.52 638.48"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bR",
    x1: 3514.716,
    x2: 3489.579,
    y1: 1988.842,
    y2: 2037.586,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bR)",
    points: "1170.51 696.03 1180.04 701.62 1180.04 692.1 1170.51 686.51"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bS",
    x1: 3526.367,
    x2: 3501.23,
    y1: 1994.85,
    y2: 2043.594,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bS)",
    points: "1155.77 687.38 1165.29 692.97 1165.29 683.45 1155.77 677.86"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bT",
    x1: 3538.018,
    x2: 3512.881,
    y1: 2000.858,
    y2: 2049.602,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bT)",
    points: "1141.02 678.72 1150.54 684.31 1150.54 674.79 1141.02 669.2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bU",
    x1: 3549.668,
    x2: 3524.532,
    y1: 2006.867,
    y2: 2055.61,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bU)",
    points: "1126.27 670.07 1135.79 675.65 1135.79 666.13 1126.27 660.55"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bV",
    x1: 3561.319,
    x2: 3536.182,
    y1: 2012.875,
    y2: 2061.618,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bV)",
    points: "1111.52 661.41 1121.04 667 1121.04 657.48 1111.52 651.89",
    opacity: 0.41
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#17cedd",
    points: "1060.3 595 1060.3 631.29 1103.77 656.92 1103.77 652.22 1064.51 629.18 1064.51 597.48",
    className: "colordd6b17 svgShape"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bW",
    x1: 3578.791,
    x2: 3578.791,
    y1: 602.64,
    y2: 643.752,
    gradientTransform: "matrix(-1 0 0 1 4662.933 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0ce8fa",
    className: "stopColorfabb0c svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19e8f8",
    className: "stopColorf88019 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bW)",
    points: "1064.51 597.48 1064.51 629.18 1103.77 652.22 1103.77 620.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#079eaa",
    points: "1064.51 629.18 1060.3 631.29 1060.3 595 1064.51 597.48",
    className: "coloraa4907 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bX",
    x1: 3542.643,
    x2: 3542.643,
    y1: 2073.975,
    y2: 2115.204,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b5b5e",
    className: "stopColor3b3e5e svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#152728",
    className: "stopColor151828 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bX)",
    points: "1052.47 704.38 1188.11 783.98 1188.11 729.08 1052.47 649.49"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bY",
    x1: 3503.792,
    x2: 3478.655,
    y1: 2050.455,
    y2: 2099.198,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bY)",
    points: "1170.51 736.46 1180.04 742.05 1180.04 732.53 1170.51 726.94",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bZ",
    x1: 3515.443,
    x2: 3490.306,
    y1: 2056.463,
    y2: 2105.206,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bZ)",
    points: "1155.77 727.81 1165.29 733.4 1165.29 723.87 1155.77 718.29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ca",
    x1: 3527.093,
    x2: 3501.956,
    y1: 2062.471,
    y2: 2111.215,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#ca)",
    points: "1141.02 719.15 1150.54 724.74 1150.54 715.22 1141.02 709.63"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cb",
    x1: 3538.744,
    x2: 3513.607,
    y1: 2068.479,
    y2: 2117.223,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cb)",
    points: "1126.27 710.5 1135.79 716.08 1135.79 706.56 1126.27 700.98"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cc",
    x1: 3550.395,
    x2: 3525.258,
    y1: 2074.488,
    y2: 2123.231,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cc)",
    points: "1111.52 701.84 1121.04 707.43 1121.04 697.91 1111.52 692.32"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cd",
    x1: 3509.254,
    x2: 3484.117,
    y1: 2053.271,
    y2: 2102.015,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cd)",
    points: "1170.51 749.87 1180.04 755.46 1180.04 745.94 1170.51 740.35",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ce",
    x1: 3520.905,
    x2: 3495.768,
    y1: 2059.28,
    y2: 2108.023,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#ce)",
    points: "1155.77 741.22 1165.29 746.8 1165.29 737.28 1155.77 731.7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cf",
    x1: 3532.555,
    x2: 3507.419,
    y1: 2065.288,
    y2: 2114.032,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cf)",
    points: "1141.02 732.56 1150.54 738.15 1150.54 728.63 1141.02 723.04",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cg",
    x1: 3544.206,
    x2: 3519.069,
    y1: 2071.296,
    y2: 2120.04,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cg)",
    points: "1126.27 723.9 1135.79 729.49 1135.79 719.97 1126.27 714.38",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ch",
    x1: 3555.857,
    x2: 3530.72,
    y1: 2077.304,
    y2: 2126.048,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#ch)",
    points: "1111.52 715.25 1121.04 720.84 1121.04 711.32 1111.52 705.73"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ci",
    x1: 3514.716,
    x2: 3489.579,
    y1: 2056.088,
    y2: 2104.832,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#ci)",
    points: "1170.51 763.28 1180.04 768.87 1180.04 759.35 1170.51 753.76"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cj",
    x1: 3526.367,
    x2: 3501.23,
    y1: 2062.096,
    y2: 2110.84,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cj)",
    points: "1155.77 754.62 1165.29 760.21 1165.29 750.69 1155.77 745.1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ck",
    x1: 3538.018,
    x2: 3512.881,
    y1: 2068.105,
    y2: 2116.848,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#ck)",
    points: "1141.02 745.97 1150.54 751.56 1150.54 742.04 1141.02 736.45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cl",
    x1: 3549.668,
    x2: 3524.532,
    y1: 2074.113,
    y2: 2122.856,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cl)",
    points: "1126.27 737.31 1135.79 742.9 1135.79 733.38 1126.27 727.79"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cm",
    x1: 3561.319,
    x2: 3536.182,
    y1: 2080.121,
    y2: 2128.865,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cm)",
    points: "1111.52 728.66 1121.04 734.24 1121.04 724.72 1111.52 719.14",
    opacity: 0.41
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#17cedd",
    points: "1060.3 662.25 1060.3 698.53 1103.77 724.17 1103.77 719.46 1064.51 696.43 1064.51 664.72",
    className: "colordd6b17 svgShape"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cn",
    x1: 3578.791,
    x2: 3578.791,
    y1: 669.886,
    y2: 710.999,
    gradientTransform: "matrix(-1 0 0 1 4662.933 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0ce8fa",
    className: "stopColorfabb0c svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19e8f8",
    className: "stopColorf88019 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cn)",
    points: "1064.51 664.72 1064.51 696.43 1103.77 719.46 1103.77 687.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#079eaa",
    points: "1064.51 696.43 1060.3 698.53 1060.3 662.25 1064.51 664.72",
    className: "coloraa4907 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "co",
    x1: 3542.643,
    x2: 3542.643,
    y1: 2141.221,
    y2: 2182.45,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b5b5e",
    className: "stopColor3b3e5e svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#152728",
    className: "stopColor151828 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#co)",
    points: "1052.47 771.63 1188.11 851.23 1188.11 796.33 1052.47 716.73"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cp",
    x1: 3503.792,
    x2: 3478.655,
    y1: 2117.701,
    y2: 2166.445,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cp)",
    points: "1170.51 803.71 1180.04 809.3 1180.04 799.78 1170.51 794.19",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cq",
    x1: 3515.443,
    x2: 3490.306,
    y1: 2123.709,
    y2: 2172.453,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cq)",
    points: "1155.77 795.05 1165.29 800.64 1165.29 791.12 1155.77 785.53"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cr",
    x1: 3527.093,
    x2: 3501.956,
    y1: 2129.718,
    y2: 2178.461,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cr)",
    points: "1141.02 786.4 1150.54 791.99 1150.54 782.47 1141.02 776.88"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cs",
    x1: 3538.744,
    x2: 3513.607,
    y1: 2135.726,
    y2: 2184.469,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cs)",
    points: "1126.27 777.74 1135.79 783.33 1135.79 773.81 1126.27 768.22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ct",
    x1: 3550.395,
    x2: 3525.258,
    y1: 2141.734,
    y2: 2190.477,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#ct)",
    points: "1111.52 769.09 1121.04 774.67 1121.04 765.15 1111.52 759.57"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cu",
    x1: 3509.254,
    x2: 3484.117,
    y1: 2120.518,
    y2: 2169.262,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cu)",
    points: "1170.51 817.12 1180.04 822.71 1180.04 813.19 1170.51 807.6",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cv",
    x1: 3520.905,
    x2: 3495.768,
    y1: 2126.526,
    y2: 2175.269,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cv)",
    points: "1155.77 808.46 1165.29 814.05 1165.29 804.53 1155.77 798.94"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cw",
    x1: 3532.555,
    x2: 3507.419,
    y1: 2132.534,
    y2: 2181.278,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cw)",
    points: "1141.02 799.81 1150.54 805.39 1150.54 795.87 1141.02 790.29",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cx",
    x1: 3544.206,
    x2: 3519.069,
    y1: 2138.543,
    y2: 2187.286,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cx)",
    points: "1126.27 791.15 1135.79 796.74 1135.79 787.22 1126.27 781.63",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cy",
    x1: 3555.857,
    x2: 3530.72,
    y1: 2144.551,
    y2: 2193.294,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cy)",
    points: "1111.52 782.5 1121.04 788.08 1121.04 778.56 1111.52 772.97"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cz",
    x1: 3514.716,
    x2: 3489.579,
    y1: 2123.335,
    y2: 2172.078,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cz)",
    points: "1170.51 830.53 1180.04 836.12 1180.04 826.59 1170.51 821.01"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cA",
    x1: 3526.367,
    x2: 3501.23,
    y1: 2129.343,
    y2: 2178.086,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cA)",
    points: "1155.77 821.87 1165.29 827.46 1165.29 817.94 1155.77 812.35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cB",
    x1: 3538.018,
    x2: 3512.881,
    y1: 2135.351,
    y2: 2184.095,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cB)",
    points: "1141.02 813.22 1150.54 818.8 1150.54 809.28 1141.02 803.69"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cC",
    x1: 3549.668,
    x2: 3524.532,
    y1: 2141.359,
    y2: 2190.103,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cC)",
    points: "1126.27 804.56 1135.79 810.15 1135.79 800.63 1126.27 795.04"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cD",
    x1: 3561.319,
    x2: 3536.182,
    y1: 2147.367,
    y2: 2196.111,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cD)",
    points: "1111.52 795.9 1121.04 801.49 1121.04 791.97 1111.52 786.38",
    opacity: 0.41
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#17cedd",
    points: "1060.3 729.49 1060.3 765.78 1103.77 791.42 1103.77 786.71 1064.51 763.67 1064.51 731.97",
    className: "colordd6b17 svgShape"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cE",
    x1: 3578.791,
    x2: 3578.791,
    y1: 737.133,
    y2: 778.245,
    gradientTransform: "matrix(-1 0 0 1 4662.933 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0ce8fa",
    className: "stopColorfabb0c svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19e8f8",
    className: "stopColorf88019 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cE)",
    points: "1064.51 731.97 1064.51 763.67 1103.77 786.71 1103.77 755.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#079eaa",
    points: "1064.51 763.67 1060.3 765.78 1060.3 729.49 1064.51 731.97",
    className: "coloraa4907 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cF",
    x1: 3542.643,
    x2: 3542.643,
    y1: 2208.468,
    y2: 2249.697,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b5b5e",
    className: "stopColor3b3e5e svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#152728",
    className: "stopColor151828 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cF)",
    points: "1052.47 838.87 1188.11 918.47 1188.11 863.58 1052.47 783.98"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cG",
    x1: 3503.792,
    x2: 3478.655,
    y1: 2184.948,
    y2: 2233.691,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cG)",
    points: "1170.51 870.96 1180.04 876.54 1180.04 867.02 1170.51 861.44",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cH",
    x1: 3515.443,
    x2: 3490.306,
    y1: 2190.956,
    y2: 2239.699,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cH)",
    points: "1155.77 862.3 1165.29 867.89 1165.29 858.37 1155.77 852.78"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cI",
    x1: 3527.093,
    x2: 3501.956,
    y1: 2196.964,
    y2: 2245.707,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cI)",
    points: "1141.02 853.64 1150.54 859.23 1150.54 849.71 1141.02 844.12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cJ",
    x1: 3538.744,
    x2: 3513.607,
    y1: 2202.972,
    y2: 2251.716,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cJ)",
    points: "1126.27 844.99 1135.79 850.58 1135.79 841.06 1126.27 835.47"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cK",
    x1: 3550.395,
    x2: 3525.258,
    y1: 2208.981,
    y2: 2257.724,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cK)",
    points: "1111.52 836.33 1121.04 841.92 1121.04 832.4 1111.52 826.81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cL",
    x1: 3509.254,
    x2: 3484.117,
    y1: 2187.764,
    y2: 2236.508,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cL)",
    points: "1170.51 884.37 1180.04 889.95 1180.04 880.43 1170.51 874.84",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cM",
    x1: 3520.905,
    x2: 3495.768,
    y1: 2193.773,
    y2: 2242.516,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cM)",
    points: "1155.77 875.71 1165.29 881.3 1165.29 871.78 1155.77 866.19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cN",
    x1: 3532.555,
    x2: 3507.419,
    y1: 2199.781,
    y2: 2248.524,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cN)",
    points: "1141.02 867.05 1150.54 872.64 1150.54 863.12 1141.02 857.53",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cO",
    x1: 3544.206,
    x2: 3519.069,
    y1: 2205.789,
    y2: 2254.532,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cO)",
    points: "1126.27 858.4 1135.79 863.99 1135.79 854.46 1126.27 848.88",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cP",
    x1: 3555.857,
    x2: 3530.72,
    y1: 2211.797,
    y2: 2260.541,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cP)",
    points: "1111.52 849.74 1121.04 855.33 1121.04 845.81 1111.52 840.22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cQ",
    x1: 3514.716,
    x2: 3489.579,
    y1: 2190.581,
    y2: 2239.325,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cQ)",
    points: "1170.51 897.77 1180.04 903.36 1180.04 893.84 1170.51 888.25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cR",
    x1: 3526.367,
    x2: 3501.23,
    y1: 2196.589,
    y2: 2245.333,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cR)",
    points: "1155.77 889.12 1165.29 894.71 1165.29 885.18 1155.77 879.6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cS",
    x1: 3538.018,
    x2: 3512.881,
    y1: 2202.597,
    y2: 2251.341,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cS)",
    points: "1141.02 880.46 1150.54 886.05 1150.54 876.53 1141.02 870.94"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cT",
    x1: 3549.668,
    x2: 3524.532,
    y1: 2208.606,
    y2: 2257.349,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cT)",
    points: "1126.27 871.81 1135.79 877.39 1135.79 867.87 1126.27 862.28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cU",
    x1: 3561.319,
    x2: 3536.182,
    y1: 2214.614,
    y2: 2263.357,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cU)",
    points: "1111.52 863.15 1121.04 868.74 1121.04 859.22 1111.52 853.63",
    opacity: 0.41
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#17cedd",
    points: "1060.3 796.74 1060.3 833.03 1103.77 858.66 1103.77 853.96 1064.51 830.92 1064.51 799.22",
    className: "colordd6b17 svgShape"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cV",
    x1: 3578.791,
    x2: 3578.791,
    y1: 804.379,
    y2: 845.491,
    gradientTransform: "matrix(-1 0 0 1 4662.933 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0ce8fa",
    className: "stopColorfabb0c svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19e8f8",
    className: "stopColorf88019 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cV)",
    points: "1064.51 799.22 1064.51 830.92 1103.77 853.96 1103.77 822.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#079eaa",
    points: "1064.51 830.92 1060.3 833.03 1060.3 796.74 1064.51 799.22",
    className: "coloraa4907 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cW",
    x1: 3178.916,
    x2: 3405.033,
    y1: 537.336,
    y2: 537.336,
    gradientTransform: "matrix(-1 0 0 1 4662.93 .065)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#819ea0",
    className: "stopColor8188a0 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#628082",
    className: "stopColor626282 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cW)",
    points: "1271.38 602.25 1484.02 480.24 1470.53 472.55 1257.9 594.57"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cX",
    x1: 3398.293,
    x2: 3398.293,
    y1: 578.893,
    y2: 891.376,
    gradientTransform: "matrix(-1 0 0 1 4662.933 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b5b5e",
    className: "stopColor3b3e5e svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#152728",
    className: "stopColor151828 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cX)",
    points: "1257.9 594.57 1257.9 928.55 1271.38 936.24 1271.38 602.25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cY",
    x1: 3257.909,
    x2: 3305.613,
    y1: 881.298,
    y2: 579.176,
    gradientTransform: "matrix(-1 0 0 1 4662.933 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b5b5e",
    className: "stopColor3b3e5e svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#628082",
    className: "stopColor626282 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cY)",
    points: "1484.02 480.24 1484.02 814.22 1271.38 936.24 1271.38 602.25"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1464.43 700.48 1469.11 697.88 1469.11 695.82 1464.43 698.41",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1464.43 707.96 1469.11 705.37 1469.11 703.3 1464.43 705.89",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1464.43 715.44 1469.11 712.85 1469.11 710.78 1464.43 713.38",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1464.43 722.92 1469.11 720.33 1469.11 718.26 1464.43 720.86",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1464.43 730.41 1469.11 727.81 1469.11 725.74 1464.43 728.34",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1464.43 737.89 1469.11 735.29 1469.11 733.23 1464.43 735.82",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1464.43 745.37 1469.11 742.78 1469.11 740.71 1464.43 743.3",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1464.43 752.85 1469.11 750.26 1469.11 748.19 1464.43 750.79",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1464.43 760.33 1469.11 757.74 1469.11 755.67 1464.43 758.27",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1464.43 767.82 1469.11 765.22 1469.11 763.15 1464.43 765.75",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1464.43 775.3 1469.11 772.7 1469.11 770.64 1464.43 773.23",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1464.43 782.78 1469.11 780.18 1469.11 778.12 1464.43 780.71",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1464.43 790.26 1469.11 787.67 1469.11 785.6 1464.43 788.2",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1464.43 797.74 1469.11 795.15 1469.11 793.08 1464.43 795.68",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1464.43 805.23 1469.11 802.63 1469.11 800.56 1464.43 803.16",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1464.43 812.71 1469.11 810.11 1469.11 808.05 1464.43 810.64",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1449.59 708.7 1454.27 706.11 1454.27 704.04 1449.59 706.64",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1449.59 716.19 1454.27 713.59 1454.27 711.53 1449.59 714.12",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1427.21 728.6 1444.44 719.04 1444.44 716.98 1427.21 726.53",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1405.73 740.51 1422.96 730.96 1422.96 728.89 1405.73 738.44",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1384.24 752.42 1401.47 742.87 1401.47 740.8 1384.24 750.36",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1362.76 764.33 1379.99 754.78 1379.99 752.71 1362.76 762.27",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1341.28 776.24 1358.51 766.69 1358.51 764.62 1341.28 774.18",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1319.8 788.16 1337.03 778.6 1337.03 776.54 1319.8 786.09",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1298.32 800.07 1315.55 790.51 1315.55 788.45 1298.32 798",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1423.59 738.09 1444.44 726.53 1444.44 724.46 1423.59 736.02",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1397.59 752.5 1418.44 740.94 1418.44 738.88 1397.59 750.44",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1371.59 766.92 1392.44 755.36 1392.44 753.29 1371.59 764.85",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1345.59 781.34 1366.44 769.77 1366.44 767.71 1345.59 779.27",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1319.59 795.75 1340.45 784.19 1340.45 782.12 1319.59 793.69",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1293.59 810.17 1314.45 798.6 1314.45 796.54 1293.59 808.1",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1427.21 780.97 1444.44 771.42 1444.44 769.35 1427.21 778.91",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1405.73 792.88 1422.96 783.33 1422.96 781.26 1405.73 790.82",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1384.24 804.8 1401.47 795.24 1401.47 793.17 1384.24 802.73",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1362.76 816.71 1379.99 807.15 1379.99 805.09 1362.76 814.64",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1341.28 828.62 1358.51 819.06 1358.51 817 1341.28 826.55",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1319.8 840.53 1337.03 830.98 1337.03 828.91 1319.8 838.46",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1298.32 852.44 1315.55 842.89 1315.55 840.82 1298.32 850.38",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1423.59 790.46 1444.44 778.9 1444.44 776.83 1423.59 788.4",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1397.59 804.88 1418.44 793.32 1418.44 791.25 1397.59 802.81",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1371.59 819.29 1392.44 807.73 1392.44 805.67 1371.59 817.23",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1345.59 833.71 1366.44 822.15 1366.44 820.08 1345.59 831.64",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1319.59 848.13 1340.45 836.56 1340.45 834.5 1319.59 846.06",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1293.59 862.54 1314.45 850.98 1314.45 848.91 1293.59 860.48",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1427.21 743.56 1444.44 734.01 1444.44 731.94 1427.21 741.5",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1405.73 755.47 1422.96 745.92 1422.96 743.85 1405.73 753.41",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1384.24 767.39 1401.47 757.83 1401.47 755.76 1384.24 765.32",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1427.21 810.9 1444.44 801.35 1444.44 799.28 1427.21 808.83",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1405.73 822.81 1422.96 813.26 1422.96 811.19 1405.73 820.75",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1384.24 834.72 1401.47 825.17 1401.47 823.1 1384.24 832.66",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1362.76 846.63 1379.99 837.08 1379.99 835.01 1362.76 844.57",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1341.28 858.55 1358.51 848.99 1358.51 846.93 1341.28 856.48",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1319.8 870.46 1337.03 860.9 1337.03 858.84 1319.8 868.39",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1298.32 882.37 1315.55 872.82 1315.55 870.75 1298.32 880.3",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1423.59 820.39 1444.44 808.83 1444.44 806.76 1423.59 818.32",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1397.59 834.81 1418.44 823.24 1418.44 821.18 1397.59 832.74",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1371.59 849.22 1392.44 837.66 1392.44 835.59 1371.59 847.16",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1345.59 863.64 1366.44 852.07 1366.44 850.01 1345.59 861.57",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1319.59 878.05 1340.45 866.49 1340.45 864.42 1319.59 875.99",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1293.59 892.47 1314.45 880.91 1314.45 878.84 1293.59 890.4",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1427.21 825.86 1444.44 816.31 1444.44 814.24 1427.21 823.8",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1405.73 837.78 1422.96 828.22 1422.96 826.15 1405.73 835.71",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1384.24 849.69 1401.47 840.13 1401.47 838.07 1384.24 847.62",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1449.59 723.67 1454.27 721.07 1454.27 719.01 1449.59 721.6",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1449.59 731.15 1454.27 728.56 1454.27 726.49 1449.59 729.08",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1449.59 738.63 1454.27 736.04 1454.27 733.97 1449.59 736.57",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#599499",
    points: "1428.35 757.89 1454.27 743.52 1454.27 741.45 1428.35 755.83",
    className: "color998359 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1399.64 773.81 1425.56 759.44 1425.56 757.37 1399.64 771.75",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1370.92 789.74 1396.85 775.36 1396.85 773.3 1370.92 787.67",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#599499",
    points: "1428.35 802.79 1454.27 788.41 1454.27 786.35 1428.35 800.72",
    className: "color998359 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1399.64 818.71 1425.56 804.33 1425.56 802.27 1399.64 816.64",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1370.92 834.63 1396.85 820.25 1396.85 818.19 1370.92 832.56",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1449.59 753.6 1454.27 751 1454.27 748.94 1449.59 751.53",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1449.59 761.08 1454.27 758.48 1454.27 756.42 1449.59 759.01",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1449.59 768.56 1454.27 765.97 1454.27 763.9 1449.59 766.49",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1449.59 776.04 1454.27 773.45 1454.27 771.38 1449.59 773.98",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1449.59 783.52 1454.27 780.93 1454.27 778.86 1449.59 781.46",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1449.59 798.49 1454.27 795.89 1454.27 793.83 1449.59 796.42",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1449.59 805.97 1454.27 803.38 1454.27 801.31 1449.59 803.9",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1449.59 813.45 1454.27 810.86 1454.27 808.79 1449.59 811.39",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1449.59 820.93 1454.27 818.34 1454.27 816.27 1449.59 818.87",
    className: "color99a7c6 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1389.72 563.27 1393.21 561.3 1393.21 558.6 1389.72 560.57",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1389.72 569.86 1393.21 567.89 1393.21 565.18 1389.72 567.15",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1389.72 576.45 1393.21 574.47 1393.21 571.77 1389.72 573.74",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1389.72 583.03 1393.21 581.06 1393.21 578.35 1389.72 580.33",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1389.72 589.62 1393.21 587.64 1393.21 584.94 1389.72 586.91",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1389.72 596.2 1393.21 594.23 1393.21 591.53 1389.72 593.5",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1389.72 602.79 1393.21 600.82 1393.21 598.11 1389.72 600.09",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1389.72 609.38 1393.21 607.4 1393.21 604.7 1389.72 606.67",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1389.72 615.96 1393.21 613.99 1393.21 611.28 1389.72 613.26",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1389.72 622.55 1393.21 620.58 1393.21 617.87 1389.72 619.84",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1389.72 629.14 1393.21 627.16 1393.21 624.46 1389.72 626.43",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1389.72 635.72 1393.21 633.75 1393.21 631.04 1389.72 633.02",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1389.72 642.31 1393.21 640.33 1393.21 637.63 1389.72 639.6",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1389.72 648.89 1393.21 646.92 1393.21 644.22 1389.72 646.19",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1389.72 655.48 1393.21 653.51 1393.21 650.8 1389.72 652.78",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1389.72 662.07 1393.21 660.09 1393.21 657.39 1389.72 659.36",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1389.72 668.65 1393.21 666.68 1393.21 663.97 1389.72 665.95",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1389.72 675.24 1393.21 673.27 1393.21 670.56 1389.72 672.53",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1389.72 681.82 1393.21 679.85 1393.21 677.15 1389.72 679.12",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1389.72 688.41 1393.21 686.44 1393.21 683.73 1389.72 685.71",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1389.72 695 1393.21 693.02 1393.21 690.32 1389.72 692.29",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1389.72 701.58 1393.21 699.61 1393.21 696.91 1389.72 698.88",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1389.72 708.17 1393.21 706.2 1393.21 703.49 1389.72 705.46",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1389.72 714.76 1393.21 712.78 1393.21 710.08 1389.72 712.05",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1389.72 721.34 1393.21 719.37 1393.21 716.66 1389.72 718.64",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1460.31 523.3 1463.79 521.33 1463.79 518.62 1460.31 520.6",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#599499",
    points: "1445.06 531.94 1457.27 525.02 1457.27 522.32 1445.06 529.23",
    className: "color998359 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#599499",
    points: "1430.07 540.42 1442.28 533.51 1442.28 530.8 1430.07 537.72",
    className: "color998359 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#599499",
    points: "1415.09 548.91 1427.3 541.99 1427.3 539.29 1415.09 546.2",
    className: "color998359 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1460.31 529.89 1463.79 527.91 1463.79 525.21 1460.31 527.18",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1460.31 536.47 1463.79 534.5 1463.79 531.8 1460.31 533.77",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1447.36 543.8 1456.6 538.57 1456.6 535.87 1447.36 541.1",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1436.7 549.84 1445.94 544.61 1445.94 541.91 1436.7 547.14",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1426.04 555.88 1435.28 550.65 1435.28 547.94 1426.04 553.17",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1460.31 543.06 1463.79 541.09 1463.79 538.38 1460.31 540.36",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1442.51 553.14 1457.88 544.43 1457.88 541.73 1442.51 550.44",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1425.2 562.94 1440.57 554.24 1440.57 551.53 1425.2 560.24",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1407.89 572.74 1423.26 564.04 1423.26 561.33 1407.89 570.04",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1460.31 549.65 1463.79 547.67 1463.79 544.97 1460.31 546.94",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1446.57 557.43 1457.88 551.02 1457.88 548.32 1446.57 554.72",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1460.31 556.23 1463.79 554.26 1463.79 551.55 1460.31 553.53",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1451.76 561.07 1455.24 559.1 1455.24 556.4 1451.76 558.37",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1460.31 562.82 1463.79 560.85 1463.79 558.14 1460.31 560.11",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1451.76 567.66 1455.24 565.69 1455.24 562.98 1451.76 564.95",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1460.31 569.4 1463.79 567.43 1463.79 564.73 1460.31 566.7",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1451.76 574.25 1455.24 572.27 1455.24 569.57 1451.76 571.54",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1436.7 569.6 1450.6 561.73 1450.6 559.03 1436.7 566.89",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1432.22 578.73 1450.6 568.32 1450.6 565.61 1432.22 576.02",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1430.05 586.54 1450.6 574.9 1450.6 572.2 1430.05 583.83",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1460.31 575.99 1463.79 574.02 1463.79 571.31 1460.31 573.29",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1447.11 583.46 1450.6 581.49 1450.6 578.78 1447.11 580.76",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1424.78 596.11 1445.35 584.46 1445.35 581.76 1424.78 593.41",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1460.31 582.58 1463.79 580.6 1463.79 577.9 1460.31 579.87",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1460.31 589.16 1463.79 587.19 1463.79 584.49 1460.31 586.46",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1460.31 595.75 1463.79 593.78 1463.79 591.07 1460.31 593.04",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1460.31 602.34 1463.79 600.36 1463.79 597.66 1460.31 599.63",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1460.31 608.92 1463.79 606.95 1463.79 604.24 1460.31 606.22",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1460.31 615.51 1463.79 613.54 1463.79 610.83 1460.31 612.8",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1460.31 622.09 1463.79 620.12 1463.79 617.42 1460.31 619.39",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1460.31 628.68 1463.79 626.71 1463.79 624 1460.31 625.98",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1431.26 599.02 1445 591.25 1445 588.54 1431.26 596.32",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1415.72 607.82 1429.46 600.05 1429.46 597.34 1415.72 605.12",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1400.19 616.62 1413.92 608.84 1413.92 606.14 1400.19 613.92",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1433.34 604.43 1445 597.83 1445 595.13 1433.34 601.73",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1420.13 611.92 1431.79 605.31 1431.79 602.61 1420.13 609.21",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1406.92 619.4 1418.58 612.8 1418.58 610.09 1406.92 616.69",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#438c92",
    points: "1431 612.34 1445 604.42 1445 601.71 1431 609.64",
    className: "color924443 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1415.14 621.33 1429.14 613.4 1429.14 610.7 1415.14 618.62",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1433.34 617.61 1445 611 1445 608.3 1433.34 614.9",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1419.34 625.53 1431 618.93 1431 616.23 1419.34 622.83",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1433.34 624.19 1445 617.59 1445 614.89 1433.34 621.49",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1420.44 631.5 1432.1 624.89 1432.1 622.19 1420.44 628.79",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1407.55 638.8 1419.21 632.2 1419.21 629.49 1407.55 636.09",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1435.64 629.48 1445 624.18 1445 621.47 1435.64 626.77",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1425.04 635.48 1434.4 630.18 1434.4 627.48 1425.04 632.77",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1414.44 641.48 1423.8 636.18 1423.8 633.48 1414.44 638.78",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1403.84 647.49 1413.19 642.19 1413.19 639.48 1403.84 644.78",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1433.34 637.37 1445 630.76 1445 628.06 1433.34 634.66",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1420.44 644.67 1432.1 638.07 1432.1 635.36 1420.44 641.96",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1407.55 651.97 1419.21 645.37 1419.21 642.66 1407.55 649.27",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1433.34 643.95 1445 637.35 1445 634.65 1433.34 641.25",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1420.13 651.43 1431.79 644.83 1431.79 642.13 1420.13 648.73",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1460.31 635.27 1463.79 633.29 1463.79 630.59 1460.31 632.56",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1460.31 641.85 1463.79 639.88 1463.79 637.18 1460.31 639.15",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1460.31 648.44 1463.79 646.47 1463.79 643.76 1460.31 645.73",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1460.31 655.03 1463.79 653.05 1463.79 650.35 1460.31 652.32",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1460.31 661.61 1463.79 659.64 1463.79 656.93 1460.31 658.91",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1451.76 640.11 1455.24 638.13 1455.24 635.43 1451.76 637.4",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1451.76 646.69 1455.24 644.72 1455.24 642.02 1451.76 643.99",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1451.76 653.28 1455.24 651.31 1455.24 648.6 1451.76 650.58",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1451.76 659.87 1455.24 657.89 1455.24 655.19 1451.76 657.16",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1451.76 666.45 1455.24 664.48 1455.24 661.78 1451.76 663.75",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1432.97 650.75 1449.88 641.17 1449.88 638.46 1432.97 648.04",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1439.17 653.82 1449.88 647.76 1449.88 645.05 1439.17 651.12",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1435.44 662.52 1449.88 654.34 1449.88 651.64 1435.44 659.82",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1438.14 667.58 1449.88 660.93 1449.88 658.22 1438.14 664.87",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1442.18 671.88 1449.88 667.51 1449.88 664.81 1442.18 669.17",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1460.31 668.2 1463.79 666.23 1463.79 663.52 1460.31 665.49",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1460.31 674.78 1463.79 672.81 1463.79 670.11 1460.31 672.08",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1460.31 681.37 1463.79 679.4 1463.79 676.69 1460.31 678.67",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1455.24 671.07 1458.73 669.09 1458.73 666.39 1455.24 668.36",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1455.24 677.65 1458.73 675.68 1458.73 672.97 1455.24 674.95",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1455.24 684.24 1458.73 682.27 1458.73 679.56 1455.24 681.53",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1439.53 679.96 1452.71 672.5 1452.71 669.8 1439.53 677.26",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1443.68 684.2 1452.71 679.09 1452.71 676.38 1443.68 681.49",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1446.12 689.41 1452.71 685.67 1452.71 682.97 1446.12 686.7",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#7b999b",
    points: "1374.1 572.12 1383.42 566.84 1383.42 564.14 1374.1 569.42",
    className: "color9a7b9b svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1357.77 581.37 1372.99 572.75 1372.99 570.05 1357.77 578.66",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#438c92",
    points: "1364.04 584.4 1383.42 573.43 1383.42 570.72 1364.04 581.7",
    className: "color924443 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#599499",
    points: "1340.9 597.51 1360.28 586.53 1360.28 583.83 1340.9 594.8",
    className: "color998359 svgShape"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cZ",
    x1: 3325.791,
    x2: 3345.169,
    y1: -623.256,
    y2: -623.256,
    gradientTransform: "matrix(-1 .5663 0 1 4662.934 -661.86)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1dc1ce",
    className: "stopColor1d7ece svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17838c",
    className: "stopColor17538c svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#cZ)",
    points: "1317.76 610.61 1337.14 599.64 1337.14 596.93 1317.76 607.9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "da",
    x1: 3348.931,
    x2: 3368.309,
    y1: -623.256,
    y2: -623.256,
    gradientTransform: "matrix(-1 .5663 0 1 4662.934 -661.86)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1dc1ce",
    className: "stopColor1d7ece svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17838c",
    className: "stopColor17538c svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#da)",
    points: "1294.63 623.71 1314 612.74 1314 610.03 1294.63 621.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#7b999b",
    points: "1374.59 585.01 1383.42 580.01 1383.42 577.31 1374.59 582.31",
    className: "color9a7b9b svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#438c92",
    points: "1350.59 598.6 1372.23 586.35 1372.23 583.64 1350.59 595.9",
    className: "color924443 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1326.32 612.35 1347.96 600.09 1347.96 597.39 1326.32 609.64",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1354.62 602.91 1375.47 591.1 1375.47 588.4 1354.62 600.2",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#599499",
    points: "1331.6 615.95 1352.45 604.14 1352.45 601.43 1331.6 613.24",
    className: "color998359 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1308.58 628.98 1329.43 617.18 1329.43 614.47 1308.58 626.28",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1285.55 642.02 1306.41 630.21 1306.41 627.51 1285.55 639.32",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#7b999b",
    points: "1367.86 602 1379.6 595.35 1379.6 592.64 1367.86 599.29",
    className: "color9a7b9b svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1363.34 611.15 1376.7 603.58 1376.7 600.87 1363.34 608.44",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1347.5 620.11 1360.87 612.54 1360.87 609.84 1347.5 617.41",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#7b999b",
    points: "1370.96 613.42 1379.38 608.65 1379.38 605.94 1370.96 610.71",
    className: "color9a7b9b svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#7b999b",
    points: "1376.19 617.04 1383.42 612.94 1383.42 610.24 1376.19 614.33",
    className: "color9a7b9b svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#7b999b",
    points: "1372.8 632.13 1383.42 626.12 1383.42 623.41 1372.8 629.43",
    className: "color9a7b9b svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1360.31 639.2 1370.93 633.19 1370.93 630.48 1360.31 636.5",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#438c92",
    points: "1363.47 644 1379.85 634.72 1379.85 632.02 1363.47 641.29",
    className: "color924443 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#599499",
    points: "1345.39 654.24 1361.77 644.96 1361.77 642.26 1345.39 651.53",
    className: "color998359 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1327.31 664.48 1343.69 655.2 1343.69 652.5 1327.31 661.77",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1309.23 674.72 1325.61 665.44 1325.61 662.74 1309.23 672.01",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1291.15 684.96 1307.53 675.68 1307.53 672.98 1291.15 682.25",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#7b999b",
    points: "1373.87 644.7 1383.42 639.29 1383.42 636.58 1373.87 642",
    className: "color9a7b9b svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#7b999b",
    points: "1375.28 657.07 1383.42 652.46 1383.42 649.76 1375.28 654.37",
    className: "color9a7b9b svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1359.73 665.88 1373.87 657.87 1373.87 655.17 1359.73 663.18",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#438c92",
    points: "1361.77 671.31 1379.85 661.07 1379.85 658.36 1361.77 668.6",
    className: "color924443 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#599499",
    points: "1341.64 682.71 1359.73 672.47 1359.73 669.76 1341.64 680",
    className: "color998359 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1321.52 694.11 1339.6 683.87 1339.6 681.16 1321.52 691.4",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1301.39 705.5 1319.47 695.26 1319.47 692.56 1301.39 702.8",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1281.26 716.9 1299.34 706.66 1299.34 703.96 1281.26 714.2",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#7b999b",
    points: "1375.59 670.07 1379.08 668.09 1379.08 665.39 1375.59 667.36",
    className: "color9a7b9b svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#438c92",
    points: "1358.56 679.71 1373.14 671.46 1373.14 668.75 1358.56 677.01",
    className: "color924443 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1341.05 689.63 1355.62 681.38 1355.62 678.68 1341.05 686.93",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1323.53 699.55 1338.1 691.3 1338.1 688.6 1323.53 696.85",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1306.01 709.47 1320.58 701.22 1320.58 698.52 1306.01 706.77",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1354.3 688.71 1374.88 677.06 1374.88 674.35 1354.3 686.01",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#599499",
    points: "1331.35 701.71 1351.93 690.05 1351.93 687.35 1331.35 699",
    className: "color998359 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1308.41 714.7 1328.99 703.05 1328.99 700.34 1308.41 712",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#438c92",
    points: "1285.47 727.69 1306.05 716.04 1306.05 713.33 1285.47 724.99",
    className: "color924443 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#7b999b",
    points: "1371.45 685.59 1379.08 681.27 1379.08 678.56 1371.45 682.88",
    className: "color9a7b9b svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1363.02 696.95 1375.61 689.82 1375.61 687.11 1363.02 694.24",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#599499",
    points: "1348.55 705.14 1361.14 698.01 1361.14 695.31 1348.55 702.44",
    className: "color998359 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#7b999b",
    points: "1372.58 698.12 1379.08 694.44 1379.08 691.73 1372.58 695.41",
    className: "color9a7b9b svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#7b999b",
    points: "1376.46 702.51 1383.42 698.57 1383.42 695.86 1376.46 699.8",
    className: "color9a7b9b svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#599499",
    points: "1368.91 719.95 1383.42 711.74 1383.42 709.03 1368.91 717.25",
    className: "color998359 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1352.47 729.27 1366.98 721.05 1366.98 718.34 1352.47 726.56",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#7b999b",
    points: "1379.94 720.3 1383.42 718.32 1383.42 715.62 1379.94 717.59",
    className: "color9a7b9b svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#7b999b",
    points: "1370.06 732.48 1383.42 724.91 1383.42 722.21 1370.06 729.77",
    className: "color9a7b9b svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1353.04 742.11 1366.41 734.55 1366.41 731.84 1353.04 739.41",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#599499",
    points: "1336.03 751.75 1349.39 744.18 1349.39 741.48 1336.03 749.04",
    className: "color998359 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#438c92",
    points: "1319.02 761.38 1332.38 753.81 1332.38 751.11 1319.02 758.68",
    className: "color924443 svgShape"
  })))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)",
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "db",
    x1: 2840.318,
    x2: 3413.151,
    y1: 1028.051,
    y2: 1028.051,
    gradientTransform: "matrix(-1 0 0 1 4662.933 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#819ea0",
    className: "stopColor8188a0 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#628082",
    className: "stopColor626282 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#db)",
    points: "1512.65 1193.67 1822.62 1015.8 1559.75 862.43 1249.78 1040.3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dc",
    x1: 3150.287,
    x2: 3413.151,
    y1: 1144.92,
    y2: 1144.92,
    gradientTransform: "matrix(-1 0 0 1 4662.933 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b5b5e",
    className: "stopColor3b3e5e svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#628082",
    className: "stopColor626282 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#dc)",
    points: "1249.78 1040.3 1249.78 1096.17 1512.65 1249.54 1512.65 1193.67"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dd",
    x1: 2840.318,
    x2: 3150.287,
    y1: 1132.668,
    y2: 1132.668,
    gradientTransform: "matrix(-1 0 0 1 4662.933 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b5b5e",
    className: "stopColor3b3e5e svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#628082",
    className: "stopColor626282 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#dd)",
    points: "1822.62 1015.8 1822.62 1071.66 1512.65 1249.54 1512.65 1193.67"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "de",
    x1: 2871.764,
    x2: 3381.831,
    y1: 591.2,
    y2: 591.2,
    gradientTransform: "matrix(-1 0 0 1 4662.933 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#819ea0",
    className: "stopColor8188a0 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#628082",
    className: "stopColor626282 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#de)",
    points: "1515.16 738.68 1791.17 580.29 1557.11 443.72 1281.1 602.11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "df",
    x1: 2968.459,
    x2: 3721.421,
    y1: 551.87,
    y2: 533.455,
    gradientTransform: "matrix(-1 0 0 1 4662.933 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b5b5e",
    className: "stopColor3b3e5e svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#527174",
    className: "stopColor525474 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#df)",
    points: "1343.03 602.33 1360.7 612.65 1556.97 500.05 1711.65 590.13 1729.16 580.12 1556.97 479.56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dg",
    x1: 3126.009,
    x2: 3127.523,
    y1: 691.44,
    y2: 509.822,
    gradientTransform: "matrix(-1 0 0 1 4662.933 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#819ea0",
    className: "stopColor8188a0 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#628082",
    className: "stopColor626282 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#dg)",
    points: "1360.7 612.65 1515.22 702.89 1711.65 590.13 1556.97 500.05"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dh",
    x1: 3147.769,
    x2: 3381.831,
    y1: 887.154,
    y2: 887.154,
    gradientTransform: "matrix(-1 0 0 1 4662.933 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b5b5e",
    className: "stopColor3b3e5e svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#628082",
    className: "stopColor626282 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#dh)",
    points: "1281.1 602.11 1281.1 1035.63 1515.16 1172.2 1515.16 738.68"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "di",
    x1: 2871.764,
    x2: 3147.769,
    y1: 876.245,
    y2: 876.245,
    gradientTransform: "matrix(-1 0 0 1 4662.933 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b5b5e",
    className: "stopColor3b3e5e svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#152728",
    className: "stopColor151828 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#di)",
    points: "1791.17 580.29 1791.17 1013.81 1515.16 1172.2 1515.16 738.68"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dj",
    x1: 3264.757,
    x2: 3264.757,
    y1: 705.442,
    y2: 1041.87,
    gradientTransform: "matrix(-1 0 0 1 4662.933 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b5b5e",
    className: "stopColor3b3e5e svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#152728",
    className: "stopColor151828 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#dj)",
    points: "1316.25 663.2 1316.25 1015.53 1480.1 1111.13 1480.1 1093.05 1331.98 1006.61 1331.98 672.36"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dk",
    x1: 3288.91,
    x2: 3226.589,
    y1: 1016.519,
    y2: 756.051,
    gradientTransform: "matrix(-1 0 0 1 4662.933 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b5b5e",
    className: "stopColor3b3e5e svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#628082",
    className: "stopColor626282 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#dk)",
    points: "1331.98 672.36 1331.98 1006.61 1480.1 1093.05 1480.1 758.8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dl",
    x1: 3269.063,
    x2: 3257.888,
    y1: 1081.329,
    y2: 1034.622,
    gradientTransform: "matrix(-1 0 0 1 4662.933 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#819ea0",
    className: "stopColor8188a0 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#628082",
    className: "stopColor626282 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#dl)",
    points: "1331.98 1006.61 1316.25 1015.53 1480.1 1111.13 1480.1 1093.05"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dm",
    x1: 3256.226,
    x2: 3256.226,
    y1: 1937.421,
    y2: 1978.649,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b5b5e",
    className: "stopColor3b3e5e svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#152728",
    className: "stopColor151828 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#dm)",
    points: "1338.89 735.92 1474.52 815.52 1474.52 760.62 1338.89 681.02"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dn",
    x1: 3217.375,
    x2: 3192.238,
    y1: 1913.9,
    y2: 1962.644,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#dn)",
    points: "1456.93 768 1466.45 773.59 1466.45 764.07 1456.93 758.48",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "do",
    x1: 3229.026,
    x2: 3203.889,
    y1: 1919.909,
    y2: 1968.652,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#do)",
    points: "1442.18 759.35 1451.7 764.93 1451.7 755.41 1442.18 749.82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dp",
    x1: 3240.677,
    x2: 3215.54,
    y1: 1925.917,
    y2: 1974.66,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#dp)",
    points: "1427.43 750.69 1436.95 756.28 1436.95 746.76 1427.43 741.17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dq",
    x1: 3252.327,
    x2: 3227.19,
    y1: 1931.925,
    y2: 1980.669,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#dq)",
    points: "1412.68 742.03 1422.21 747.62 1422.21 738.1 1412.68 732.51"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dr",
    x1: 3263.978,
    x2: 3238.841,
    y1: 1937.933,
    y2: 1986.677,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#dr)",
    points: "1397.93 733.38 1407.46 738.97 1407.46 729.44 1397.93 723.86"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ds",
    x1: 3222.837,
    x2: 3197.7,
    y1: 1916.717,
    y2: 1965.461,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#ds)",
    points: "1456.93 781.41 1466.45 787 1466.45 777.48 1456.93 771.89",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dt",
    x1: 3234.488,
    x2: 3209.351,
    y1: 1922.726,
    y2: 1971.469,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#dt)",
    points: "1442.18 772.75 1451.7 778.34 1451.7 768.82 1442.18 763.23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "du",
    x1: 3246.139,
    x2: 3221.002,
    y1: 1928.734,
    y2: 1977.477,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#du)",
    points: "1427.43 764.1 1436.95 769.69 1436.95 760.16 1427.43 754.58",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dv",
    x1: 3257.789,
    x2: 3232.653,
    y1: 1934.742,
    y2: 1983.486,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#dv)",
    points: "1412.68 755.44 1422.21 761.03 1422.21 751.51 1412.68 745.92",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dw",
    x1: 3269.44,
    x2: 3244.303,
    y1: 1940.75,
    y2: 1989.494,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#dw)",
    points: "1397.93 746.79 1407.46 752.37 1407.46 742.85 1397.93 737.26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dx",
    x1: 3228.299,
    x2: 3203.162,
    y1: 1919.534,
    y2: 1968.277,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#dx)",
    points: "1456.93 794.82 1466.45 800.41 1466.45 790.88 1456.93 785.3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dy",
    x1: 3239.95,
    x2: 3214.813,
    y1: 1925.542,
    y2: 1974.286,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#dy)",
    points: "1442.18 786.16 1451.7 791.75 1451.7 782.23 1442.18 776.64"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dz",
    x1: 3251.601,
    x2: 3226.464,
    y1: 1931.55,
    y2: 1980.294,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#dz)",
    points: "1427.43 777.51 1436.95 783.09 1436.95 773.57 1427.43 767.98"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dA",
    x1: 3263.251,
    x2: 3238.115,
    y1: 1937.559,
    y2: 1986.302,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#dA)",
    points: "1412.68 768.85 1422.21 774.44 1422.21 764.92 1412.68 759.33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dB",
    x1: 3274.902,
    x2: 3249.765,
    y1: 1943.567,
    y2: 1992.31,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#dB)",
    points: "1397.93 760.19 1407.46 765.78 1407.46 756.26 1397.93 750.67",
    opacity: 0.41
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#17cedd",
    points: "1346.72 693.78 1346.72 730.07 1390.19 755.71 1390.19 751 1350.93 727.97 1350.93 696.26",
    className: "colordd6b17 svgShape"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dC",
    x1: 3292.374,
    x2: 3292.374,
    y1: 701.423,
    y2: 742.536,
    gradientTransform: "matrix(-1 0 0 1 4662.933 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0ce8fa",
    className: "stopColorfabb0c svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19e8f8",
    className: "stopColorf88019 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#dC)",
    points: "1350.93 696.26 1350.93 727.97 1390.19 751 1390.19 719.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#079eaa",
    points: "1350.93 727.97 1346.72 730.07 1346.72 693.78 1350.93 696.26",
    className: "coloraa4907 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dD",
    x1: 3256.226,
    x2: 3256.226,
    y1: 2004.667,
    y2: 2045.896,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b5b5e",
    className: "stopColor3b3e5e svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#152728",
    className: "stopColor151828 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#dD)",
    points: "1338.89 803.16 1474.52 882.76 1474.52 827.87 1338.89 748.27"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dE",
    x1: 3217.375,
    x2: 3192.238,
    y1: 1981.147,
    y2: 2029.89,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#dE)",
    points: "1456.93 835.25 1466.45 840.84 1466.45 831.31 1456.93 825.73",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dF",
    x1: 3229.026,
    x2: 3203.889,
    y1: 1987.155,
    y2: 2035.899,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#dF)",
    points: "1442.18 826.59 1451.7 832.18 1451.7 822.66 1442.18 817.07"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dG",
    x1: 3240.677,
    x2: 3215.54,
    y1: 1993.163,
    y2: 2041.907,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#dG)",
    points: "1427.43 817.94 1436.95 823.52 1436.95 814 1427.43 808.41"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dH",
    x1: 3252.327,
    x2: 3227.19,
    y1: 1999.171,
    y2: 2047.915,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#dH)",
    points: "1412.68 809.28 1422.21 814.87 1422.21 805.35 1412.68 799.76"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dI",
    x1: 3263.978,
    x2: 3238.841,
    y1: 2005.18,
    y2: 2053.923,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#dI)",
    points: "1397.93 800.62 1407.46 806.21 1407.46 796.69 1397.93 791.1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dJ",
    x1: 3222.837,
    x2: 3197.7,
    y1: 1983.964,
    y2: 2032.707,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#dJ)",
    points: "1456.93 848.66 1466.45 854.24 1466.45 844.72 1456.93 839.13",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dK",
    x1: 3234.488,
    x2: 3209.351,
    y1: 1989.972,
    y2: 2038.715,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#dK)",
    points: "1442.18 840 1451.7 845.59 1451.7 836.07 1442.18 830.48"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dL",
    x1: 3246.139,
    x2: 3221.002,
    y1: 1995.98,
    y2: 2044.724,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#dL)",
    points: "1427.43 831.34 1436.95 836.93 1436.95 827.41 1427.43 821.82",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dM",
    x1: 3257.789,
    x2: 3232.653,
    y1: 2001.988,
    y2: 2050.732,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#dM)",
    points: "1412.68 822.69 1422.21 828.28 1422.21 818.75 1412.68 813.17",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dN",
    x1: 3269.44,
    x2: 3244.303,
    y1: 2007.996,
    y2: 2056.74,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#dN)",
    points: "1397.93 814.03 1407.46 819.62 1407.46 810.1 1397.93 804.51"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dO",
    x1: 3228.299,
    x2: 3203.162,
    y1: 1986.78,
    y2: 2035.524,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#dO)",
    points: "1456.93 862.06 1466.45 867.65 1466.45 858.13 1456.93 852.54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dP",
    x1: 3239.95,
    x2: 3214.813,
    y1: 1992.789,
    y2: 2041.532,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#dP)",
    points: "1442.18 853.41 1451.7 859 1451.7 849.47 1442.18 843.89"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dQ",
    x1: 3251.601,
    x2: 3226.464,
    y1: 1998.797,
    y2: 2047.54,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#dQ)",
    points: "1427.43 844.75 1436.95 850.34 1436.95 840.82 1427.43 835.23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dR",
    x1: 3263.251,
    x2: 3238.115,
    y1: 2004.805,
    y2: 2053.549,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#dR)",
    points: "1412.68 836.1 1422.21 841.68 1422.21 832.16 1412.68 826.58"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dS",
    x1: 3274.902,
    x2: 3249.765,
    y1: 2010.813,
    y2: 2059.557,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#dS)",
    points: "1397.93 827.44 1407.46 833.03 1407.46 823.51 1397.93 817.92",
    opacity: 0.41
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#17cedd",
    points: "1346.72 761.03 1346.72 797.32 1390.19 822.95 1390.19 818.25 1350.93 795.21 1350.93 763.51",
    className: "colordd6b17 svgShape"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dT",
    x1: 3292.374,
    x2: 3292.374,
    y1: 768.67,
    y2: 809.782,
    gradientTransform: "matrix(-1 0 0 1 4662.933 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0ce8fa",
    className: "stopColorfabb0c svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19e8f8",
    className: "stopColorf88019 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#dT)",
    points: "1350.93 763.51 1350.93 795.21 1390.19 818.25 1390.19 786.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#079eaa",
    points: "1350.93 795.21 1346.72 797.32 1346.72 761.03 1350.93 763.51",
    className: "coloraa4907 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dU",
    x1: 3256.226,
    x2: 3256.226,
    y1: 2071.913,
    y2: 2113.142,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b5b5e",
    className: "stopColor3b3e5e svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#152728",
    className: "stopColor151828 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#dU)",
    points: "1338.89 870.41 1474.52 950.01 1474.52 895.11 1338.89 815.52"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dV",
    x1: 3217.375,
    x2: 3192.238,
    y1: 2048.393,
    y2: 2097.137,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#dV)",
    points: "1456.93 902.49 1466.45 908.08 1466.45 898.56 1456.93 892.97",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dW",
    x1: 3229.026,
    x2: 3203.889,
    y1: 2054.401,
    y2: 2103.145,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#dW)",
    points: "1442.18 893.84 1451.7 899.43 1451.7 889.9 1442.18 884.32"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dX",
    x1: 3240.677,
    x2: 3215.54,
    y1: 2060.41,
    y2: 2109.153,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#dX)",
    points: "1427.43 885.18 1436.95 890.77 1436.95 881.25 1427.43 875.66"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dY",
    x1: 3252.327,
    x2: 3227.19,
    y1: 2066.418,
    y2: 2115.161,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#dY)",
    points: "1412.68 876.53 1422.21 882.11 1422.21 872.59 1412.68 867"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dZ",
    x1: 3263.978,
    x2: 3238.841,
    y1: 2072.426,
    y2: 2121.169,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#dZ)",
    points: "1397.93 867.87 1407.46 873.46 1407.46 863.94 1397.93 858.35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ea",
    x1: 3222.837,
    x2: 3197.7,
    y1: 2051.21,
    y2: 2099.953,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#ea)",
    points: "1456.93 915.9 1466.45 921.49 1466.45 911.97 1456.93 906.38",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eb",
    x1: 3234.488,
    x2: 3209.351,
    y1: 2057.218,
    y2: 2105.962,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#eb)",
    points: "1442.18 907.25 1451.7 912.83 1451.7 903.31 1442.18 897.72"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ec",
    x1: 3246.139,
    x2: 3221.002,
    y1: 2063.226,
    y2: 2111.97,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#ec)",
    points: "1427.43 898.59 1436.95 904.18 1436.95 894.66 1427.43 889.07",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ed",
    x1: 3257.789,
    x2: 3232.653,
    y1: 2069.235,
    y2: 2117.978,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#ed)",
    points: "1412.68 889.93 1422.21 895.52 1422.21 886 1412.68 880.41",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ee",
    x1: 3269.44,
    x2: 3244.303,
    y1: 2075.243,
    y2: 2123.986,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#ee)",
    points: "1397.93 881.28 1407.46 886.87 1407.46 877.34 1397.93 871.76"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ef",
    x1: 3228.299,
    x2: 3203.162,
    y1: 2054.027,
    y2: 2102.77,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#ef)",
    points: "1456.93 929.31 1466.45 934.9 1466.45 925.38 1456.93 919.79"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eg",
    x1: 3239.95,
    x2: 3214.813,
    y1: 2060.035,
    y2: 2108.778,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#eg)",
    points: "1442.18 920.65 1451.7 926.24 1451.7 916.72 1442.18 911.13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eh",
    x1: 3251.601,
    x2: 3226.464,
    y1: 2066.043,
    y2: 2114.787,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#eh)",
    points: "1427.43 912 1436.95 917.59 1436.95 908.07 1427.43 902.48"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ei",
    x1: 3263.251,
    x2: 3238.115,
    y1: 2072.051,
    y2: 2120.795,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#ei)",
    points: "1412.68 903.34 1422.21 908.93 1422.21 899.41 1412.68 893.82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ej",
    x1: 3274.902,
    x2: 3249.765,
    y1: 2078.06,
    y2: 2126.803,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#ej)",
    points: "1397.93 894.69 1407.46 900.27 1407.46 890.75 1397.93 885.17",
    opacity: 0.41
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#17cedd",
    points: "1346.72 828.28 1346.72 864.56 1390.19 890.2 1390.19 885.49 1350.93 862.46 1350.93 830.75",
    className: "colordd6b17 svgShape"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ek",
    x1: 3292.374,
    x2: 3292.374,
    y1: 835.916,
    y2: 877.028,
    gradientTransform: "matrix(-1 0 0 1 4662.933 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0ce8fa",
    className: "stopColorfabb0c svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19e8f8",
    className: "stopColorf88019 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#ek)",
    points: "1350.93 830.75 1350.93 862.46 1390.19 885.49 1390.19 853.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#079eaa",
    points: "1350.93 862.46 1346.72 864.56 1346.72 828.28 1350.93 830.75",
    className: "coloraa4907 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "el",
    x1: 3256.226,
    x2: 3256.226,
    y1: 2139.16,
    y2: 2180.388,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b5b5e",
    className: "stopColor3b3e5e svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#152728",
    className: "stopColor151828 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#el)",
    points: "1338.89 937.66 1474.52 1017.25 1474.52 962.36 1338.89 882.76"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "em",
    x1: 3217.375,
    x2: 3192.238,
    y1: 2115.639,
    y2: 2164.383,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#em)",
    points: "1456.93 969.74 1466.45 975.33 1466.45 965.81 1456.93 960.22",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "en",
    x1: 3229.026,
    x2: 3203.889,
    y1: 2121.648,
    y2: 2170.391,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#en)",
    points: "1442.18 961.08 1451.7 966.67 1451.7 957.15 1442.18 951.56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eo",
    x1: 3240.677,
    x2: 3215.54,
    y1: 2127.656,
    y2: 2176.399,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#eo)",
    points: "1427.43 952.43 1436.95 958.02 1436.95 948.49 1427.43 942.91"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ep",
    x1: 3252.327,
    x2: 3227.19,
    y1: 2133.664,
    y2: 2182.408,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#ep)",
    points: "1412.68 943.77 1422.21 949.36 1422.21 939.84 1412.68 934.25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eq",
    x1: 3263.978,
    x2: 3238.841,
    y1: 2139.672,
    y2: 2188.416,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#eq)",
    points: "1397.93 935.12 1407.46 940.7 1407.46 931.18 1397.93 925.6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "er",
    x1: 3222.837,
    x2: 3197.7,
    y1: 2118.456,
    y2: 2167.2,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#er)",
    points: "1456.93 983.15 1466.45 988.74 1466.45 979.21 1456.93 973.63",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "es",
    x1: 3234.488,
    x2: 3209.351,
    y1: 2124.464,
    y2: 2173.208,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#es)",
    points: "1442.18 974.49 1451.7 980.08 1451.7 970.56 1442.18 964.97"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "et",
    x1: 3246.139,
    x2: 3221.002,
    y1: 2130.473,
    y2: 2179.216,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#et)",
    points: "1427.43 965.84 1436.95 971.42 1436.95 961.9 1427.43 956.32",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eu",
    x1: 3257.789,
    x2: 3232.653,
    y1: 2136.481,
    y2: 2185.224,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#eu)",
    points: "1412.68 957.18 1422.21 962.77 1422.21 953.25 1412.68 947.66",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ev",
    x1: 3269.44,
    x2: 3244.303,
    y1: 2142.489,
    y2: 2191.233,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#ev)",
    points: "1397.93 948.52 1407.46 954.11 1407.46 944.59 1397.93 939"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ew",
    x1: 3228.299,
    x2: 3203.162,
    y1: 2121.273,
    y2: 2170.016,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#ew)",
    points: "1456.93 996.56 1466.45 1002.14 1466.45 992.62 1456.93 987.04"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ex",
    x1: 3239.95,
    x2: 3214.813,
    y1: 2127.281,
    y2: 2176.025,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#ex)",
    points: "1442.18 987.9 1451.7 993.49 1451.7 983.97 1442.18 978.38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ey",
    x1: 3251.601,
    x2: 3226.464,
    y1: 2133.289,
    y2: 2182.033,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#ey)",
    points: "1427.43 979.24 1436.95 984.83 1436.95 975.31 1427.43 969.72"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ez",
    x1: 3263.251,
    x2: 3238.115,
    y1: 2139.298,
    y2: 2188.041,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#ez)",
    points: "1412.68 970.59 1422.21 976.18 1422.21 966.66 1412.68 961.07"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eA",
    x1: 3274.902,
    x2: 3249.765,
    y1: 2145.306,
    y2: 2194.049,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#eA)",
    points: "1397.93 961.93 1407.46 967.52 1407.46 958 1397.93 952.41",
    opacity: 0.41
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#17cedd",
    points: "1346.72 895.52 1346.72 931.81 1390.19 957.44 1390.19 952.74 1350.93 929.7 1350.93 898",
    className: "colordd6b17 svgShape"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eB",
    x1: 3292.374,
    x2: 3292.374,
    y1: 903.162,
    y2: 944.275,
    gradientTransform: "matrix(-1 0 0 1 4662.933 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0ce8fa",
    className: "stopColorfabb0c svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19e8f8",
    className: "stopColorf88019 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#eB)",
    points: "1350.93 898 1350.93 929.7 1390.19 952.74 1390.19 921.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#079eaa",
    points: "1350.93 929.7 1346.72 931.81 1346.72 895.52 1350.93 898",
    className: "coloraa4907 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "eC",
    x1: 3256.226,
    x2: 3256.226,
    y1: 2206.406,
    y2: 2247.635,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b5b5e",
    className: "stopColor3b3e5e svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#152728",
    className: "stopColor151828 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#eC)",
    points: "1338.89 1004.9 1474.52 1084.5 1474.52 1029.61 1338.89 950.01"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "eD",
    x1: 3217.375,
    x2: 3192.238,
    y1: 2182.886,
    y2: 2231.629,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#eD)",
    points: "1456.93 1036.99 1466.45 1042.57 1466.45 1033.05 1456.93 1027.47",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eE",
    x1: 3229.026,
    x2: 3203.889,
    y1: 2188.894,
    y2: 2237.637,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#eE)",
    points: "1442.18 1028.33 1451.7 1033.92 1451.7 1024.4 1442.18 1018.81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eF",
    x1: 3240.677,
    x2: 3215.54,
    y1: 2194.902,
    y2: 2243.646,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#eF)",
    points: "1427.43 1019.67 1436.95 1025.26 1436.95 1015.74 1427.43 1010.15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eG",
    x1: 3252.327,
    x2: 3227.19,
    y1: 2200.91,
    y2: 2249.654,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#eG)",
    points: "1412.68 1011.02 1422.21 1016.61 1422.21 1007.09 1412.68 1001.5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eH",
    x1: 3263.978,
    x2: 3238.841,
    y1: 2206.919,
    y2: 2255.662,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#eH)",
    points: "1397.93 1002.36 1407.46 1007.95 1407.46 998.43 1397.93 992.84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eI",
    x1: 3222.837,
    x2: 3197.7,
    y1: 2185.702,
    y2: 2234.446,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#eI)",
    points: "1456.93 1050.39 1466.45 1055.98 1466.45 1046.46 1456.93 1040.87",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eJ",
    x1: 3234.488,
    x2: 3209.351,
    y1: 2191.711,
    y2: 2240.454,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#eJ)",
    points: "1442.18 1041.74 1451.7 1047.33 1451.7 1037.81 1442.18 1032.22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eK",
    x1: 3246.139,
    x2: 3221.002,
    y1: 2197.719,
    y2: 2246.462,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#eK)",
    points: "1427.43 1033.08 1436.95 1038.67 1436.95 1029.15 1427.43 1023.56",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eL",
    x1: 3257.789,
    x2: 3232.653,
    y1: 2203.727,
    y2: 2252.471,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#eL)",
    points: "1412.68 1024.43 1422.21 1030.01 1422.21 1020.49 1412.68 1014.91",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eM",
    x1: 3269.44,
    x2: 3244.303,
    y1: 2209.735,
    y2: 2258.479,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#eM)",
    points: "1397.93 1015.77 1407.46 1021.36 1407.46 1011.84 1397.93 1006.25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eN",
    x1: 3228.299,
    x2: 3203.162,
    y1: 2188.519,
    y2: 2237.263,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#eN)",
    points: "1456.93 1063.8 1466.45 1069.39 1466.45 1059.87 1456.93 1054.28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eO",
    x1: 3239.95,
    x2: 3214.813,
    y1: 2194.527,
    y2: 2243.271,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#eO)",
    points: "1442.18 1055.15 1451.7 1060.73 1451.7 1051.21 1442.18 1045.63"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eP",
    x1: 3251.601,
    x2: 3226.464,
    y1: 2200.536,
    y2: 2249.279,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#eP)",
    points: "1427.43 1046.49 1436.95 1052.08 1436.95 1042.56 1427.43 1036.97"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eQ",
    x1: 3263.251,
    x2: 3238.115,
    y1: 2206.544,
    y2: 2255.287,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#eQ)",
    points: "1412.68 1037.84 1422.21 1043.42 1422.21 1033.9 1412.68 1028.31"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eR",
    x1: 3274.902,
    x2: 3249.765,
    y1: 2212.552,
    y2: 2261.296,
    gradientTransform: "matrix(-1 -.5869 0 1 4662.933 699.582)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf0f7",
    className: "stopColor9cd2f7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#eR)",
    points: "1397.93 1029.18 1407.46 1034.77 1407.46 1025.25 1397.93 1019.66",
    opacity: 0.41
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#17cedd",
    points: "1346.72 962.77 1346.72 999.05 1390.19 1024.69 1390.19 1019.98 1350.93 996.95 1350.93 965.25",
    className: "colordd6b17 svgShape"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eS",
    x1: 3292.374,
    x2: 3292.374,
    y1: 970.409,
    y2: 1011.521,
    gradientTransform: "matrix(-1 0 0 1 4662.933 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0ce8fa",
    className: "stopColorfabb0c svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19e8f8",
    className: "stopColorf88019 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#eS)",
    points: "1350.93 965.25 1350.93 996.95 1390.19 1019.98 1390.19 988.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#079eaa",
    points: "1350.93 996.95 1346.72 999.05 1346.72 962.77 1350.93 965.25",
    className: "coloraa4907 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "eT",
    x1: 2892.499,
    x2: 3118.616,
    y1: 703.365,
    y2: 703.365,
    gradientTransform: "matrix(-1 0 0 1 4662.93 .065)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#819ea0",
    className: "stopColor8188a0 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#628082",
    className: "stopColor626282 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#eT)",
    points: "1557.8 768.28 1770.43 646.27 1756.95 638.58 1544.31 760.6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eU",
    x1: 3111.876,
    x2: 3111.876,
    y1: 744.922,
    y2: 1057.406,
    gradientTransform: "matrix(-1 0 0 1 4662.933 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b5b5e",
    className: "stopColor3b3e5e svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#152728",
    className: "stopColor151828 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#eU)",
    points: "1544.31 760.6 1544.32 1094.58 1557.8 1102.27 1557.8 768.28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eV",
    x1: 2971.492,
    x2: 3019.196,
    y1: 1047.328,
    y2: 745.206,
    gradientTransform: "matrix(-1 0 0 1 4662.933 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b5b5e",
    className: "stopColor3b3e5e svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#628082",
    className: "stopColor626282 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#eV)",
    points: "1770.43 646.27 1770.43 980.25 1557.8 1102.27 1557.8 768.28"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1750.85 866.51 1755.53 863.91 1755.53 861.85 1750.85 864.44",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1750.85 873.99 1755.53 871.39 1755.53 869.33 1750.85 871.92",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1750.85 881.47 1755.53 878.88 1755.53 876.81 1750.85 879.41",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1750.85 888.95 1755.53 886.36 1755.53 884.29 1750.85 886.89",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1750.85 896.44 1755.53 893.84 1755.53 891.77 1750.85 894.37",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1750.85 903.92 1755.53 901.32 1755.53 899.26 1750.85 901.85",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1750.85 911.4 1755.53 908.8 1755.53 906.74 1750.85 909.33",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1750.85 918.88 1755.53 916.29 1755.53 914.22 1750.85 916.82",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1750.85 926.36 1755.53 923.77 1755.53 921.7 1750.85 924.3",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1750.85 933.85 1755.53 931.25 1755.53 929.18 1750.85 931.78",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1750.85 941.33 1755.53 938.73 1755.53 936.67 1750.85 939.26",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1750.85 948.81 1755.53 946.21 1755.53 944.15 1750.85 946.74",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1750.85 956.29 1755.53 953.7 1755.53 951.63 1750.85 954.22",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1750.85 963.77 1755.53 961.18 1755.53 959.11 1750.85 961.71",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1750.85 971.26 1755.53 968.66 1755.53 966.59 1750.85 969.19",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1750.85 978.74 1755.53 976.14 1755.53 974.08 1750.85 976.67",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1736.01 874.73 1740.69 872.14 1740.69 870.07 1736.01 872.67",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1736.01 882.22 1740.69 879.62 1740.69 877.56 1736.01 880.15",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1713.63 894.63 1730.86 885.07 1730.86 883.01 1713.63 892.56",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1692.14 906.54 1709.37 896.99 1709.37 894.92 1692.14 904.47",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1670.66 918.45 1687.89 908.9 1687.89 906.83 1670.66 916.38",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1649.18 930.36 1666.41 920.81 1666.41 918.74 1649.18 928.3",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1627.7 942.27 1644.93 932.72 1644.93 930.65 1627.7 940.21",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1606.21 954.19 1623.45 944.63 1623.45 942.57 1606.21 952.12",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1584.73 966.1 1601.96 956.54 1601.96 954.48 1584.73 964.03",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1710 904.12 1730.86 892.56 1730.86 890.49 1710 902.05",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1684 918.53 1704.86 906.97 1704.86 904.91 1684 916.47",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1658.01 932.95 1678.86 921.39 1678.86 919.32 1658.01 930.88",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1632.01 947.37 1652.86 935.8 1652.86 933.74 1632.01 945.3",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1606.01 961.78 1626.86 950.22 1626.86 948.15 1606.01 959.72",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1580.01 976.2 1600.86 964.63 1600.86 962.57 1580.01 974.13",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1713.63 947 1730.86 937.45 1730.86 935.38 1713.63 944.94",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1692.14 958.91 1709.37 949.36 1709.37 947.29 1692.14 956.85",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1670.66 970.82 1687.89 961.27 1687.89 959.2 1670.66 968.76",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1649.18 982.74 1666.41 973.18 1666.41 971.12 1649.18 980.67",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1627.7 994.65 1644.93 985.09 1644.93 983.03 1627.7 992.58",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1606.21 1006.56 1623.45 997.01 1623.45 994.94 1606.21 1004.49",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1584.73 1018.47 1601.96 1008.92 1601.96 1006.85 1584.73 1016.4",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1710 956.49 1730.86 944.93 1730.86 942.86 1710 954.43",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1684 970.91 1704.86 959.35 1704.86 957.28 1684 968.84",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1658.01 985.32 1678.86 973.76 1678.86 971.69 1658.01 983.26",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1632.01 999.74 1652.86 988.18 1652.86 986.11 1632.01 997.67",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1606.01 1014.16 1626.86 1002.59 1626.86 1000.53 1606.01 1012.09",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1580.01 1028.57 1600.86 1017.01 1600.86 1014.94 1580.01 1026.5",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1713.63 909.59 1730.86 900.04 1730.86 897.97 1713.63 907.53",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1692.14 921.5 1709.37 911.95 1709.37 909.88 1692.14 919.44",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1670.66 933.41 1687.89 923.86 1687.89 921.79 1670.66 931.35",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1713.63 976.93 1730.86 967.38 1730.86 965.31 1713.63 974.86",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1692.14 988.84 1709.37 979.29 1709.37 977.22 1692.14 986.77",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1670.66 1000.75 1687.89 991.2 1687.89 989.13 1670.66 998.69",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1649.18 1012.66 1666.41 1003.11 1666.41 1001.04 1649.18 1010.6",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1627.7 1024.58 1644.93 1015.02 1644.93 1012.96 1627.7 1022.51",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1606.21 1036.49 1623.45 1026.93 1623.45 1024.87 1606.21 1034.42",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1584.73 1048.4 1601.96 1038.84 1601.96 1036.78 1584.73 1046.33",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1710 986.42 1730.86 974.86 1730.86 972.79 1710 984.35",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1684 1000.84 1704.86 989.27 1704.86 987.21 1684 998.77",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1658.01 1015.25 1678.86 1003.69 1678.86 1001.62 1658.01 1013.19",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1632.01 1029.67 1652.86 1018.1 1652.86 1016.04 1632.01 1027.6",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1606.01 1044.08 1626.86 1032.52 1626.86 1030.45 1606.01 1042.02",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1580.01 1058.5 1600.86 1046.94 1600.86 1044.87 1580.01 1056.43",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1713.63 991.89 1730.86 982.34 1730.86 980.27 1713.63 989.83",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1692.14 1003.8 1709.37 994.25 1709.37 992.18 1692.14 1001.74",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1670.66 1015.72 1687.89 1006.16 1687.89 1004.1 1670.66 1013.65",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1736.01 889.7 1740.69 887.1 1740.69 885.04 1736.01 887.63",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1736.01 897.18 1740.69 894.59 1740.69 892.52 1736.01 895.11",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1736.01 904.66 1740.69 902.07 1740.69 900 1736.01 902.6",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#599499",
    points: "1714.77 923.92 1740.69 909.55 1740.69 907.48 1714.77 921.86",
    className: "color998359 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1686.05 939.84 1711.98 925.47 1711.98 923.4 1686.05 937.78",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1657.34 955.76 1683.26 941.39 1683.26 939.32 1657.34 953.7",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#599499",
    points: "1714.77 968.82 1740.69 954.44 1740.69 952.38 1714.77 966.75",
    className: "color998359 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1686.05 984.74 1711.98 970.36 1711.98 968.3 1686.05 982.67",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1657.34 1000.66 1683.26 986.28 1683.26 984.22 1657.34 998.59",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1736.01 919.63 1740.69 917.03 1740.69 914.97 1736.01 917.56",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1736.01 927.11 1740.69 924.51 1740.69 922.45 1736.01 925.04",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1736.01 934.59 1740.69 932 1740.69 929.93 1736.01 932.52",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1736.01 942.07 1740.69 939.48 1740.69 937.41 1736.01 940.01",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1736.01 949.55 1740.69 946.96 1740.69 944.89 1736.01 947.49",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1736.01 964.52 1740.69 961.92 1740.69 959.86 1736.01 962.45",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1736.01 972 1740.69 969.41 1740.69 967.34 1736.01 969.93",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1736.01 979.48 1740.69 976.89 1740.69 974.82 1736.01 977.42",
    className: "color99a7c6 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99c3c6",
    points: "1736.01 986.96 1740.69 984.37 1740.69 982.3 1736.01 984.9",
    className: "color99a7c6 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1676.14 729.3 1679.62 727.33 1679.62 724.62 1676.14 726.6",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1676.14 735.89 1679.62 733.92 1679.62 731.21 1676.14 733.18",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1676.14 742.47 1679.62 740.5 1679.62 737.8 1676.14 739.77",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1676.14 749.06 1679.62 747.09 1679.62 744.38 1676.14 746.36",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1676.14 755.65 1679.62 753.67 1679.62 750.97 1676.14 752.94",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1676.14 762.23 1679.62 760.26 1679.62 757.56 1676.14 759.53",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1676.14 768.82 1679.62 766.85 1679.62 764.14 1676.14 766.11",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1676.14 775.41 1679.62 773.43 1679.62 770.73 1676.14 772.7",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1676.14 781.99 1679.62 780.02 1679.62 777.31 1676.14 779.29",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1676.14 788.58 1679.62 786.61 1679.62 783.9 1676.14 785.87",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1676.14 795.16 1679.62 793.19 1679.62 790.49 1676.14 792.46",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1676.14 801.75 1679.62 799.78 1679.62 797.07 1676.14 799.05",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1676.14 808.34 1679.62 806.36 1679.62 803.66 1676.14 805.63",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1676.14 814.92 1679.62 812.95 1679.62 810.25 1676.14 812.22",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1676.14 821.51 1679.62 819.54 1679.62 816.83 1676.14 818.8",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1676.14 828.1 1679.62 826.12 1679.62 823.42 1676.14 825.39",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1676.14 834.68 1679.62 832.71 1679.62 830 1676.14 831.98",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1676.14 841.27 1679.62 839.3 1679.62 836.59 1676.14 838.56",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1676.14 847.85 1679.62 845.88 1679.62 843.18 1676.14 845.15",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1676.14 854.44 1679.62 852.47 1679.62 849.76 1676.14 851.74",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1676.14 861.03 1679.62 859.05 1679.62 856.35 1676.14 858.32",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1676.14 867.61 1679.62 865.64 1679.62 862.94 1676.14 864.91",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1676.14 874.2 1679.62 872.23 1679.62 869.52 1676.14 871.49",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1676.14 880.79 1679.62 878.81 1679.62 876.11 1676.14 878.08",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1676.14 887.37 1679.62 885.4 1679.62 882.69 1676.14 884.67",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1746.72 689.33 1750.21 687.36 1750.21 684.65 1746.72 686.63",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#599499",
    points: "1731.48 697.97 1743.69 691.05 1743.69 688.35 1731.48 695.26",
    className: "color998359 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#599499",
    points: "1716.49 706.45 1728.7 699.54 1728.7 696.83 1716.49 703.75",
    className: "color998359 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#599499",
    points: "1701.5 714.94 1713.71 708.02 1713.71 705.32 1701.5 712.23",
    className: "color998359 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1746.72 695.92 1750.21 693.94 1750.21 691.24 1746.72 693.21",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1746.72 702.5 1750.21 700.53 1750.21 697.83 1746.72 699.8",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1733.78 709.83 1743.01 704.6 1743.01 701.9 1733.78 707.13",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1723.12 715.87 1732.35 710.64 1732.35 707.94 1723.12 713.17",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1712.46 721.91 1721.7 716.68 1721.7 713.97 1712.46 719.2",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1746.72 709.09 1750.21 707.12 1750.21 704.41 1746.72 706.38",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1728.92 719.17 1744.3 710.46 1744.3 707.76 1728.92 716.46",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1711.62 728.97 1726.99 720.26 1726.99 717.56 1711.62 726.27",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1694.31 738.77 1709.68 730.07 1709.68 727.36 1694.31 736.07",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1746.72 715.68 1750.21 713.7 1750.21 711 1746.72 712.97",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1732.99 723.46 1744.3 717.05 1744.3 714.34 1732.99 720.75",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1746.72 722.26 1750.21 720.29 1750.21 717.58 1746.72 719.56",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1738.18 727.1 1741.66 725.13 1741.66 722.43 1738.18 724.4",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1746.72 728.85 1750.21 726.88 1750.21 724.17 1746.72 726.14",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1738.18 733.69 1741.66 731.72 1741.66 729.01 1738.18 730.98",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1746.72 735.43 1750.21 733.46 1750.21 730.76 1746.72 732.73",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1738.18 740.28 1741.66 738.3 1741.66 735.6 1738.18 737.57",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1723.12 735.63 1737.02 727.76 1737.02 725.05 1723.12 732.92",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1718.63 744.76 1737.02 734.35 1737.02 731.64 1718.63 742.05",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1716.47 752.57 1737.02 740.93 1737.02 738.23 1716.47 749.86",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1746.72 742.02 1750.21 740.05 1750.21 737.34 1746.72 739.32",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1733.53 749.49 1737.02 747.52 1737.02 744.81 1733.53 746.79",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1711.2 762.14 1731.77 750.49 1731.77 747.79 1711.2 759.44",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1746.72 748.61 1750.21 746.63 1750.21 743.93 1746.72 745.9",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1746.72 755.19 1750.21 753.22 1750.21 750.52 1746.72 752.49",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1746.72 761.78 1750.21 759.81 1750.21 757.1 1746.72 759.07",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1746.72 768.37 1750.21 766.39 1750.21 763.69 1746.72 765.66",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1746.72 774.95 1750.21 772.98 1750.21 770.27 1746.72 772.25",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1746.72 781.54 1750.21 779.56 1750.21 776.86 1746.72 778.83",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1746.72 788.12 1750.21 786.15 1750.21 783.45 1746.72 785.42",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1746.72 794.71 1750.21 792.74 1750.21 790.03 1746.72 792.01",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1717.68 765.05 1731.42 757.28 1731.42 754.57 1717.68 762.35",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1702.14 773.85 1715.88 766.07 1715.88 763.37 1702.14 771.15",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1686.6 782.65 1700.34 774.87 1700.34 772.17 1686.6 779.95",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1719.76 770.46 1731.42 763.86 1731.42 761.16 1719.76 767.76",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1706.55 777.95 1718.2 771.34 1718.2 768.64 1706.55 775.24",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1693.33 785.43 1704.99 778.83 1704.99 776.12 1693.33 782.72",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#438c92",
    points: "1717.42 778.37 1731.42 770.45 1731.42 767.74 1717.42 775.67",
    className: "color924443 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1701.56 787.36 1715.56 779.43 1715.56 776.72 1701.56 784.65",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1719.76 783.64 1731.42 777.03 1731.42 774.33 1719.76 780.93",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1705.76 791.56 1717.42 784.96 1717.42 782.26 1705.76 788.86",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1719.76 790.22 1731.42 783.62 1731.42 780.92 1719.76 787.52",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1706.86 797.53 1718.52 790.92 1718.52 788.22 1706.86 794.82",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1693.96 804.83 1705.62 798.23 1705.62 795.52 1693.96 802.12",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1722.06 795.5 1731.42 790.21 1731.42 787.5 1722.06 792.8",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1711.46 801.51 1720.81 796.21 1720.81 793.51 1711.46 798.8",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1700.86 807.51 1710.21 802.21 1710.21 799.51 1700.86 804.81",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1690.26 813.52 1699.61 808.22 1699.61 805.51 1690.26 810.81",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1719.76 803.4 1731.42 796.79 1731.42 794.09 1719.76 800.69",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1706.86 810.7 1718.52 804.1 1718.52 801.39 1706.86 807.99",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1693.96 818 1705.62 811.4 1705.62 808.69 1693.96 815.3",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1719.76 809.98 1731.42 803.38 1731.42 800.67 1719.76 807.28",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1706.55 817.46 1718.2 810.86 1718.2 808.16 1706.55 814.76",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1746.72 801.3 1750.21 799.32 1750.21 796.62 1746.72 798.59",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1746.72 807.88 1750.21 805.91 1750.21 803.2 1746.72 805.18",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1746.72 814.47 1750.21 812.5 1750.21 809.79 1746.72 811.76",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1746.72 821.06 1750.21 819.08 1750.21 816.38 1746.72 818.35",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1746.72 827.64 1750.21 825.67 1750.21 822.96 1746.72 824.94",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1738.18 806.14 1741.66 804.16 1741.66 801.46 1738.18 803.43",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1738.18 812.72 1741.66 810.75 1741.66 808.05 1738.18 810.02",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1738.18 819.31 1741.66 817.34 1741.66 814.63 1738.18 816.61",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1738.18 825.9 1741.66 823.92 1741.66 821.22 1738.18 823.19",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1738.18 832.48 1741.66 830.51 1741.66 827.8 1738.18 829.78",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1719.38 816.78 1736.3 807.2 1736.3 804.49 1719.38 814.07",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1725.59 819.85 1736.3 813.78 1736.3 811.08 1725.59 817.15",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1721.85 828.55 1736.3 820.37 1736.3 817.67 1721.85 825.85",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1724.56 833.61 1736.3 826.96 1736.3 824.25 1724.56 830.9",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1728.59 837.91 1736.3 833.54 1736.3 830.84 1728.59 835.2",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1746.72 834.23 1750.21 832.25 1750.21 829.55 1746.72 831.52",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1746.72 840.81 1750.21 838.84 1750.21 836.14 1746.72 838.11",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1746.72 847.4 1750.21 845.43 1750.21 842.72 1746.72 844.7",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1741.66 837.1 1745.14 835.12 1745.14 832.42 1741.66 834.39",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1741.66 843.68 1745.14 841.71 1745.14 839 1741.66 840.98",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1741.66 850.27 1745.14 848.3 1745.14 845.59 1741.66 847.56",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1725.95 845.99 1739.12 838.53 1739.12 835.83 1725.95 843.29",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1730.1 850.23 1739.12 845.12 1739.12 842.41 1730.1 847.52",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1732.53 855.44 1739.12 851.7 1739.12 849 1732.53 852.73",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#7b999b",
    points: "1660.52 738.15 1669.84 732.87 1669.84 730.17 1660.52 735.45",
    className: "color9a7b9b svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1644.19 747.4 1659.4 738.78 1659.4 736.08 1644.19 744.69",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#438c92",
    points: "1650.46 750.43 1669.84 739.46 1669.84 736.75 1650.46 747.73",
    className: "color924443 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#599499",
    points: "1627.32 763.53 1646.7 752.56 1646.7 749.86 1627.32 760.83",
    className: "color998359 svgShape"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eW",
    x1: 3039.374,
    x2: 3058.752,
    y1: -295.029,
    y2: -295.029,
    gradientTransform: "matrix(-1 .5663 0 1 4662.934 -661.86)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1dc1ce",
    className: "stopColor1d7ece svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17838c",
    className: "stopColor17538c svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#eW)",
    points: "1604.18 776.64 1623.56 765.66 1623.56 762.96 1604.18 773.93"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eX",
    x1: 3062.514,
    x2: 3081.892,
    y1: -295.029,
    y2: -295.029,
    gradientTransform: "matrix(-1 .5663 0 1 4662.934 -661.86)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1dc1ce",
    className: "stopColor1d7ece svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17838c",
    className: "stopColor17538c svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#eX)",
    points: "1581.04 789.74 1600.42 778.77 1600.42 776.06 1581.04 787.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#7b999b",
    points: "1661.01 751.04 1669.84 746.04 1669.84 743.34 1661.01 748.34",
    className: "color9a7b9b svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#438c92",
    points: "1637.01 764.63 1658.65 752.38 1658.65 749.67 1637.01 761.93",
    className: "color924443 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1612.74 778.38 1634.38 766.12 1634.38 763.42 1612.74 775.67",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1641.04 768.94 1661.89 757.13 1661.89 754.43 1641.04 766.23",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#599499",
    points: "1618.02 781.98 1638.87 770.17 1638.87 767.46 1618.02 779.27",
    className: "color998359 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1594.99 795.01 1615.85 783.21 1615.85 780.5 1594.99 792.31",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1571.97 808.05 1592.82 796.24 1592.82 793.54 1571.97 805.35",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#7b999b",
    points: "1654.28 768.03 1666.02 761.38 1666.02 758.67 1654.28 765.32",
    className: "color9a7b9b svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1649.75 777.18 1663.12 769.61 1663.12 766.9 1649.75 774.47",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1633.92 786.14 1647.28 778.57 1647.28 775.87 1633.92 783.44",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#7b999b",
    points: "1657.37 779.45 1665.79 774.68 1665.79 771.97 1657.37 776.74",
    className: "color9a7b9b svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#7b999b",
    points: "1662.61 783.07 1669.84 778.97 1669.84 776.27 1662.61 780.36",
    className: "color9a7b9b svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#7b999b",
    points: "1659.22 798.16 1669.84 792.15 1669.84 789.44 1659.22 795.46",
    className: "color9a7b9b svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1646.73 805.23 1657.35 799.22 1657.35 796.51 1646.73 802.53",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#438c92",
    points: "1649.89 810.03 1666.27 800.75 1666.27 798.05 1649.89 807.32",
    className: "color924443 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#599499",
    points: "1631.81 820.27 1648.19 810.99 1648.19 808.29 1631.81 817.56",
    className: "color998359 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1613.73 830.51 1630.11 821.23 1630.11 818.53 1613.73 827.8",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1595.65 840.75 1612.02 831.47 1612.02 828.77 1595.65 838.04",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1577.56 850.99 1593.94 841.71 1593.94 839.01 1577.56 848.28",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#7b999b",
    points: "1660.28 810.73 1669.84 805.32 1669.84 802.61 1660.28 808.02",
    className: "color9a7b9b svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#7b999b",
    points: "1661.7 823.1 1669.84 818.49 1669.84 815.79 1661.7 820.4",
    className: "color9a7b9b svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1646.14 831.91 1660.28 823.9 1660.28 821.2 1646.14 829.21",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#438c92",
    points: "1648.19 837.34 1666.27 827.1 1666.27 824.39 1648.19 834.63",
    className: "color924443 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#599499",
    points: "1628.06 848.74 1646.14 838.5 1646.14 835.79 1628.06 846.03",
    className: "color998359 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1607.93 860.14 1626.01 849.9 1626.01 847.19 1607.93 857.43",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1587.8 871.53 1605.89 861.29 1605.89 858.59 1587.8 868.83",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1567.68 882.93 1585.76 872.69 1585.76 869.99 1567.68 880.23",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#7b999b",
    points: "1662.01 836.1 1665.5 834.12 1665.5 831.42 1662.01 833.39",
    className: "color9a7b9b svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#438c92",
    points: "1644.98 845.74 1659.55 837.49 1659.55 834.78 1644.98 843.04",
    className: "color924443 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1627.46 855.66 1642.03 847.41 1642.03 844.71 1627.46 852.96",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1609.94 865.58 1624.51 857.33 1624.51 854.63 1609.94 862.88",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1592.42 875.5 1606.99 867.25 1606.99 864.55 1592.42 872.8",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1640.71 854.74 1661.29 843.09 1661.29 840.38 1640.71 852.04",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#599499",
    points: "1617.77 867.74 1638.35 856.08 1638.35 853.38 1617.77 865.03",
    className: "color998359 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cdd7d8",
    points: "1594.83 880.73 1615.41 869.08 1615.41 866.37 1594.83 878.03",
    className: "colorcdd8d4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#438c92",
    points: "1571.88 893.72 1592.46 882.07 1592.46 879.36 1571.88 891.02",
    className: "color924443 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#7b999b",
    points: "1657.86 851.62 1665.5 847.3 1665.5 844.59 1657.86 848.91",
    className: "color9a7b9b svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1649.44 862.98 1662.03 855.85 1662.03 853.14 1649.44 860.27",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#599499",
    points: "1634.97 871.17 1647.56 864.04 1647.56 861.34 1634.97 868.47",
    className: "color998359 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#7b999b",
    points: "1659 864.15 1665.5 860.47 1665.5 857.76 1659 861.44",
    className: "color9a7b9b svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#7b999b",
    points: "1662.88 868.54 1669.84 864.6 1669.84 861.89 1662.88 865.83",
    className: "color9a7b9b svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#599499",
    points: "1655.33 885.98 1669.84 877.77 1669.84 875.06 1655.33 883.28",
    className: "color998359 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1638.89 895.29 1653.4 887.08 1653.4 884.37 1638.89 892.59",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#7b999b",
    points: "1666.35 886.33 1669.84 884.35 1669.84 881.65 1666.35 883.62",
    className: "color9a7b9b svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#7b999b",
    points: "1656.47 898.51 1669.84 890.94 1669.84 888.24 1656.47 895.8",
    className: "color9a7b9b svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1639.46 908.14 1652.83 900.57 1652.83 897.87 1639.46 905.44",
    className: "color247489 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#599499",
    points: "1622.45 917.78 1635.81 910.21 1635.81 907.5 1622.45 915.07",
    className: "color998359 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#438c92",
    points: "1605.43 927.41 1618.8 919.84 1618.8 917.14 1605.43 924.71",
    className: "color924443 svgShape"
  })))))))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#c9d2d3",
    points: "876.83 1536.01 1427.1 1882.99 1457.95 1864.9 1457.95 956.03 876.83 627.14",
    className: "colorc9c9d3 svgShape"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eY",
    x1: 1420.557,
    x2: 1106.786,
    y1: 885.419,
    y2: 1303.779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b6c4c5",
    className: "stopColorb6bac5 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7d9c9e",
    className: "stopColor7d859e svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#eY)",
    points: "845.98 1554.09 1427.1 1882.99 1427.1 974.11 845.98 645.22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eZ",
    x1: 845.982,
    x2: 1457.954,
    y1: 800.626,
    y2: 800.626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cbd5d6",
    className: "stopColorcbcbd6 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9fafa",
    className: "stopColorf9faf9 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#eZ)",
    points: "1457.95 956.03 1427.1 974.11 845.98 645.22 876.83 627.14"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#c9d2d3",
    points: "807.28 1570.36 1357.55 1917.33 1388.4 1899.25 1388.4 990.38 807.28 661.49",
    className: "colorc9c9d3 svgShape"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fa",
    x1: 826.426,
    x2: 1025.145,
    y1: 2068.726,
    y2: 1432.443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cbd5d6",
    className: "stopColorcbcbd6 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9fafa",
    className: "stopColorf9faf9 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#fa)",
    points: "776.43 1588.44 1357.55 1917.33 1357.55 1008.46 776.43 679.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#dbdddd",
    points: "1204.94 922.09 1357.55 1182.21 1357.55 1008.46",
    className: "colordbdbdd svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#feffff",
    points: "1204.94 922.09 1204.94 1098.73 1357.55 1182.21",
    className: "colorfefeff svgShape"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fb",
    x1: 776.431,
    x2: 1388.402,
    y1: 834.974,
    y2: 834.974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cbd5d6",
    className: "stopColorcbcbd6 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9fafa",
    className: "stopColorf9faf9 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#fb)",
    points: "1388.4 990.38 1357.55 1008.46 776.43 679.57 807.28 661.49"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#c9d2d3",
    points: "1306.85 1543.9 831.72 1284.77 831.72 1255.06 1306.85 1514.19",
    className: "colorc9c9d3 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#c9d2d3",
    points: "1306.85 1600.97 831.72 1341.83 831.72 1312.13 1306.85 1571.26",
    className: "colorc9c9d3 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#c9d2d3",
    points: "1306.85 1658.03 831.72 1398.9 831.72 1369.19 1306.85 1628.33",
    className: "colorc9c9d3 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#c9d2d3",
    points: "1306.85 1715.1 831.72 1455.97 831.72 1426.26 1306.85 1685.39",
    className: "colorc9c9d3 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#929797",
    strokeMiterlimit: 10,
    strokeWidth: 3.213,
    points: "1306.85 1743.19 831.72 1484.05 831.72 1222.94 1306.85 1482.08",
    className: "colorStroke929497 svgStroke"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 872.65,
    x2: 872.65,
    y1: 1244.59,
    y2: 1506.38,
    fill: "none",
    stroke: "#929797",
    strokeMiterlimit: 10,
    strokeWidth: 3.213,
    className: "colorStroke929497 svgStroke"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1121.24,
    x2: 1121.24,
    y1: 1380.17,
    y2: 1641.96,
    fill: "none",
    stroke: "#929797",
    strokeMiterlimit: 10,
    strokeWidth: 3.213,
    className: "colorStroke929497 svgStroke"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c9d2d3",
    d: "M1294.15,1275.23l-457.24-249.38c-2.85-1.56-5.19-5.16-5.19-8.02v0c0-2.85,2.33-3.91,5.19-2.36 l457.24,249.38c2.85,1.56,5.19,5.16,5.19,8.02l0,0C1299.33,1275.72,1297,1276.79,1294.15,1275.23z",
    className: "colorc9c9d3 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#57c8d1",
    d: "M1147.68 1148.48L836.01 978.51c-2.36-1.29-4.29-4.27-4.29-6.63v-1.79c0-2.36 1.93-3.24 4.29-1.95l311.66 169.98c2.36 1.29 4.29 4.27 4.29 6.63v1.79C1151.97 1148.89 1150.04 1149.77 1147.68 1148.48zM1147.68 1368.62l-311.66-169.98c-2.36-1.29-4.29-4.27-4.29-6.63v-1.79c0-2.36 1.93-3.24 4.29-1.95l311.66 169.98c2.36 1.29 4.29 4.27 4.29 6.63v1.79C1151.97 1369.03 1150.04 1369.91 1147.68 1368.62z",
    className: "color579ad1 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c9d2d3",
    d: "M1294.15 1305.61l-457.24-249.38c-2.85-1.56-5.19-5.16-5.19-8.02l0 0c0-2.85 2.33-3.91 5.19-2.36l457.24 249.38c2.85 1.56 5.19 5.16 5.19 8.02v0C1299.33 1306.11 1297 1307.17 1294.15 1305.61zM1294.15 1336l-457.24-249.38c-2.85-1.56-5.19-5.16-5.19-8.02l0 0c0-2.85 2.33-3.91 5.19-2.36l457.24 249.38c2.85 1.56 5.19 5.16 5.19 8.02l0 0C1299.33 1336.49 1297 1337.55 1294.15 1336zM1294.15 1366.38l-457.24-249.38c-2.85-1.56-5.19-5.16-5.19-8.02l0 0c0-2.85 2.33-3.91 5.19-2.36l457.24 249.38c2.85 1.56 5.19 5.16 5.19 8.02l0 0C1299.33 1366.88 1297 1367.94 1294.15 1366.38zM1294.15 1396.77l-457.24-249.38c-2.85-1.56-5.19-5.16-5.19-8.02l0 0c0-2.85 2.33-3.91 5.19-2.36l457.24 249.38c2.85 1.56 5.19 5.16 5.19 8.02l0 0C1299.33 1397.26 1297 1398.32 1294.15 1396.77z",
    className: "colorc9c9d3 svgShape"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fc",
    x1: 1242.203,
    x2: 1419.837,
    y1: 1002.436,
    y2: 1002.436,
    gradientTransform: "translate(-691.029)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#96b9bc",
    className: "stopColor969bbc svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6eeef",
    className: "stopColore6e7ef svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fc)",
    d: "M646.26,768.14l-0.88,309.35c-0.03,11.92-0.62,23.43-1.63,34.6c-0.09,0.98-0.2,1.94-0.3,2.92 c-1.01,10.26-2.44,20.17-4.27,29.75c-0.25,1.31-0.52,2.6-0.78,3.9c-1.89,9.29-4.15,18.24-6.79,26.83c-0.47,1.53-1,3.01-1.49,4.51 c-2.46,7.51-5.24,14.69-8.27,21.61c-0.67,1.54-1.27,3.16-1.97,4.67c-7.53,16.21-16.7,30.61-27.3,43.18 c-1.52,1.8-3.13,3.48-4.71,5.2c-3.96,4.32-8.11,8.39-12.44,12.2c-1.74,1.53-3.44,3.1-5.24,4.55 c-6.05,4.87-12.32,9.42-19.02,13.31l82.55-47.98c6.7-3.89,12.97-8.44,19.02-13.31c1.8-1.45,3.5-3.02,5.24-4.55 c4.33-3.81,8.48-7.88,12.44-12.2c1.58-1.72,3.19-3.4,4.71-5.2c5.14-6.1,10.05-12.5,14.49-19.48c4.36-6.86,8.37-14.14,12.02-21.81 c0.29-0.6,0.51-1.27,0.79-1.88c0.71-1.52,1.3-3.15,1.98-4.7c1.78-4.08,3.63-8.1,5.22-12.38c1.1-2.98,2.03-6.13,3.04-9.21 c0.49-1.51,1.02-2.98,1.49-4.51c0.36-1.17,0.8-2.27,1.14-3.46c1.56-5.33,2.98-10.79,4.25-16.39c0.52-2.28,0.92-4.66,1.4-6.97 c0.26-1.3,0.53-2.59,0.78-3.9c0.32-1.68,0.7-3.29,1-4.99c0.88-5.08,1.65-10.25,2.31-15.52c0.38-3.03,0.65-6.15,0.95-9.24 c0.1-0.98,0.21-1.93,0.3-2.92c0.1-1.07,0.24-2.1,0.33-3.19c0.41-5.01,0.72-10.09,0.94-15.26c0.21-5.01,0.33-10.1,0.35-15.25 c0-0.3,0-0.6,0-0.91l0.88-309.35L646.26,768.14z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fd",
    x1: 691.908,
    x2: 1097.684,
    y1: 362.829,
    y2: 362.829,
    gradientTransform: "translate(-691.029)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#96b9bc",
    className: "stopColor969bbc svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6eeef",
    className: "stopColore6e7ef svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fd)",
    d: "M385.36,327c-5.25,2.13-10.5,3.92-15.74,5.37c-4.6,1.7-9.32,3.13-14,4.65 c-5.03,1.64-10.09,3.25-15.21,4.7c-3.66,1.03-7.37,1.97-11.08,2.9c-5.1,1.28-10.23,2.49-15.41,3.59 c-3.28,0.69-6.59,1.32-9.9,1.94c-11.48,2.13-23.09,3.99-34.98,5.23c-10.79,1.69-21.58,2.52-32.52,2.92 c-9.25,0.58-18.61,0.88-28.06,0.91c-0.6,0-1.21-0.04-1.81-0.04c-11.31,0-22.8-0.46-34.38-1.19c-3.3-0.21-6.63-0.46-9.95-0.73 c-10.73-0.86-21.55-1.96-32.47-3.37c-2.5-0.32-4.96-0.53-7.46-0.89l-11.08-1.41l-27.85-4.03L0.88,395.53l27.85,4.03l11.08,1.41 c1.11,0.15,2.21,0.31,3.31,0.46c1.4,0.19,2.75,0.25,4.15,0.43c10.93,1.42,21.74,2.52,32.47,3.37c1.82,0.14,3.7,0.45,5.52,0.57 c1.5,0.11,2.94,0.06,4.43,0.15c11.58,0.73,23.06,1.2,34.38,1.19c0.49,0,0.99,0.05,1.48,0.05c0.11,0,0.22-0.01,0.33-0.01 c9.45-0.03,18.81-0.33,28.06-0.91c5.72-0.21,11.4-0.54,17.06-1.04c5.16-0.46,10.31-1.07,15.46-1.88 c11.89-1.24,23.5-3.09,34.98-5.23c1.44-0.27,2.94-0.37,4.37-0.65c1.87-0.37,3.66-0.9,5.52-1.28c5.19-1.1,10.32-2.3,15.41-3.59 c3.71-0.94,7.42-1.87,11.08-2.9c5.13-1.45,10.18-3.05,15.21-4.7c2.46-0.8,4.99-1.44,7.42-2.29c2.2-0.77,4.4-1.56,6.58-2.36 c2.93-0.81,5.86-1.72,8.8-2.75c2.32-0.81,4.63-1.68,6.95-2.62l21.3-8.53l82.55-47.98L385.36,327z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fe",
    x1: 1015.132,
    x2: 1419.837,
    y1: 543.302,
    y2: 543.302,
    gradientTransform: "translate(-691.029)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#96b9bc",
    className: "stopColor969bbc svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6eeef",
    className: "stopColore6e7ef svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fe)",
    d: "M689.82,680.61c-22.69-23.03-44.89-46.94-66.71-71.47c-1.71-1.92-3.45-3.78-5.15-5.71 c-20.92-23.69-41.36-48.14-61.4-73.15c-2.1-2.62-4.24-5.18-6.33-7.82c-18.15-22.88-35.77-46.46-53.14-70.36 c-6.97-9.59-13.79-19.34-20.62-29.08c-16.46-23.47-32.82-47.06-48.48-71.41l-21.33-33.14l-82.55,47.98l21.33,33.14 c9.67,15.03,19.49,29.9,29.47,44.6c6.18,9.11,12.71,17.82,19.01,26.8c6.84,9.75,13.66,19.49,20.62,29.08 c3.83,5.27,7.48,10.77,11.35,16c12.21,16.48,24.62,32.72,37.21,48.7c1.51,1.91,3.07,3.75,4.58,5.66 c2.09,2.64,4.23,5.2,6.33,7.82c7.87,9.82,15.72,19.68,23.73,29.3c11.26,13.53,22.66,26.86,34.19,39.99 c1.15,1.31,2.33,2.55,3.48,3.85c1.71,1.94,3.45,3.8,5.17,5.72c8.89,9.99,17.78,19.98,26.82,29.73 c12.3,13.27,24.75,26.31,37.31,39.12c0.86,0.88,1.71,1.74,2.57,2.61l38.99,39.55l82.55-47.97L689.82,680.61z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ff",
    x1: 691.029,
    x2: 1337.285,
    y1: 854.965,
    y2: 854.965,
    gradientTransform: "translate(-691.029)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cbd5d6",
    className: "stopColorcbcbd6 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9fafa",
    className: "stopColorf9faf9 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ff)",
    d: "M324.1,366.44l21.33,33.14c78.01,121.3,166.23,231.97,261.84,329l38.99,39.55l-0.88,309.35 c-0.34,121.16-52.12,205.06-138.76,224.58l-185.28,41.42l-184.29-254.79C50.79,969.35-0.34,826.04,0,704.88l0.88-309.35 l27.85,4.03l11.08,1.41c39.38,5.52,77.58,7.61,114.14,5.31c10.94-0.4,21.73-1.23,32.52-2.92 c35.37-3.68,68.95-11.32,100.59-23.01c5.25-1.45,10.5-3.24,15.75-5.37L324.1,366.44z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fg",
    x1: 724.153,
    x2: 1247.253,
    y1: 869.914,
    y2: 869.914,
    gradientTransform: "translate(-691.029)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1dc1ce",
    className: "stopColor1d7ece svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17838c",
    className: "stopColor17538c svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fg)",
    d: "M556.22,1239.46c-15.93,14.99-35.14,25.3-56.92,30.22l-163.98,36.55l-171.48-237.07 C81.85,955.54,32.89,819.43,33.13,704.88l0.94-271.27l1.64,0.23c8.43,1.17,16.87,2.34,25.3,3.05L60.06,685.9 c-0.23,114.32,48.73,250.66,130.95,364.27l171.48,237.07l163.75-36.54C537.01,1248.36,546.85,1244.61,556.22,1239.46z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fh",
    x1: 827.528,
    x2: 1142.627,
    y1: 1167.559,
    y2: 579.027,
    gradientTransform: "translate(-691.029)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1dc1ce",
    className: "stopColor1d7ece svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce1ed",
    className: "stopColor4ca5ed svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fh)",
    d: "M612.92,781.72l-0.7,295.63c-0.23,71.92-20.15,128.37-55.75,161.87c0,0,0,0.47-0.23,0.23 c-9.37,5.15-19.21,8.9-29.98,11.24l-163.75,36.54l-171.48-237.07C108.79,936.56,59.83,800.22,60.06,685.9L61,436.89 c21.55,2.34,42.64,3.51,63.02,3.51c10.78,0,21.55-0.23,32.09-0.94c12.65-0.47,24.36-1.64,35.61-3.28 c35.84-3.75,71.92-11.94,105.65-24.13c4.45-1.41,9.14-2.81,13.59-4.69l6.56,10.07c78.95,122.99,168.43,235.43,266.12,334.52 L612.92,781.72z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M323.13,697.09c-69.41-41.62-125.68-19.09-125.68,50.32c0,69.41,56.27,159.42,125.68,201.03 c69.41,41.62,125.68,19.09,125.68-50.32C448.81,828.71,392.54,738.71,323.13,697.09z M323.13,927.53 c-57.86-34.69-104.76-109.72-104.76-167.58c0-57.86,46.9-76.64,104.76-41.95s104.76,109.72,104.76,167.58 C427.89,943.44,380.99,962.22,323.13,927.53z",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M273.87,789.75v39.71c0,26.52,21.52,60.79,47.89,76.6l2.73,1.64c26.37,15.81,47.89,7.35,47.89-19.18 v-39.71L273.87,789.75z M329.95,858.83v12.88c0,3.79-3.03,5-6.82,2.73c-3.79-2.27-6.82-7.12-6.82-10.91v-12.88 c-3.49-4.36-5.76-9.52-5.76-13.91c0-6.97,5.61-9.22,12.58-5.04c6.97,4.18,12.58,13.15,12.58,20.12 C335.71,856.23,333.43,858.65,329.95,858.83z",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M364.91,844.34l-7.58-4.54v-35.56c0-18.85-15.35-43.4-34.2-54.71s-34.2-5.16-34.2,13.69v35.56 l-7.58-4.54v-35.56c0-23.04,18.74-30.55,41.78-16.73s41.78,43.79,41.78,66.83V844.34z",
    className: "colorffffff svgShape"
  }))))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fi",
    x1: 1959.011,
    x2: 1666.311,
    y1: 2156.483,
    y2: 1636.129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4299a0",
    className: "stopColora06842 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71d3db",
    className: "stopColordbb871 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fi)",
    d: "M1962.69,1828.62c-0.02-0.68-0.05-1.37-0.09-2.06c-0.04-0.69-0.1-1.38-0.17-2.07 c-0.07-0.69-0.14-1.39-0.23-2.09c-0.09-0.71-0.19-1.42-0.3-2.14c-0.01-0.03-0.01-0.05-0.01-0.08c0-0.01,0-0.01-0.01-0.02 c-0.11-0.68-0.22-1.36-0.35-2.05c-0.14-0.74-0.29-1.48-0.45-2.22c-0.16-0.74-0.33-1.48-0.52-2.23c-0.19-0.75-0.39-1.51-0.59-2.26 c-0.16-0.59-0.34-1.17-0.51-1.76c-0.01-0.05-0.03-0.1-0.04-0.16c-0.03-0.11-0.06-0.22-0.1-0.33c-0.22-0.73-0.46-1.47-0.71-2.2 c-0.24-0.72-0.49-1.45-0.76-2.17c-0.25-0.7-0.51-1.39-0.78-2.09c-0.27-0.69-0.55-1.38-0.83-2.07c-0.22-0.53-0.45-1.06-0.68-1.59 c-0.01-0.03-0.03-0.07-0.04-0.11c-0.05-0.11-0.09-0.22-0.14-0.33c-0.3-0.69-0.62-1.37-0.93-2.06c-0.35-0.75-0.72-1.5-1.09-2.25 c-0.43-0.86-0.87-1.71-1.32-2.56c-0.49-0.91-1-1.81-1.52-2.71c-0.09-0.16-0.17-0.31-0.26-0.47c-0.11-0.19-0.21-0.38-0.32-0.57 c-1-1.71-2.06-3.39-3.16-5.03c-0.87-1.31-1.77-2.59-2.7-3.84c-0.62-0.84-1.25-1.67-1.89-2.49c-0.54-0.69-1.09-1.36-1.64-2.03 c-0.54-0.65-1.09-1.3-1.65-1.93c-0.54-0.62-1.1-1.23-1.66-1.83c-0.1-0.11-0.21-0.22-0.32-0.34c-0.04-0.05-0.09-0.09-0.13-0.14 c-0.43-0.45-0.85-0.91-1.29-1.35c-0.59-0.6-1.19-1.2-1.8-1.78c-0.62-0.59-1.24-1.17-1.87-1.74c-0.63-0.56-1.26-1.11-1.89-1.65 c-0.32-0.27-0.64-0.52-0.96-0.78c-0.07-0.05-0.13-0.11-0.2-0.16c-0.24-0.2-0.49-0.41-0.74-0.6c-0.62-0.49-1.24-0.96-1.86-1.42 c-0.61-0.45-1.23-0.89-1.85-1.32c-0.6-0.41-1.2-0.81-1.81-1.19c-0.6-0.38-1.2-0.75-1.8-1.1c-0.14-0.08-0.28-0.16-0.42-0.24 l-318.49-183.88c-0.46-0.26-0.91-0.52-1.37-0.77c-0.59-0.32-1.18-0.62-1.77-0.91c-0.58-0.29-1.16-0.56-1.74-0.82 c-0.58-0.26-1.15-0.5-1.72-0.73c-0.58-0.23-1.16-0.45-1.73-0.65c-0.11-0.04-0.22-0.07-0.33-0.11c-0.03-0.01-0.07-0.02-0.1-0.03 c-0.43-0.14-0.86-0.29-1.29-0.42c-0.59-0.18-1.19-0.34-1.77-0.49c-0.59-0.15-1.18-0.28-1.76-0.39c-0.63-0.12-1.25-0.23-1.87-0.31 c-0.42-0.05-0.82-0.09-1.23-0.12c-0.07-0.01-0.14-0.01-0.21-0.02c-0.16-0.01-0.32-0.03-0.47-0.05c-0.68-0.05-1.34-0.07-2.01-0.07 c-0.75,0.01-1.49,0.04-2.21,0.1c-0.84,0.08-1.66,0.2-2.46,0.36c-0.02,0.01-0.03,0.01-0.04,0.01c-0.03,0.01-0.05,0.02-0.08,0.02 c-0.98,0.2-1.93,0.46-2.85,0.79c-1.21,0.43-2.36,0.96-3.45,1.59l-105.75,61.45c1.93-1.12,4.05-1.91,6.32-2.38 c0.02,0,0.04-0.01,0.06-0.02c2.26-0.46,4.67-0.58,7.21-0.36c0.06,0,0.13,0.01,0.19,0.02c2.52,0.23,5.17,0.8,7.91,1.73 c0.04,0.01,0.08,0.03,0.13,0.04c2.79,0.96,5.68,2.27,8.64,3.99l318.49,183.88c2.9,1.68,5.74,3.66,8.48,5.88 c0.07,0.05,0.14,0.11,0.21,0.17c2.7,2.21,5.31,4.65,7.8,7.29c0.04,0.05,0.09,0.09,0.14,0.14c5.01,5.36,9.53,11.5,13.33,18.06 c0.09,0.15,0.17,0.31,0.26,0.47c1.84,3.22,3.53,6.52,5,9.89c0.02,0.05,0.04,0.1,0.06,0.15c1.5,3.44,2.79,6.93,3.85,10.43 c0.01,0.05,0.02,0.1,0.04,0.15c1.05,3.51,1.87,7.02,2.43,10.5c0,0.02,0.01,0.04,0.01,0.06c0.56,3.5,0.85,6.96,0.84,10.33 l-0.77,272.35c-0.01,3.31-0.32,6.36-0.87,9.17c-0.02,0.08-0.03,0.16-0.05,0.25c-0.56,2.76-1.37,5.27-2.41,7.52 c-0.02,0.04-0.03,0.08-0.05,0.12c-0.69,1.47-1.62,2.62-2.49,3.85c-1.85,2.61-3.96,4.89-6.55,6.4l105.74-61.45 c2.59-1.51,4.69-3.78,6.55-6.39c0.24-0.33,0.61-0.47,0.84-0.82c0.58-0.91,1.12-1.88,1.61-2.91c0.02-0.04,0.03-0.09,0.05-0.13 c0.01-0.03,0.03-0.07,0.04-0.1c0.33-0.7,0.64-1.43,0.92-2.18c0.27-0.72,0.52-1.47,0.74-2.24c0.21-0.7,0.4-1.43,0.57-2.18 c0.07-0.3,0.12-0.62,0.19-0.93c0.02-0.08,0.03-0.16,0.05-0.25c0.06-0.3,0.13-0.6,0.18-0.91c0.12-0.66,0.22-1.34,0.3-2.03 c0.08-0.67,0.16-1.35,0.21-2.05c0.05-0.66,0.1-1.33,0.12-2.01c0.03-0.68,0.04-1.36,0.05-2.06c0-0.04,0-0.08,0-0.12l0.77-272.35 C1962.72,1829.9,1962.71,1829.26,1962.69,1828.62z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fj",
    x1: 1492.123,
    x2: 1850.131,
    y1: 1972.569,
    y2: 1838.316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4299a0",
    className: "stopColora06842 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71d3db",
    className: "stopColordbb871 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fj)",
    d: "M1814.53,1818.47c23.51,13.57,42.52,46.5,42.45,73.52l-0.77,272.35c-0.08,27.01-19.21,37.92-42.72,24.35 l-318.49-183.88c-23.66-13.66-42.67-46.59-42.59-73.6l0.77-272.35c0.08-27.01,19.21-37.92,42.87-24.26L1814.53,1818.47z"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2f7c82",
    points: "1596.83 1617.77 1559.99 1639.74 1510.29 1615.61 1547.13 1593.65",
    className: "color82512f svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2f7c82",
    points: "1891.54 1777.85 1854.7 1799.81 1805 1775.69 1841.84 1753.73",
    className: "color82512f svgShape"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fk",
    x1: 1782.584,
    x2: 1633.292,
    y1: 1777.894,
    y2: 1294.188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4299a0",
    className: "stopColora06842 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71d3db",
    className: "stopColordbb871 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fk)",
    d: "M1872.9,1780.8l-16.52,11.01l-14.03-266.64c0-76.52-62.73-172.58-139.84-214.15 c-37.65-20.29-72.64-23.89-95.99-9.96c-18.95,11.32-29.4,34.31-29.4,64.7v255.63l-16.52,11.01l-14.03-266.64 c0-41.59,15.73-73.87,44.29-90.92c32.78-19.61,78.76-16.23,126.12,9.29c85.98,46.32,155.91,154.46,155.91,241.04V1780.8z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fl",
    x1: 1530.058,
    x2: 1856.386,
    y1: 1532.525,
    y2: 1532.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4299a0",
    className: "stopColora06842 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71d3db",
    className: "stopColordbb871 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fl)",
    d: "M1856.39,1791.81l-30.55-13.62v-242.02c0-76.52-62.73-172.58-139.84-214.15 c-37.65-20.29-72.64-23.89-95.99-9.96c-18.95,11.32-29.4,34.31-29.4,64.7v255.63l-30.55-13.62v-242.02 c0-41.59,15.73-73.87,44.29-90.92c32.78-19.61,78.76-16.23,126.12,9.29c85.98,46.32,155.91,154.46,155.91,241.04V1791.81z"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1587.48,1846.54v39.71c0,26.52,21.52,60.79,47.89,76.6l2.73,1.64c26.37,15.81,47.89,7.35,47.89-19.18 v-39.71L1587.48,1846.54z M1643.55,1915.62v12.88c0,3.79-3.03,5-6.82,2.73c-3.79-2.27-6.82-7.12-6.82-10.91v-12.88 c-3.49-4.36-5.76-9.52-5.76-13.91c0-6.97,5.61-9.22,12.58-5.04c6.97,4.18,12.58,13.15,12.58,20.12 C1649.31,1913.02,1647.04,1915.44,1643.55,1915.62z",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1678.51,1901.13l-7.58-4.54v-35.56c0-18.85-15.35-43.4-34.2-54.71c-18.85-11.31-34.2-5.16-34.2,13.69 v35.56l-7.58-4.54v-35.56c0-23.04,18.74-30.55,41.78-16.73c23.04,13.82,41.78,43.79,41.78,66.83V1901.13z",
    className: "colorffffff svgShape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudServerDataSecurityLock);
export default __webpack_public_path__ + "static/media/cloud-server-data-security-lock.9bb35c15904c803561f6c3396b9cc456.svg";
export { ForwardRef as ReactComponent };